/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(68);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(2);
	
	__webpack_require__(3);
	
	var _domready = __webpack_require__(4);
	
	var _domready2 = _interopRequireDefault(_domready);
	
	var _gsap = __webpack_require__(5);
	
	var _swup = __webpack_require__(6);
	
	var _swup2 = _interopRequireDefault(_swup);
	
	var _bodyClassPlugin = __webpack_require__(29);
	
	var _bodyClassPlugin2 = _interopRequireDefault(_bodyClassPlugin);
	
	var _gaPlugin = __webpack_require__(31);
	
	var _gaPlugin2 = _interopRequireDefault(_gaPlugin);
	
	var _jsPlugin = __webpack_require__(32);
	
	var _jsPlugin2 = _interopRequireDefault(_jsPlugin);
	
	var _debugPlugin = __webpack_require__(34);
	
	var _debugPlugin2 = _interopRequireDefault(_debugPlugin);
	
	var _globalHeader = __webpack_require__(35);
	
	var _globalHeader2 = _interopRequireDefault(_globalHeader);
	
	var _pageIntroduction = __webpack_require__(38);
	
	var _pageIntroduction2 = _interopRequireDefault(_pageIntroduction);
	
	var _popup = __webpack_require__(39);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _accordions = __webpack_require__(40);
	
	var _accordions2 = _interopRequireDefault(_accordions);
	
	var _whatWeDoSectionFaqs = __webpack_require__(61);
	
	var _whatWeDoSectionFaqs2 = _interopRequireDefault(_whatWeDoSectionFaqs);
	
	var _archive = __webpack_require__(62);
	
	var _archive2 = _interopRequireDefault(_archive);
	
	var _instagramFeed = __webpack_require__(63);
	
	var _instagramFeed2 = _interopRequireDefault(_instagramFeed);
	
	var _siteSwitcher = __webpack_require__(66);
	
	var _siteSwitcher2 = _interopRequireDefault(_siteSwitcher);
	
	var _globalFooter = __webpack_require__(67);
	
	var _globalFooter2 = _interopRequireDefault(_globalFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var touchDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
	
	(0, _domready2.default)(function () {
	
	  function init() {
	    // Initialise PageIntroduction component
	    document.queryAll('[data-component="page-introduction"]').forEach(function (element) {
	      new _pageIntroduction2.default({
	        element: element
	      });
	    });
	
	    // Enable 'touch' class for mobile/tablet devices
	    if (touchDevice) {
	      document.body.classList.add("touch");
	    }
	
	    // Scroll window to top on every page load
	    window.scroll({
	      top: 0,
	      left: 0,
	      behavior: "auto"
	    });
	
	    // Initialise global header component
	    document.queryAll('[data-component="global-header"]').forEach(function (element) {
	      new _globalHeader2.default({
	        element: element
	      });
	    });
	
	    // Initialise archive component
	    document.queryAll('[data-component="archive"]').forEach(function (element) {
	      new _archive2.default({
	        element: element
	      });
	    });
	
	    // Initialise popup component
	    document.queryAll('[data-component="popup"]').forEach(function (element) {
	      new _popup2.default({
	        element: element
	      });
	    });
	
	    // Initialise global footer component
	    document.queryAll('[data-component="global-footer"]').forEach(function (element) {
	      new _globalFooter2.default({
	        element: element
	      });
	    });
	
	    // Initialise InstagramFeed component
	    document.queryAll('[data-component="instagram-feed"]').forEach(function (element) {
	      new _instagramFeed2.default({
	        element: element
	      });
	    });
	
	    // Initialise Accordions component
	    document.queryAll('[data-component="accordions"]').forEach(function (element) {
	      new _accordions2.default({
	        element: element
	      });
	    });
	
	    // Initialise WhatWeDoFAQs accordions component
	    document.queryAll('[data-component="what-we-do-section-faqs"]').forEach(function (element) {
	      new _whatWeDoSectionFaqs2.default({
	        element: element
	      });
	    });
	  }
	
	  var animationOptions = [{
	    from: "(.*)",
	    to: "(.*)",
	    out: function out(next) {
	      var defaultTransitionOut = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      defaultTransitionOut.to("[data-component='default-transition']", {
	        visibility: "visible",
	        opacity: 1
	      });
	      defaultTransitionOut.to("[data-component='default-transition']", {
	        duration: 0.8,
	        opacity: 1
	      });
	      defaultTransitionOut.play();
	    },
	    in: function _in(next) {
	      var defaultTransitionIn = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      defaultTransitionIn.to("[data-component='default-transition']", {
	        duration: 0.8,
	        opacity: 0
	      });
	      defaultTransitionIn.to("[data-component='default-transition']", {
	        visibility: "hidden"
	      });
	      defaultTransitionIn.play();
	    }
	  },
	  // What we do > What we do subpages
	  {
	    from: "/what-we-do/",
	    to: "/what-we-do(.*)",
	    out: function out(next) {
	      var defaultTransitionOut = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      defaultTransitionOut.to("[data-component='default-transition']", {
	        visibility: "visible",
	        opacity: 1
	      });
	      defaultTransitionOut.to("[data-component='default-transition']", {
	        duration: 0.8,
	        opacity: 1
	      });
	      defaultTransitionOut.play();
	    },
	    in: function _in(next) {
	      var defaultTransitionIn = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      defaultTransitionIn.to("[data-component='default-transition']", {
	        duration: 0.8,
	        opacity: 0
	      });
	      defaultTransitionIn.to("[data-component='default-transition']", {
	        visibility: "hidden"
	      });
	      defaultTransitionIn.play();
	    }
	  }, {
	    from: "/",
	    to: "/workshop/",
	    out: function out(next) {
	      var mwTimelineOut = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        backgroundColor: "#F0EEEA"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        opacity: 1,
	        visibility: "visible"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        duration: 1,
	        x: 0,
	        y: 0,
	        ease: "expo.out"
	      });
	      mwTimelineOut.to("[data-component='mw-transition'] svg", { duration: 0.8, opacity: 1 }, "+=0.5");
	      mwTimelineOut.to("[data-component='mw-transition'] #rotate", {
	        rotation: 180,
	        transformOrigin: "50% 31px",
	        ease: "expo.out",
	        duration: 1.5
	      }, "+=0.5");
	      mwTimelineOut.play();
	    },
	    in: function _in(next) {
	      var mwTimelineIn = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        duration: 0.8,
	        opacity: 0
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        visibility: "hidden"
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
	      mwTimelineIn.play();
	    }
	  }, {
	    from: "/what-we-do/",
	    to: "/workshop/",
	    out: function out(next) {
	      var mwTimelineOut = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        backgroundColor: "#F0EEEA"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        opacity: 1,
	        visibility: "visible"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        duration: 1,
	        x: 0,
	        y: 0,
	        ease: "expo.out"
	      });
	      mwTimelineOut.to("[data-component='mw-transition'] svg", { duration: 0.8, opacity: 1 }, "+=0.5");
	      mwTimelineOut.to("[data-component='mw-transition'] #rotate", {
	        rotation: 180,
	        transformOrigin: "50% 31px",
	        ease: "expo.out",
	        duration: 1.5
	      }, "+=0.5");
	      mwTimelineOut.to("[data-component='mw-transition']", { opacity: 0 });
	      mwTimelineOut.play();
	    },
	    in: function _in(next) {
	      var mwTimelineIn = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        duration: 0.8,
	        opacity: 0
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        visibility: "hidden"
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
	      mwTimelineIn.play();
	    }
	  }, {
	    from: "/what-we-do(.*)",
	    to: "/workshop/",
	    out: function out(next) {
	      var mwTimelineOut = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        backgroundColor: "#F0EEEA"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        opacity: 1,
	        visibility: "visible"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        duration: 1,
	        x: 0,
	        y: 0,
	        ease: "expo.out"
	      });
	      mwTimelineOut.to("[data-component='mw-transition'] svg", { duration: 0.8, opacity: 1 }, "+=0.5");
	      mwTimelineOut.to("[data-component='mw-transition'] #rotate", {
	        rotation: 180,
	        transformOrigin: "50% 31px",
	        ease: "expo.out",
	        duration: 1.5
	      }, "+=0.5");
	      mwTimelineOut.play();
	    },
	    in: function _in(next) {
	      var mwTimelineIn = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        duration: 0.8,
	        opacity: 0
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        visibility: "hidden"
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
	      mwTimelineIn.play();
	    }
	  }, {
	    from: "/journal(.*)",
	    to: "/workshop/",
	    out: function out(next) {
	      var mwTimelineOut = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        backgroundColor: "#F0EEEA"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        opacity: 1,
	        visibility: "visible"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        duration: 1,
	        x: 0,
	        y: 0,
	        ease: "expo.out"
	      });
	      mwTimelineOut.to("[data-component='mw-transition'] svg", { duration: 0.8, opacity: 1 }, "+=0.5");
	      mwTimelineOut.to("[data-component='mw-transition'] #rotate", {
	        rotation: 180,
	        transformOrigin: "50% 31px",
	        ease: "expo.out",
	        duration: 1.5
	      }, "+=0.5");
	      mwTimelineOut.play();
	    },
	    in: function _in(next) {
	      var mwTimelineIn = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        duration: 0.8,
	        opacity: 0
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        visibility: "hidden"
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
	      mwTimelineIn.play();
	    }
	  }, {
	    from: "/journal(.*)",
	    to: "/workshop/",
	    out: function out(next) {
	      var mwTimelineOut = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        backgroundColor: "#F0EEEA"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        opacity: 1,
	        visibility: "visible"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        duration: 1,
	        x: 0,
	        y: 0,
	        ease: "expo.out"
	      });
	      mwTimelineOut.to("[data-component='mw-transition'] svg", { duration: 0.8, opacity: 1 }, "+=0.5");
	      mwTimelineOut.to("[data-component='mw-transition'] #rotate", {
	        rotation: 180,
	        transformOrigin: "50% 31px",
	        ease: "expo.out",
	        duration: 1.5
	      }, "+=0.5");
	      mwTimelineOut.play();
	    },
	    in: function _in(next) {
	      var mwTimelineIn = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        duration: 0.8,
	        opacity: 0
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        visibility: "hidden"
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
	      mwTimelineIn.play();
	    }
	  }, {
	    from: "/journal/",
	    to: "/workshop/",
	    out: function out(next) {
	      var mwTimelineOut = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        backgroundColor: "#F0EEEA"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        opacity: 1,
	        visibility: "visible"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        duration: 1,
	        x: 0,
	        y: 0,
	        ease: "expo.out"
	      });
	      mwTimelineOut.to("[data-component='mw-transition'] svg", { duration: 0.8, opacity: 1 }, "+=0.5");
	      mwTimelineOut.to("[data-component='mw-transition'] #rotate", {
	        rotation: 180,
	        transformOrigin: "50% 31px",
	        ease: "expo.out",
	        duration: 1.5
	      }, "+=0.5");
	      mwTimelineOut.play();
	    },
	    in: function _in(next) {
	      var mwTimelineIn = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        duration: 0.8,
	        opacity: 0
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        visibility: "hidden"
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
	      mwTimelineIn.play();
	    }
	  }, {
	    from: "/journal(.*)",
	    to: "/workshop/",
	    out: function out(next) {
	      var mwTimelineOut = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        backgroundColor: "#F0EEEA"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        opacity: 1,
	        visibility: "visible"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        duration: 1,
	        x: 0,
	        y: 0,
	        ease: "expo.out"
	      });
	      mwTimelineOut.to("[data-component='mw-transition'] svg", { duration: 0.8, opacity: 1 }, "+=0.5");
	      mwTimelineOut.to("[data-component='mw-transition'] #rotate", {
	        rotation: 180,
	        transformOrigin: "50% 31px",
	        ease: "expo.out",
	        duration: 1.5
	      }, "+=0.5");
	      mwTimelineOut.play();
	    },
	    in: function _in(next) {
	      var mwTimelineIn = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        duration: 0.8,
	        opacity: 0
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        visibility: "hidden"
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
	      mwTimelineIn.play();
	    }
	  }, {
	    from: "/journal(.*)",
	    to: "/workshop/",
	    out: function out(next) {
	      var mwTimelineOut = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        backgroundColor: "#F0EEEA"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        opacity: 1,
	        visibility: "visible"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        duration: 1,
	        x: 0,
	        y: 0,
	        ease: "expo.out"
	      });
	      mwTimelineOut.to("[data-component='mw-transition'] svg", { duration: 0.8, opacity: 1 }, "+=0.5");
	      mwTimelineOut.to("[data-component='mw-transition'] #rotate", {
	        rotation: 180,
	        transformOrigin: "50% 31px",
	        ease: "expo.out",
	        duration: 1.5
	      }, "+=0.5");
	      mwTimelineOut.play();
	    },
	    in: function _in(next) {
	      var mwTimelineIn = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        duration: 0.8,
	        opacity: 0
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        visibility: "hidden"
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
	      mwTimelineIn.play();
	    }
	  }, {
	    from: "/workshop/",
	    to: "/workshop/faqs-resources/",
	    out: function out(next) {
	      var defaultTransitionOut = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      defaultTransitionOut.to("[data-component='default-transition']", {
	        visibility: "visible",
	        opacity: 1
	      });
	      defaultTransitionOut.to("[data-component='default-transition']", {
	        duration: 0.8,
	        opacity: 1
	      });
	      defaultTransitionOut.play();
	    },
	    in: function _in(next) {
	      var defaultTransitionIn = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      defaultTransitionIn.to("[data-component='default-transition']", {
	        duration: 0.8,
	        opacity: 0
	      });
	      defaultTransitionIn.to("[data-component='default-transition']", {
	        visibility: "hidden"
	      });
	      defaultTransitionIn.play();
	    }
	  }, {
	    from: "/workshop/",
	    to: "/",
	    out: function out(next) {
	      var mwTimelineOut = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        backgroundColor: "#a55444"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        opacity: 1,
	        visibility: "visible"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        duration: 1,
	        x: 0,
	        y: 0,
	        ease: "expo.out"
	      });
	      mwTimelineOut.to("[data-component='mw-transition'] svg", { duration: 0.8, opacity: 1 }, "+=0.5");
	      mwTimelineOut.to("[data-component='mw-transition'] #rotate", {
	        rotation: 0,
	        transformOrigin: "50% 31px",
	        ease: "expo.out",
	        duration: 1.5
	      }, "+=0.5");
	      mwTimelineOut.play();
	    },
	    in: function _in(next) {
	      var mwTimelineIn = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        duration: 0.8,
	        opacity: 0
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        visibility: "hidden"
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
	      mwTimelineIn.play();
	    }
	  }, {
	    from: "/workshop/faqs-resources/",
	    to: "/",
	    out: function out(next) {
	      var mwTimelineOut = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        backgroundColor: "#a55444"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        opacity: 1,
	        visibility: "visible"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        duration: 1,
	        x: 0,
	        y: 0,
	        ease: "expo.out"
	      });
	      mwTimelineOut.to("[data-component='mw-transition'] svg", { duration: 0.8, opacity: 1 }, "+=0.5");
	      mwTimelineOut.to("[data-component='mw-transition'] #rotate", {
	        rotation: 0,
	        transformOrigin: "50% 31px",
	        ease: "expo.out",
	        duration: 1.5
	      }, "+=0.5");
	      mwTimelineOut.play();
	    },
	    in: function _in(next) {
	      var mwTimelineIn = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        duration: 0.8,
	        opacity: 0
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        visibility: "hidden"
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
	      mwTimelineIn.play();
	    }
	  }, {
	    from: "/workshop/book/",
	    to: "/",
	    out: function out(next) {
	      var mwTimelineOut = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        backgroundColor: "#a55444"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        opacity: 1,
	        visibility: "visible"
	      });
	      mwTimelineOut.to("[data-component='mw-transition']", {
	        duration: 1,
	        x: 0,
	        y: 0,
	        ease: "expo.out"
	      });
	      mwTimelineOut.to("[data-component='mw-transition'] svg", { duration: 0.8, opacity: 1 }, "+=0.5");
	      mwTimelineOut.to("[data-component='mw-transition'] #rotate", {
	        rotation: 0,
	        transformOrigin: "50% 31px",
	        ease: "expo.out",
	        duration: 1.5
	      }, "+=0.5");
	      mwTimelineOut.play();
	    },
	    in: function _in(next) {
	      var mwTimelineIn = _gsap.gsap.timeline({
	        repeat: 0,
	        repeatDelay: 0,
	        paused: true,
	        onComplete: next
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        duration: 0.8,
	        opacity: 0
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", {
	        visibility: "hidden"
	      });
	      mwTimelineIn.to("[data-component='mw-transition']", { x: "100%" });
	      mwTimelineIn.play();
	    }
	  }];
	
	  // swupOptions
	  var swupOptions = {
	    plugins: [new _bodyClassPlugin2.default(), new _gaPlugin2.default(),
	    // new SwupDebugPlugin(),
	    new _jsPlugin2.default(animationOptions)]
	
	    // Initialise swup
	  };var swup = new _swup2.default(swupOptions);
	
	  // Initialise global init
	  init();
	
	  // Re-initialise JS on page load
	  swup.on('contentReplaced', init);
	});

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	/*!
	Copyright (C) 2013-2015 by Andrea Giammarchi - @WebReflection
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	
	*/
	(function(window){'use strict';
	  /* jshint loopfunc: true, noempty: false*/
	  // http://www.w3.org/TR/dom/#element
	
	  function createDocumentFragment() {
	    return document.createDocumentFragment();
	  }
	
	  function createElement(nodeName) {
	    return document.createElement(nodeName);
	  }
	
	  function enoughArguments(length, name) {
	    if (!length) throw new Error(
	      'Failed to construct ' +
	        name +
	      ': 1 argument required, but only 0 present.'
	    );
	  }
	
	  function mutationMacro(nodes) {
	    if (nodes.length === 1) {
	      return textNodeIfString(nodes[0]);
	    }
	    for (var
	      fragment = createDocumentFragment(),
	      list = slice.call(nodes),
	      i = 0; i < nodes.length; i++
	    ) {
	      fragment.appendChild(textNodeIfString(list[i]));
	    }
	    return fragment;
	  }
	
	  function textNodeIfString(node) {
	    return typeof node === 'string' ? document.createTextNode(node) : node;
	  }
	
	  for(var
	    head,
	    property,
	    TemporaryPrototype,
	    TemporaryTokenList,
	    wrapVerifyToken,
	    document = window.document,
	    hOP = Object.prototype.hasOwnProperty,
	    defineProperty = Object.defineProperty || function (object, property, descriptor) {
	      if (hOP.call(descriptor, 'value')) {
	        object[property] = descriptor.value;
	      } else {
	        if (hOP.call(descriptor, 'get'))
	          object.__defineGetter__(property, descriptor.get);
	        if (hOP.call(descriptor, 'set'))
	          object.__defineSetter__(property, descriptor.set);
	      }
	      return object;
	    },
	    indexOf = [].indexOf || function indexOf(value){
	      var length = this.length;
	      while(length--) {
	        if (this[length] === value) {
	          break;
	        }
	      }
	      return length;
	    },
	    // http://www.w3.org/TR/domcore/#domtokenlist
	    verifyToken = function (token) {
	      if (!token) {
	        throw 'SyntaxError';
	      } else if (spaces.test(token)) {
	        throw 'InvalidCharacterError';
	      }
	      return token;
	    },
	    DOMTokenList = function (node) {
	      var
	        noClassName = typeof node.className === 'undefined',
	        className = noClassName ?
	          (node.getAttribute('class') || '') : node.className,
	        isSVG = noClassName || typeof className === 'object',
	        value = (isSVG ?
	          (noClassName ? className : className.baseVal) :
	          className
	        ).replace(trim, '')
	      ;
	      if (value.length) {
	        properties.push.apply(
	          this,
	          value.split(spaces)
	        );
	      }
	      this._isSVG = isSVG;
	      this._ = node;
	    },
	    classListDescriptor = {
	      get: function get() {
	        return new DOMTokenList(this);
	      },
	      set: function(){}
	    },
	    uid = 'dom4-tmp-'.concat(Math.random() * +new Date()).replace('.','-'),
	    trim = /^\s+|\s+$/g,
	    spaces = /\s+/,
	    SPACE = '\x20',
	    CLASS_LIST = 'classList',
	    toggle = function toggle(token, force) {
	      if (this.contains(token)) {
	        if (!force) {
	          // force is not true (either false or omitted)
	          this.remove(token);
	        }
	      } else if(force === undefined || force) {
	        force = true;
	        this.add(token);
	      }
	      return !!force;
	    },
	    DocumentFragmentPrototype = window.DocumentFragment && DocumentFragment.prototype,
	    Node = window.Node,
	    NodePrototype = (Node || Element).prototype,
	    CharacterData = window.CharacterData || Node,
	    CharacterDataPrototype = CharacterData && CharacterData.prototype,
	    DocumentType = window.DocumentType,
	    DocumentTypePrototype = DocumentType && DocumentType.prototype,
	    ElementPrototype = (window.Element || Node || window.HTMLElement).prototype,
	    HTMLSelectElement = window.HTMLSelectElement || createElement('select').constructor,
	    selectRemove = HTMLSelectElement.prototype.remove,
	    ShadowRoot = window.ShadowRoot,
	    SVGElement = window.SVGElement,
	    // normalizes multiple ids as CSS query
	    idSpaceFinder = / /g,
	    idSpaceReplacer = '\\ ',
	    createQueryMethod = function (methodName) {
	      var createArray = methodName === 'querySelectorAll';
	      return function (css) {
	        var a, i, id, query, nl, selectors, node = this.parentNode;
	        if (node) {
	          for (
	            id = this.getAttribute('id') || uid,
	            query = id === uid ? id : id.replace(idSpaceFinder, idSpaceReplacer),
	            selectors = css.split(','),
	            i = 0; i < selectors.length; i++
	          ) {
	            selectors[i] = '#' + query + ' ' + selectors[i];
	          }
	          css = selectors.join(',');
	        }
	        if (id === uid) this.setAttribute('id', id);
	        nl = (node || this)[methodName](css);
	        if (id === uid) this.removeAttribute('id');
	        // return a list
	        if (createArray) {
	          i = nl.length;
	          a = new Array(i);
	          while (i--) a[i] = nl[i];
	        }
	        // return node or null
	        else {
	          a = nl;
	        }
	        return a;
	      };
	    },
	    addQueryAndAll = function (where) {
	      if (!('query' in where)) {
	        where.query = ElementPrototype.query;
	      }
	      if (!('queryAll' in where)) {
	        where.queryAll = ElementPrototype.queryAll;
	      }
	    },
	    properties = [
	      'matches', (
	        ElementPrototype.matchesSelector ||
	        ElementPrototype.webkitMatchesSelector ||
	        ElementPrototype.khtmlMatchesSelector ||
	        ElementPrototype.mozMatchesSelector ||
	        ElementPrototype.msMatchesSelector ||
	        ElementPrototype.oMatchesSelector ||
	        function matches(selector) {
	          var parentNode = this.parentNode;
	          return !!parentNode && -1 < indexOf.call(
	            parentNode.querySelectorAll(selector),
	            this
	          );
	        }
	      ),
	      'closest', function closest(selector) {
	        var parentNode = this, matches;
	        while (
	          // document has no .matches
	          (matches = parentNode && parentNode.matches) &&
	          !parentNode.matches(selector)
	        ) {
	          parentNode = parentNode.parentNode;
	        }
	        return matches ? parentNode : null;
	      },
	      'prepend', function prepend() {
	        var firstChild = this.firstChild,
	            node = mutationMacro(arguments);
	        if (firstChild) {
	          this.insertBefore(node, firstChild);
	        } else {
	          this.appendChild(node);
	        }
	      },
	      'append', function append() {
	        this.appendChild(mutationMacro(arguments));
	      },
	      'before', function before() {
	        var parentNode = this.parentNode;
	        if (parentNode) {
	          parentNode.insertBefore(
	            mutationMacro(arguments), this
	          );
	        }
	      },
	      'after', function after() {
	        var parentNode = this.parentNode,
	            nextSibling = this.nextSibling,
	            node = mutationMacro(arguments);
	        if (parentNode) {
	          if (nextSibling) {
	            parentNode.insertBefore(node, nextSibling);
	          } else {
	            parentNode.appendChild(node);
	          }
	        }
	      },
	      // WARNING - DEPRECATED - use .replaceWith() instead
	      'replace', function replace() {
	        this.replaceWith.apply(this, arguments);
	      },
	      'replaceWith', function replaceWith() {
	        var parentNode = this.parentNode;
	        if (parentNode) {
	          parentNode.replaceChild(
	            mutationMacro(arguments),
	            this
	          );
	        }
	      },
	      'remove', function remove() {
	        var parentNode = this.parentNode;
	        if (parentNode) {
	          parentNode.removeChild(this);
	        }
	      },
	      'query', createQueryMethod('querySelector'),
	      'queryAll', createQueryMethod('querySelectorAll')
	    ],
	    slice = properties.slice,
	    i = properties.length; i; i -= 2
	  ) {
	    property = properties[i - 2];
	    if (!(property in ElementPrototype)) {
	      ElementPrototype[property] = properties[i - 1];
	    }
	    if (property === 'remove') {
	      // see https://github.com/WebReflection/dom4/issues/19
	      HTMLSelectElement.prototype[property] = function () {
	        return 0 < arguments.length ?
	          selectRemove.apply(this, arguments) :
	          ElementPrototype.remove.call(this);
	      };
	    }
	    // see https://github.com/WebReflection/dom4/issues/18
	    if (/^(?:before|after|replace|replaceWith|remove)$/.test(property)) {
	      if (CharacterData && !(property in CharacterDataPrototype)) {
	        CharacterDataPrototype[property] = properties[i - 1];
	      }
	      if (DocumentType && !(property in DocumentTypePrototype)) {
	        DocumentTypePrototype[property] = properties[i - 1];
	      }
	    }
	    // see https://github.com/WebReflection/dom4/pull/26
	    if (/^(?:append|prepend)$/.test(property)) {
	      if (DocumentFragmentPrototype) {
	        if (!(property in DocumentFragmentPrototype)) {
	          DocumentFragmentPrototype[property] = properties[i - 1];
	        }
	      } else {
	        try {
	          createDocumentFragment().constructor.prototype[property] = properties[i - 1];
	        } catch(o_O) {}
	      }
	    }
	  }
	
	  // bring query and queryAll to the document too
	  addQueryAndAll(document);
	
	  // brings query and queryAll to fragments as well
	  if (DocumentFragmentPrototype) {
	    addQueryAndAll(DocumentFragmentPrototype);
	  } else {
	    try {
	      addQueryAndAll(createDocumentFragment().constructor.prototype);
	    } catch(o_O) {}
	  }
	
	  // bring query and queryAll to the ShadowRoot too
	  if (ShadowRoot) {
	    addQueryAndAll(ShadowRoot.prototype);
	  }
	
	  // most likely an IE9 only issue
	  // see https://github.com/WebReflection/dom4/issues/6
	  if (!createElement('a').matches('a')) {
	    ElementPrototype[property] = function(matches){
	      return function (selector) {
	        return matches.call(
	          this.parentNode ?
	            this :
	            createDocumentFragment().appendChild(this),
	          selector
	        );
	      };
	    }(ElementPrototype[property]);
	  }
	
	  // used to fix both old webkit and SVG
	  DOMTokenList.prototype = {
	    length: 0,
	    add: function add() {
	      for(var j = 0, token; j < arguments.length; j++) {
	        token = arguments[j];
	        if(!this.contains(token)) {
	          properties.push.call(this, property);
	        }
	      }
	      if (this._isSVG) {
	        this._.setAttribute('class', '' + this);
	      } else {
	        this._.className = '' + this;
	      }
	    },
	    contains: (function(indexOf){
	      return function contains(token) {
	        i = indexOf.call(this, property = verifyToken(token));
	        return -1 < i;
	      };
	    }([].indexOf || function (token) {
	      i = this.length;
	      while(i-- && this[i] !== token){}
	      return i;
	    })),
	    item: function item(i) {
	      return this[i] || null;
	    },
	    remove: function remove() {
	      for(var j = 0, token; j < arguments.length; j++) {
	        token = arguments[j];
	        if(this.contains(token)) {
	          properties.splice.call(this, i, 1);
	        }
	      }
	      if (this._isSVG) {
	        this._.setAttribute('class', '' + this);
	      } else {
	        this._.className = '' + this;
	      }
	    },
	    toggle: toggle,
	    toString: function toString() {
	      return properties.join.call(this, SPACE);
	    }
	  };
	
	  if (SVGElement && !(CLASS_LIST in SVGElement.prototype)) {
	    defineProperty(SVGElement.prototype, CLASS_LIST, classListDescriptor);
	  }
	
	  // http://www.w3.org/TR/dom/#domtokenlist
	  // iOS 5.1 has completely screwed this property
	  // classList in ElementPrototype is false
	  // but it's actually there as getter
	  if (!(CLASS_LIST in document.documentElement)) {
	    defineProperty(ElementPrototype, CLASS_LIST, classListDescriptor);
	  } else {
	    // iOS 5.1 and Nokia ASHA do not support multiple add or remove
	    // trying to detect and fix that in here
	    TemporaryTokenList = createElement('div')[CLASS_LIST];
	    TemporaryTokenList.add('a', 'b', 'a');
	    if ('a\x20b' != TemporaryTokenList) {
	      // no other way to reach original methods in iOS 5.1
	      TemporaryPrototype = TemporaryTokenList.constructor.prototype;
	      if (!('add' in TemporaryPrototype)) {
	        // ASHA double fails in here
	        TemporaryPrototype = window.TemporaryTokenList.prototype;
	      }
	      wrapVerifyToken = function (original) {
	        return function () {
	          var i = 0;
	          while (i < arguments.length) {
	            original.call(this, arguments[i++]);
	          }
	        };
	      };
	      TemporaryPrototype.add = wrapVerifyToken(TemporaryPrototype.add);
	      TemporaryPrototype.remove = wrapVerifyToken(TemporaryPrototype.remove);
	      // toggle is broken too ^_^ ... let's fix it
	      TemporaryPrototype.toggle = toggle;
	    }
	  }
	
	  if (!('contains' in NodePrototype)) {
	    defineProperty(NodePrototype, 'contains', {
	      value: function (el) {
	        while (el && el !== this) el = el.parentNode;
	        return this === el;
	      }
	    });
	  }
	
	  if (!('head' in document)) {
	    defineProperty(document, 'head', {
	      get: function () {
	        return head || (
	          head = document.getElementsByTagName('head')[0]
	        );
	      }
	    });
	  }
	
	  // requestAnimationFrame partial polyfill
	  (function () {
	    for (var
	      raf,
	      rAF = window.requestAnimationFrame,
	      cAF = window.cancelAnimationFrame,
	      prefixes = ['o', 'ms', 'moz', 'webkit'],
	      i = prefixes.length;
	      !cAF && i--;
	    ) {
	      rAF = rAF || window[prefixes[i] + 'RequestAnimationFrame'];
	      cAF = window[prefixes[i] + 'CancelAnimationFrame'] ||
	            window[prefixes[i] + 'CancelRequestAnimationFrame'];
	    }
	    if (!cAF) {
	      // some FF apparently implemented rAF but no cAF 
	      if (rAF) {
	        raf = rAF;
	        rAF = function (callback) {
	          var goOn = true;
	          raf(function () {
	            if (goOn) callback.apply(this, arguments);
	          });
	          return function () {
	            goOn = false;
	          };
	        };
	        cAF = function (id) {
	          id();
	        };
	      } else {
	        rAF = function (callback) {
	          return setTimeout(callback, 15, 15);
	        };
	        cAF = function (id) {
	          clearTimeout(id);
	        };
	      }
	    }
	    window.requestAnimationFrame = rAF;
	    window.cancelAnimationFrame = cAF;
	  }());
	
	  // http://www.w3.org/TR/dom/#customevent
	  try{new window.CustomEvent('?');}catch(o_O){
	    window.CustomEvent = function(
	      eventName,
	      defaultInitDict
	    ){
	
	      // the infamous substitute
	      function CustomEvent(type, eventInitDict) {
	        /*jshint eqnull:true */
	        var event = document.createEvent(eventName);
	        if (typeof type != 'string') {
	          throw new Error('An event name must be provided');
	        }
	        if (eventName == 'Event') {
	          event.initCustomEvent = initCustomEvent;
	        }
	        if (eventInitDict == null) {
	          eventInitDict = defaultInitDict;
	        }
	        event.initCustomEvent(
	          type,
	          eventInitDict.bubbles,
	          eventInitDict.cancelable,
	          eventInitDict.detail
	        );
	        return event;
	      }
	
	      // attached at runtime
	      function initCustomEvent(
	        type, bubbles, cancelable, detail
	      ) {
	        /*jshint validthis:true*/
	        this.initEvent(type, bubbles, cancelable);
	        this.detail = detail;
	      }
	
	      // that's it
	      return CustomEvent;
	    }(
	      // is this IE9 or IE10 ?
	      // where CustomEvent is there
	      // but not usable as construtor ?
	      window.CustomEvent ?
	        // use the CustomEvent interface in such case
	        'CustomEvent' : 'Event',
	        // otherwise the common compatible one
	      {
	        bubbles: false,
	        cancelable: false,
	        detail: null
	      }
	    );
	  }
	
	  // window.Event as constructor
	  try { new Event('_'); } catch (o_O) {
	    /* jshint -W022 */
	    o_O = (function ($Event) {
	      function Event(type, init) {
	        enoughArguments(arguments.length, 'Event');
	        var out = document.createEvent('Event');
	        if (!init) init = {};
	        out.initEvent(
	          type,
	          !!init.bubbles,
	          !!init.cancelable
	        );
	        return out;
	      }
	      Event.prototype = $Event.prototype;
	      return Event;
	    }(window.Event || function Event() {}));
	    defineProperty(window, 'Event', {value: o_O});
	    // Android 4 gotcha
	    if (Event !== o_O) Event = o_O;
	  }
	
	  // window.KeyboardEvent as constructor
	  try { new KeyboardEvent('_', {}); } catch (o_O) {
	    /* jshint -W022 */
	    o_O = (function ($KeyboardEvent) {
	      // code inspired by https://gist.github.com/termi/4654819
	      var
	        initType = 0,
	        defaults = {
	          char: '',
	          key: '',
	          location: 0,
	          ctrlKey: false,
	          shiftKey: false,
	          altKey: false,
	          metaKey: false,
	          altGraphKey: false,
	          repeat: false,
	          locale: navigator.language,
	          detail: 0,
	          bubbles: false,
	          cancelable: false,
	          keyCode: 0,
	          charCode: 0,
	          which: 0
	        },
	        eventType
	      ;
	      try {
	        var e = document.createEvent('KeyboardEvent');
	        e.initKeyboardEvent(
	          'keyup', false, false, window, '+', 3,
	          true, false, true, false, false
	        );
	        initType = (
	          (e.keyIdentifier || e.key) == '+' &&
	          (e.keyLocation || e.location) == 3
	        ) && (
	          e.ctrlKey ? e.altKey ? 1 : 3 : e.shiftKey ? 2 : 4
	        ) || 9;
	      } catch(o_O) {}
	      eventType = 0 < initType ? 'KeyboardEvent' : 'Event';
	
	      function getModifier(init) {
	        for (var
	          out = [],
	          keys = [
	            'ctrlKey',
	            'Control',
	            'shiftKey',
	            'Shift',
	            'altKey',
	            'Alt',
	            'metaKey',
	            'Meta',
	            'altGraphKey',
	            'AltGraph'
	          ],
	          i = 0; i < keys.length; i += 2
	        ) {
	          if (init[keys[i]])
	            out.push(keys[i + 1]);
	        }
	        return out.join(' ');
	      }
	
	      function withDefaults(target, source) {
	        for (var key in source) {
	          if (
	            source.hasOwnProperty(key) &&
	            !source.hasOwnProperty.call(target, key)
	          ) target[key] = source[key];
	        }
	        return target;
	      }
	
	      function withInitValues(key, out, init) {
	        try {
	          out[key] = init[key];
	        } catch(o_O) {}
	      }
	
	      function KeyboardEvent(type, init) {
	        enoughArguments(arguments.length, 'KeyboardEvent');
	        init = withDefaults(init || {}, defaults);
	        var
	          out = document.createEvent(eventType),
	          ctrlKey = init.ctrlKey,
	          shiftKey = init.shiftKey,
	          altKey = init.altKey,
	          metaKey = init.metaKey,
	          altGraphKey = init.altGraphKey,
	          modifiers = initType > 3 ? getModifier(init) : null,
	          key = String(init.key),
	          chr = String(init.char),
	          location = init.location,
	          keyCode = init.keyCode || (
	            (init.keyCode = key) &&
	            key.charCodeAt(0)
	          ) || 0,
	          charCode = init.charCode || (
	            (init.charCode = chr) &&
	            chr.charCodeAt(0)
	          ) || 0,
	          bubbles = init.bubbles,
	          cancelable = init.cancelable,
	          repeat = init.repeat,
	          locale = init.locale,
	          view = init.view || window,
	          args
	        ;
	        if (!init.which) init.which = init.keyCode;
	        if ('initKeyEvent' in out) {
	          out.initKeyEvent(
	            type, bubbles, cancelable, view,
	            ctrlKey, altKey, shiftKey, metaKey, keyCode, charCode
	          );
	        } else if (0 < initType && 'initKeyboardEvent' in out) {
	          args = [type, bubbles, cancelable, view];
	          switch (initType) {
	            case 1:
	              args.push(key, location, ctrlKey, shiftKey, altKey, metaKey, altGraphKey);
	              break;
	            case 2:
	              args.push(ctrlKey, altKey, shiftKey, metaKey, keyCode, charCode);
	              break;
	            case 3:
	              args.push(key, location, ctrlKey, altKey, shiftKey, metaKey, altGraphKey);
	              break;
	            case 4:
	              args.push(key, location, modifiers, repeat, locale);
	              break;
	            default:
	              args.push(char, key, location, modifiers, repeat, locale);
	          }
	          out.initKeyboardEvent.apply(out, args);
	        } else {
	          out.initEvent(type, bubbles, cancelable);
	        }
	        for (key in out) {
	          if (defaults.hasOwnProperty(key) && out[key] !== init[key]) {
	            withInitValues(key, out, init);
	          }
	        }
	        return out;
	      }
	      KeyboardEvent.prototype = $KeyboardEvent.prototype;
	      return KeyboardEvent;
	    }(window.KeyboardEvent || function KeyboardEvent() {}));
	    defineProperty(window, 'KeyboardEvent', {value: o_O});
	    // Android 4 gotcha
	    if (KeyboardEvent !== o_O) KeyboardEvent = o_O;
	  }
	
	  // window.MouseEvent as constructor
	  try { new MouseEvent('_', {}); } catch (o_O) {
	    /* jshint -W022 */
	    o_O = (function ($MouseEvent) {
	      function MouseEvent(type, init) {
	        enoughArguments(arguments.length, 'MouseEvent');
	        var out = document.createEvent('MouseEvent');
	        if (!init) init = {};
	        out.initMouseEvent(
	          type,
	          !!init.bubbles,
	          !!init.cancelable,
	          init.view || window,
	          init.detail || 1,
	          init.screenX || 0,
	          init.screenY || 0,
	          init.clientX || 0,
	          init.clientY || 0,
	          !!init.ctrlKey,
	          !!init.altKey,
	          !!init.shiftKey,
	          !!init.metaKey,
	          init.button || 0,
	          init.relatedTarget || null
	        );
	        return out;
	      }
	      MouseEvent.prototype = $MouseEvent.prototype;
	      return MouseEvent;
	    }(window.MouseEvent || function MouseEvent() {}));
	    defineProperty(window, 'MouseEvent', {value: o_O});
	    // Android 4 gotcha
	    if (MouseEvent !== o_O) MouseEvent = o_O;
	  }
	
	}(window));(function (global){'use strict';
	
	  // a WeakMap fallback for DOM nodes only used as key
	  var DOMMap = global.WeakMap || (function () {
	
	    var
	      counter = 0,
	      dispatched = false,
	      drop = false,
	      value
	    ;
	
	    function dispatch(key, ce, shouldDrop) {
	      drop = shouldDrop;
	      dispatched = false;
	      value = undefined;
	      key.dispatchEvent(ce);
	    }
	
	    function Handler(value) {
	      this.value = value;
	    }
	
	    Handler.prototype.handleEvent = function handleEvent(e) {
	      dispatched = true;
	      if (drop) {
	        e.currentTarget.removeEventListener(e.type, this, false);
	      } else {
	        value = this.value;
	      }
	    };
	
	    function DOMMap() {
	      counter++;  // make id clashing highly improbable
	      this.__ce__ = new Event(('@DOMMap:' + counter) + Math.random());
	    }
	
	    DOMMap.prototype = {
	      'constructor': DOMMap,
	      'delete': function del(key) {
	        return dispatch(key, this.__ce__, true), dispatched;
	      },
	      'get': function get(key) {
	        dispatch(key, this.__ce__, false);
	        var v = value;
	        value = undefined;
	        return v;
	      },
	      'has': function has(key) {
	        return dispatch(key, this.__ce__, false), dispatched;
	      },
	      'set': function set(key, value) {
	        dispatch(key, this.__ce__, true);
	        key.addEventListener(this.__ce__.type, new Handler(value), false);
	        return this;
	      },
	    };
	
	    return DOMMap;
	
	  }());
	
	  function Dict() {}
	  Dict.prototype = (Object.create || Object)(null);
	
	  // https://dom.spec.whatwg.org/#interface-eventtarget
	
	  function createEventListener(type, callback, options) {
	    function eventListener(e) {
	      if (eventListener.once) {
	        e.currentTarget.removeEventListener(
	          e.type,
	          callback,
	          eventListener
	        );
	        eventListener.removed = true;
	      }
	      if (eventListener.passive) {
	        e.preventDefault = createEventListener.preventDefault;
	      }
	      if (typeof eventListener.callback === 'function') {
	        /* jshint validthis: true */
	        eventListener.callback.call(this, e);
	      } else if (eventListener.callback) {
	        eventListener.callback.handleEvent(e);
	      }
	      if (eventListener.passive) {
	        delete e.preventDefault;
	      }
	    }
	    eventListener.type = type;
	    eventListener.callback = callback;
	    eventListener.capture = !!options.capture;
	    eventListener.passive = !!options.passive;
	    eventListener.once = !!options.once;
	    // currently pointless but specs say to use it, so ...
	    eventListener.removed = false;
	    return eventListener;
	  }
	
	  createEventListener.preventDefault = function preventDefault() {};
	
	  var
	    Event = global.CustomEvent,
	    hOP = Object.prototype.hasOwnProperty,
	    dE = global.dispatchEvent,
	    aEL = global.addEventListener,
	    rEL = global.removeEventListener,
	    counter = 0,
	    increment = function () { counter++; },
	    indexOf = [].indexOf || function indexOf(value){
	      var length = this.length;
	      while(length--) {
	        if (this[length] === value) {
	          break;
	        }
	      }
	      return length;
	    },
	    getListenerKey = function (options) {
	      return ''.concat(
	        options.capture ? '1' : '0',
	        options.passive ? '1' : '0',
	        options.once ? '1' : '0'
	      );
	    },
	    augment, proto
	  ;
	
	  try {
	    aEL('_', increment, {once: true});
	    dE(new Event('_'));
	    dE(new Event('_'));
	    rEL('_', increment, {once: true});
	  } catch(o_O) {}
	
	  if (counter !== 1) {
	    (function () {
	      var dm = new DOMMap();
	      function createAEL(aEL) {
	        return function addEventListener(type, handler, options) {
	          if (options && typeof options !== 'boolean') {
	            var
	              info = dm.get(this),
	              key = getListenerKey(options),
	              i, tmp, wrap
	            ;
	            if (!info) dm.set(this, (info = new Dict()));
	            if (!(type in info)) info[type] = {
	              handler: [],
	              wrap: []
	            };
	            tmp = info[type];
	            i = indexOf.call(tmp.handler, handler);
	            if (i < 0) {
	              i = tmp.handler.push(handler) - 1;
	              tmp.wrap[i] = (wrap = new Dict());
	            } else {
	              wrap = tmp.wrap[i];
	            }
	            if (!(key in wrap)) {
	              wrap[key] = createEventListener(type, handler, options);
	              aEL.call(this, type, wrap[key], wrap[key].capture);
	            }
	          } else {
	            aEL.call(this, type, handler, options);
	          }
	        };
	      }
	      function createREL(rEL) {
	        return function removeEventListener(type, handler, options) {
	          if (options && typeof options !== 'boolean') {
	            var
	              info = dm.get(this),
	              key, i, tmp, wrap
	            ;
	            if (info && (type in info)) {
	              tmp = info[type];
	              i = indexOf.call(tmp.handler, handler);
	              if (-1 < i) {
	                key = getListenerKey(options);
	                wrap = tmp.wrap[i];
	                if (key in wrap) {
	                  rEL.call(this, type, wrap[key], wrap[key].capture);
	                  delete wrap[key];
	                  // return if there are other wraps
	                  for (key in wrap) return;
	                  // otherwise remove all the things
	                  tmp.handler.splice(i, 1);
	                  tmp.wrap.splice(i, 1);
	                  // if there are no other handlers
	                  if (tmp.handler.length === 0)
	                    // drop the info[type] entirely
	                    delete info[type];
	                }
	              }
	            }
	          } else {
	            rEL.call(this, type, handler, options);
	          }
	        };
	      }
	
	      augment = function (Constructor) {
	        if (!Constructor) return;
	        var proto = Constructor.prototype;
	        proto.addEventListener = createAEL(proto.addEventListener);
	        proto.removeEventListener = createREL(proto.removeEventListener);
	      };
	
	      if (global.EventTarget) {
	        augment(EventTarget);
	      } else {
	        augment(global.Text);
	        augment(global.Element || global.HTMLElement);
	        augment(global.HTMLDocument);
	        augment(global.Window || {prototype:global});
	        augment(global.XMLHttpRequest);
	      }
	
	    }());
	  }
	
	}(self));

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/*!
	 * @copyright Copyright (c) 2017 IcoMoon.io
	 * @license   Licensed under MIT license
	 *            See https://github.com/Keyamoon/svgxuse
	 * @version   1.2.6
	 */
	/*jslint browser: true */
	/*global XDomainRequest, MutationObserver, window */
	(function () {
	    "use strict";
	    if (typeof window !== "undefined" && window.addEventListener) {
	        var cache = Object.create(null); // holds xhr objects to prevent multiple requests
	        var checkUseElems;
	        var tid; // timeout id
	        var debouncedCheck = function () {
	            clearTimeout(tid);
	            tid = setTimeout(checkUseElems, 100);
	        };
	        var unobserveChanges = function () {
	            return;
	        };
	        var observeChanges = function () {
	            var observer;
	            window.addEventListener("resize", debouncedCheck, false);
	            window.addEventListener("orientationchange", debouncedCheck, false);
	            if (window.MutationObserver) {
	                observer = new MutationObserver(debouncedCheck);
	                observer.observe(document.documentElement, {
	                    childList: true,
	                    subtree: true,
	                    attributes: true
	                });
	                unobserveChanges = function () {
	                    try {
	                        observer.disconnect();
	                        window.removeEventListener("resize", debouncedCheck, false);
	                        window.removeEventListener("orientationchange", debouncedCheck, false);
	                    } catch (ignore) {}
	                };
	            } else {
	                document.documentElement.addEventListener("DOMSubtreeModified", debouncedCheck, false);
	                unobserveChanges = function () {
	                    document.documentElement.removeEventListener("DOMSubtreeModified", debouncedCheck, false);
	                    window.removeEventListener("resize", debouncedCheck, false);
	                    window.removeEventListener("orientationchange", debouncedCheck, false);
	                };
	            }
	        };
	        var createRequest = function (url) {
	            // In IE 9, cross origin requests can only be sent using XDomainRequest.
	            // XDomainRequest would fail if CORS headers are not set.
	            // Therefore, XDomainRequest should only be used with cross origin requests.
	            function getOrigin(loc) {
	                var a;
	                if (loc.protocol !== undefined) {
	                    a = loc;
	                } else {
	                    a = document.createElement("a");
	                    a.href = loc;
	                }
	                return a.protocol.replace(/:/g, "") + a.host;
	            }
	            var Request;
	            var origin;
	            var origin2;
	            if (window.XMLHttpRequest) {
	                Request = new XMLHttpRequest();
	                origin = getOrigin(location);
	                origin2 = getOrigin(url);
	                if (Request.withCredentials === undefined && origin2 !== "" && origin2 !== origin) {
	                    Request = XDomainRequest || undefined;
	                } else {
	                    Request = XMLHttpRequest;
	                }
	            }
	            return Request;
	        };
	        var xlinkNS = "http://www.w3.org/1999/xlink";
	        checkUseElems = function () {
	            var base;
	            var bcr;
	            var fallback = ""; // optional fallback URL in case no base path to SVG file was given and no symbol definition was found.
	            var hash;
	            var href;
	            var i;
	            var inProgressCount = 0;
	            var isHidden;
	            var Request;
	            var url;
	            var uses;
	            var xhr;
	            function observeIfDone() {
	                // If done with making changes, start watching for chagnes in DOM again
	                inProgressCount -= 1;
	                if (inProgressCount === 0) { // if all xhrs were resolved
	                    unobserveChanges(); // make sure to remove old handlers
	                    observeChanges(); // watch for changes to DOM
	                }
	            }
	            function attrUpdateFunc(spec) {
	                return function () {
	                    if (cache[spec.base] !== true) {
	                        spec.useEl.setAttributeNS(xlinkNS, "xlink:href", "#" + spec.hash);
	                        if (spec.useEl.hasAttribute("href")) {
	                            spec.useEl.setAttribute("href", "#" + spec.hash);
	                        }
	                    }
	                };
	            }
	            function onloadFunc(xhr) {
	                return function () {
	                    var body = document.body;
	                    var x = document.createElement("x");
	                    var svg;
	                    xhr.onload = null;
	                    x.innerHTML = xhr.responseText;
	                    svg = x.getElementsByTagName("svg")[0];
	                    if (svg) {
	                        svg.setAttribute("aria-hidden", "true");
	                        svg.style.position = "absolute";
	                        svg.style.width = 0;
	                        svg.style.height = 0;
	                        svg.style.overflow = "hidden";
	                        body.insertBefore(svg, body.firstChild);
	                    }
	                    observeIfDone();
	                };
	            }
	            function onErrorTimeout(xhr) {
	                return function () {
	                    xhr.onerror = null;
	                    xhr.ontimeout = null;
	                    observeIfDone();
	                };
	            }
	            unobserveChanges(); // stop watching for changes to DOM
	            // find all use elements
	            uses = document.getElementsByTagName("use");
	            for (i = 0; i < uses.length; i += 1) {
	                try {
	                    bcr = uses[i].getBoundingClientRect();
	                } catch (ignore) {
	                    // failed to get bounding rectangle of the use element
	                    bcr = false;
	                }
	                href = uses[i].getAttribute("href")
	                        || uses[i].getAttributeNS(xlinkNS, "href")
	                        || uses[i].getAttribute("xlink:href");
	                if (href && href.split) {
	                    url = href.split("#");
	                } else {
	                    url = ["", ""];
	                }
	                base = url[0];
	                hash = url[1];
	                isHidden = bcr && bcr.left === 0 && bcr.right === 0 && bcr.top === 0 && bcr.bottom === 0;
	                if (bcr && bcr.width === 0 && bcr.height === 0 && !isHidden) {
	                    // the use element is empty
	                    // if there is a reference to an external SVG, try to fetch it
	                    // use the optional fallback URL if there is no reference to an external SVG
	                    if (fallback && !base.length && hash && !document.getElementById(hash)) {
	                        base = fallback;
	                    }
	                    if (uses[i].hasAttribute("href")) {
	                        uses[i].setAttributeNS(xlinkNS, "xlink:href", href);
	                    }
	                    if (base.length) {
	                        // schedule updating xlink:href
	                        xhr = cache[base];
	                        if (xhr !== true) {
	                            // true signifies that prepending the SVG was not required
	                            setTimeout(attrUpdateFunc({
	                                useEl: uses[i],
	                                base: base,
	                                hash: hash
	                            }), 0);
	                        }
	                        if (xhr === undefined) {
	                            Request = createRequest(base);
	                            if (Request !== undefined) {
	                                xhr = new Request();
	                                cache[base] = xhr;
	                                xhr.onload = onloadFunc(xhr);
	                                xhr.onerror = onErrorTimeout(xhr);
	                                xhr.ontimeout = onErrorTimeout(xhr);
	                                xhr.open("GET", base);
	                                xhr.send();
	                                inProgressCount += 1;
	                            }
	                        }
	                    }
	                } else {
	                    if (!isHidden) {
	                        if (cache[base] === undefined) {
	                            // remember this URL if the use element was not empty and no request was sent
	                            cache[base] = true;
	                        } else if (cache[base].onload) {
	                            // if it turns out that prepending the SVG is not necessary,
	                            // abort the in-progress xhr.
	                            cache[base].abort();
	                            delete cache[base].onload;
	                            cache[base] = true;
	                        }
	                    } else if (base.length && cache[base]) {
	                        setTimeout(attrUpdateFunc({
	                            useEl: uses[i],
	                            base: base,
	                            hash: hash
	                        }), 0);
	                    }
	                }
	            }
	            uses = "";
	            inProgressCount += 1;
	            observeIfDone();
	        };
	        var winLoad;
	        winLoad = function () {
	            window.removeEventListener("load", winLoad, false); // to prevent memory leaks
	            tid = setTimeout(checkUseElems, 0);
	        };
	        if (document.readyState !== "complete") {
	            // The load event fires when all resources have finished loading, which allows detecting whether SVG use elements are empty.
	            window.addEventListener("load", winLoad, false);
	        } else {
	            // No need to add a listener if the document is already loaded, initialize immediately.
	            winLoad();
	        }
	    }
	}());


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	  * domready (c) Dustin Diaz 2014 - License MIT
	  */
	!function (name, definition) {
	
	  if (true) module.exports = definition()
	  else if (typeof define == 'function' && typeof define.amd == 'object') define(definition)
	  else this[name] = definition()
	
	}('domready', function () {
	
	  var fns = [], listener
	    , doc = document
	    , hack = doc.documentElement.doScroll
	    , domContentLoaded = 'DOMContentLoaded'
	    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState)
	
	
	  if (!loaded)
	  doc.addEventListener(domContentLoaded, listener = function () {
	    doc.removeEventListener(domContentLoaded, listener)
	    loaded = 1
	    while (listener = fns.shift()) listener()
	  })
	
	  return function (fn) {
	    loaded ? setTimeout(fn, 0) : fns.push(fn)
	  }
	
	});


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (global = global || self, factory(global.window = global.window || {}));
	}(this, (function (exports) { 'use strict';
	
	  function _inheritsLoose(subClass, superClass) {
	    subClass.prototype = Object.create(superClass.prototype);
	    subClass.prototype.constructor = subClass;
	    subClass.__proto__ = superClass;
	  }
	
	  function _assertThisInitialized(self) {
	    if (self === void 0) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return self;
	  }
	
	  /*!
	   * GSAP 3.3.1
	   * https://greensock.com
	   *
	   * @license Copyright 2008-2020, GreenSock. All rights reserved.
	   * Subject to the terms at https://greensock.com/standard-license or for
	   * Club GreenSock members, the agreement issued with that membership.
	   * @author: Jack Doyle, jack@greensock.com
	  */
	  var _config = {
	    autoSleep: 120,
	    force3D: "auto",
	    nullTargetWarn: 1,
	    units: {
	      lineHeight: ""
	    }
	  },
	      _defaults = {
	    duration: .5,
	    overwrite: false,
	    delay: 0
	  },
	      _bigNum = 1e8,
	      _tinyNum = 1 / _bigNum,
	      _2PI = Math.PI * 2,
	      _HALF_PI = _2PI / 4,
	      _gsID = 0,
	      _sqrt = Math.sqrt,
	      _cos = Math.cos,
	      _sin = Math.sin,
	      _isString = function _isString(value) {
	    return typeof value === "string";
	  },
	      _isFunction = function _isFunction(value) {
	    return typeof value === "function";
	  },
	      _isNumber = function _isNumber(value) {
	    return typeof value === "number";
	  },
	      _isUndefined = function _isUndefined(value) {
	    return typeof value === "undefined";
	  },
	      _isObject = function _isObject(value) {
	    return typeof value === "object";
	  },
	      _isNotFalse = function _isNotFalse(value) {
	    return value !== false;
	  },
	      _windowExists = function _windowExists() {
	    return typeof window !== "undefined";
	  },
	      _isFuncOrString = function _isFuncOrString(value) {
	    return _isFunction(value) || _isString(value);
	  },
	      _isArray = Array.isArray,
	      _strictNumExp = /(?:-?\.?\d|\.)+/gi,
	      _numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-\+]*\d*/g,
	      _numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
	      _complexStringNumExp = /[-+=.]*\d+(?:\.|e-|e)*\d*/gi,
	      _parenthesesExp = /\(([^()]+)\)/i,
	      _relExp = /[+-]=-?[\.\d]+/,
	      _delimitedValueExp = /[#\-+.]*\b[a-z\d-=+%.]+/gi,
	      _globalTimeline,
	      _win,
	      _coreInitted,
	      _doc,
	      _globals = {},
	      _installScope = {},
	      _coreReady,
	      _install = function _install(scope) {
	    return (_installScope = _merge(scope, _globals)) && gsap;
	  },
	      _missingPlugin = function _missingPlugin(property, value) {
	    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
	  },
	      _warn = function _warn(message, suppress) {
	    return !suppress && console.warn(message);
	  },
	      _addGlobal = function _addGlobal(name, obj) {
	    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
	  },
	      _emptyFunc = function _emptyFunc() {
	    return 0;
	  },
	      _reservedProps = {},
	      _lazyTweens = [],
	      _lazyLookup = {},
	      _lastRenderedFrame,
	      _plugins = {},
	      _effects = {},
	      _nextGCFrame = 30,
	      _harnessPlugins = [],
	      _callbackNames = "",
	      _harness = function _harness(targets) {
	    var target = targets[0],
	        harnessPlugin,
	        i;
	
	    if (!_isObject(target) && !_isFunction(target)) {
	      targets = [targets];
	    }
	
	    if (!(harnessPlugin = (target._gsap || {}).harness)) {
	      i = _harnessPlugins.length;
	
	      while (i-- && !_harnessPlugins[i].targetTest(target)) {}
	
	      harnessPlugin = _harnessPlugins[i];
	    }
	
	    i = targets.length;
	
	    while (i--) {
	      targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
	    }
	
	    return targets;
	  },
	      _getCache = function _getCache(target) {
	    return target._gsap || _harness(toArray(target))[0]._gsap;
	  },
	      _getProperty = function _getProperty(target, property) {
	    var currentValue = target[property];
	    return _isFunction(currentValue) ? target[property]() : _isUndefined(currentValue) && target.getAttribute(property) || currentValue;
	  },
	      _forEachName = function _forEachName(names, func) {
	    return (names = names.split(",")).forEach(func) || names;
	  },
	      _round = function _round(value) {
	    return Math.round(value * 100000) / 100000 || 0;
	  },
	      _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
	    var l = toFind.length,
	        i = 0;
	
	    for (; toSearch.indexOf(toFind[i]) < 0 && ++i < l;) {}
	
	    return i < l;
	  },
	      _parseVars = function _parseVars(params, type, parent) {
	    var isLegacy = _isNumber(params[1]),
	        varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1),
	        vars = params[varsIndex],
	        irVars;
	
	    if (isLegacy) {
	      vars.duration = params[1];
	    }
	
	    vars.parent = parent;
	
	    if (type) {
	      irVars = vars;
	
	      while (parent && !("immediateRender" in irVars)) {
	        irVars = parent.vars.defaults || {};
	        parent = _isNotFalse(parent.vars.inherit) && parent.parent;
	      }
	
	      vars.immediateRender = _isNotFalse(irVars.immediateRender);
	
	      if (type < 2) {
	        vars.runBackwards = 1;
	      } else {
	        vars.startAt = params[varsIndex - 1];
	      }
	    }
	
	    return vars;
	  },
	      _lazyRender = function _lazyRender() {
	    var l = _lazyTweens.length,
	        a = _lazyTweens.slice(0),
	        i,
	        tween;
	
	    _lazyLookup = {};
	    _lazyTweens.length = 0;
	
	    for (i = 0; i < l; i++) {
	      tween = a[i];
	      tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
	    }
	  },
	      _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
	    _lazyTweens.length && _lazyRender();
	    animation.render(time, suppressEvents, force);
	    _lazyTweens.length && _lazyRender();
	  },
	      _numericIfPossible = function _numericIfPossible(value) {
	    var n = parseFloat(value);
	    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : value;
	  },
	      _passThrough = function _passThrough(p) {
	    return p;
	  },
	      _setDefaults = function _setDefaults(obj, defaults) {
	    for (var p in defaults) {
	      if (!(p in obj)) {
	        obj[p] = defaults[p];
	      }
	    }
	
	    return obj;
	  },
	      _setKeyframeDefaults = function _setKeyframeDefaults(obj, defaults) {
	    for (var p in defaults) {
	      if (!(p in obj) && p !== "duration" && p !== "ease") {
	        obj[p] = defaults[p];
	      }
	    }
	  },
	      _merge = function _merge(base, toMerge) {
	    for (var p in toMerge) {
	      base[p] = toMerge[p];
	    }
	
	    return base;
	  },
	      _mergeDeep = function _mergeDeep(base, toMerge) {
	    for (var p in toMerge) {
	      base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p];
	    }
	
	    return base;
	  },
	      _copyExcluding = function _copyExcluding(obj, excluding) {
	    var copy = {},
	        p;
	
	    for (p in obj) {
	      p in excluding || (copy[p] = obj[p]);
	    }
	
	    return copy;
	  },
	      _inheritDefaults = function _inheritDefaults(vars) {
	    var parent = vars.parent || _globalTimeline,
	        func = vars.keyframes ? _setKeyframeDefaults : _setDefaults;
	
	    if (_isNotFalse(vars.inherit)) {
	      while (parent) {
	        func(vars, parent.vars.defaults);
	        parent = parent.parent || parent._dp;
	      }
	    }
	
	    return vars;
	  },
	      _arraysMatch = function _arraysMatch(a1, a2) {
	    var i = a1.length,
	        match = i === a2.length;
	
	    while (match && i-- && a1[i] === a2[i]) {}
	
	    return i < 0;
	  },
	      _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
	    if (firstProp === void 0) {
	      firstProp = "_first";
	    }
	
	    if (lastProp === void 0) {
	      lastProp = "_last";
	    }
	
	    var prev = parent[lastProp],
	        t;
	
	    if (sortBy) {
	      t = child[sortBy];
	
	      while (prev && prev[sortBy] > t) {
	        prev = prev._prev;
	      }
	    }
	
	    if (prev) {
	      child._next = prev._next;
	      prev._next = child;
	    } else {
	      child._next = parent[firstProp];
	      parent[firstProp] = child;
	    }
	
	    if (child._next) {
	      child._next._prev = child;
	    } else {
	      parent[lastProp] = child;
	    }
	
	    child._prev = prev;
	    child.parent = child._dp = parent;
	    return child;
	  },
	      _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
	    if (firstProp === void 0) {
	      firstProp = "_first";
	    }
	
	    if (lastProp === void 0) {
	      lastProp = "_last";
	    }
	
	    var prev = child._prev,
	        next = child._next;
	
	    if (prev) {
	      prev._next = next;
	    } else if (parent[firstProp] === child) {
	      parent[firstProp] = next;
	    }
	
	    if (next) {
	      next._prev = prev;
	    } else if (parent[lastProp] === child) {
	      parent[lastProp] = prev;
	    }
	
	    child._next = child._prev = child.parent = null;
	  },
	      _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
	    if (child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren)) {
	      child.parent.remove(child);
	    }
	
	    child._act = 0;
	  },
	      _uncache = function _uncache(animation) {
	    var a = animation;
	
	    while (a) {
	      a._dirty = 1;
	      a = a.parent;
	    }
	
	    return animation;
	  },
	      _recacheAncestors = function _recacheAncestors(animation) {
	    var parent = animation.parent;
	
	    while (parent && parent.parent) {
	      parent._dirty = 1;
	      parent.totalDuration();
	      parent = parent.parent;
	    }
	
	    return animation;
	  },
	      _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
	    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
	  },
	      _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
	    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
	  },
	      _animationCycle = function _animationCycle(tTime, cycleDuration) {
	    return (tTime /= cycleDuration) && ~~tTime === tTime ? ~~tTime - 1 : ~~tTime;
	  },
	      _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
	    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
	  },
	      _setEnd = function _setEnd(animation) {
	    return animation._end = _round(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
	  },
	      _postAddChecks = function _postAddChecks(timeline, child) {
	    var t;
	
	    if (child._time || child._initted && !child._dur) {
	      t = _parentToChildTotalTime(timeline.rawTime(), child);
	
	      if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) {
	        child.render(t, true);
	      }
	    }
	
	    if (_uncache(timeline)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
	      if (timeline._dur < timeline.duration()) {
	        t = timeline;
	
	        while (t._dp) {
	          t.rawTime() >= 0 && t.totalTime(t._tTime);
	          t = t._dp;
	        }
	      }
	
	      timeline._zTime = -_tinyNum;
	    }
	  },
	      _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
	    child.parent && _removeFromParent(child);
	    child._start = _round(position + child._delay);
	    child._end = _round(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
	
	    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
	
	    timeline._recent = child;
	    skipChecks || _postAddChecks(timeline, child);
	    return timeline;
	  },
	      _scrollTrigger = function _scrollTrigger(animation, trigger) {
	    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
	  },
	      _attemptInitTween = function _attemptInitTween(tween, totalTime, force, suppressEvents) {
	    _initTween(tween, totalTime);
	
	    if (!tween._initted) {
	      return 1;
	    }
	
	    if (!force && tween._pt && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
	      _lazyTweens.push(tween);
	
	      tween._lazy = [totalTime, suppressEvents];
	      return 1;
	    }
	  },
	      _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
	    var prevRatio = tween.ratio,
	        ratio = totalTime < 0 || prevRatio && !totalTime && !tween._start && !tween._dp._lock ? 0 : 1,
	        repeatDelay = tween._rDelay,
	        tTime = 0,
	        pt,
	        iteration,
	        prevIteration;
	
	    if (repeatDelay && tween._repeat) {
	      tTime = _clamp(0, tween._tDur, totalTime);
	      iteration = _animationCycle(tTime, repeatDelay);
	      prevIteration = _animationCycle(tween._tTime, repeatDelay);
	
	      if (iteration !== prevIteration) {
	        prevRatio = 1 - ratio;
	        tween.vars.repeatRefresh && tween._initted && tween.invalidate();
	      }
	    }
	
	    if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents)) {
	      return;
	    }
	
	    if (ratio !== prevRatio || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
	      prevIteration = tween._zTime;
	      tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0);
	      suppressEvents || (suppressEvents = totalTime && !prevIteration);
	      tween.ratio = ratio;
	      tween._from && (ratio = 1 - ratio);
	      tween._time = 0;
	      tween._tTime = tTime;
	      suppressEvents || _callback(tween, "onStart");
	      pt = tween._pt;
	
	      while (pt) {
	        pt.r(ratio, pt.d);
	        pt = pt._next;
	      }
	
	      if (!ratio && tween._startAt && !tween._onUpdate && tween._start) {
	        tween._startAt.render(totalTime, true, force);
	      }
	
	      tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
	      tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
	
	      if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
	        ratio && _removeFromParent(tween, 1);
	
	        if (!suppressEvents) {
	          _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
	
	          tween._prom && tween._prom();
	        }
	      }
	    } else if (!tween._zTime) {
	      tween._zTime = totalTime;
	    }
	  },
	      _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
	    var child;
	
	    if (time > prevTime) {
	      child = animation._first;
	
	      while (child && child._start <= time) {
	        if (!child._dur && child.data === "isPause" && child._start > prevTime) {
	          return child;
	        }
	
	        child = child._next;
	      }
	    } else {
	      child = animation._last;
	
	      while (child && child._start >= time) {
	        if (!child._dur && child.data === "isPause" && child._start < prevTime) {
	          return child;
	        }
	
	        child = child._prev;
	      }
	    }
	  },
	      _setDuration = function _setDuration(animation, duration, skipUncache) {
	    var repeat = animation._repeat,
	        dur = _round(duration) || 0;
	    animation._dur = dur;
	    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _round(dur * (repeat + 1) + animation._rDelay * repeat);
	
	    if (animation._time > dur) {
	      animation._time = dur;
	      animation._tTime = Math.min(animation._tTime, animation._tDur);
	    }
	
	    !skipUncache && _uncache(animation.parent);
	    animation.parent && _setEnd(animation);
	    return animation;
	  },
	      _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
	    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
	  },
	      _zeroPosition = {
	    _start: 0,
	    endTime: _emptyFunc
	  },
	      _parsePosition = function _parsePosition(animation, position) {
	    var labels = animation.labels,
	        recent = animation._recent || _zeroPosition,
	        clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur,
	        i,
	        offset;
	
	    if (_isString(position) && (isNaN(position) || position in labels)) {
	      i = position.charAt(0);
	
	      if (i === "<" || i === ">") {
	        return (i === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0);
	      }
	
	      i = position.indexOf("=");
	
	      if (i < 0) {
	        position in labels || (labels[position] = clippedDuration);
	        return labels[position];
	      }
	
	      offset = +(position.charAt(i - 1) + position.substr(i + 1));
	      return i > 1 ? _parsePosition(animation, position.substr(0, i - 1)) + offset : clippedDuration + offset;
	    }
	
	    return position == null ? clippedDuration : +position;
	  },
	      _conditionalReturn = function _conditionalReturn(value, func) {
	    return value || value === 0 ? func(value) : func;
	  },
	      _clamp = function _clamp(min, max, value) {
	    return value < min ? min : value > max ? max : value;
	  },
	      getUnit = function getUnit(value) {
	    return (value + "").substr((parseFloat(value) + "").length);
	  },
	      clamp = function clamp(min, max, value) {
	    return _conditionalReturn(value, function (v) {
	      return _clamp(min, max, v);
	    });
	  },
	      _slice = [].slice,
	      _isArrayLike = function _isArrayLike(value, nonEmpty) {
	    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
	  },
	      _flatten = function _flatten(ar, leaveStrings, accumulator) {
	    if (accumulator === void 0) {
	      accumulator = [];
	    }
	
	    return ar.forEach(function (value) {
	      var _accumulator;
	
	      return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
	    }) || accumulator;
	  },
	      toArray = function toArray(value, leaveStrings) {
	    return _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call(_doc.querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [value] : [];
	  },
	      shuffle = function shuffle(a) {
	    return a.sort(function () {
	      return .5 - Math.random();
	    });
	  },
	      distribute = function distribute(v) {
	    if (_isFunction(v)) {
	      return v;
	    }
	
	    var vars = _isObject(v) ? v : {
	      each: v
	    },
	        ease = _parseEase(vars.ease),
	        from = vars.from || 0,
	        base = parseFloat(vars.base) || 0,
	        cache = {},
	        isDecimal = from > 0 && from < 1,
	        ratios = isNaN(from) || isDecimal,
	        axis = vars.axis,
	        ratioX = from,
	        ratioY = from;
	
	    if (_isString(from)) {
	      ratioX = ratioY = {
	        center: .5,
	        edges: .5,
	        end: 1
	      }[from] || 0;
	    } else if (!isDecimal && ratios) {
	      ratioX = from[0];
	      ratioY = from[1];
	    }
	
	    return function (i, target, a) {
	      var l = (a || vars).length,
	          distances = cache[l],
	          originX,
	          originY,
	          x,
	          y,
	          d,
	          j,
	          max,
	          min,
	          wrapAt;
	
	      if (!distances) {
	        wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [1, _bigNum])[1];
	
	        if (!wrapAt) {
	          max = -_bigNum;
	
	          while (max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l) {}
	
	          wrapAt--;
	        }
	
	        distances = cache[l] = [];
	        originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
	        originY = ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
	        max = 0;
	        min = _bigNum;
	
	        for (j = 0; j < l; j++) {
	          x = j % wrapAt - originX;
	          y = originY - (j / wrapAt | 0);
	          distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
	          d > max && (max = d);
	          d < min && (min = d);
	        }
	
	        from === "random" && shuffle(distances);
	        distances.max = max - min;
	        distances.min = min;
	        distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
	        distances.b = l < 0 ? base - l : base;
	        distances.u = getUnit(vars.amount || vars.each) || 0;
	        ease = ease && l < 0 ? _invertEase(ease) : ease;
	      }
	
	      l = (distances[i] - distances.min) / distances.max || 0;
	      return _round(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u;
	    };
	  },
	      _roundModifier = function _roundModifier(v) {
	    var p = v < 1 ? Math.pow(10, (v + "").length - 2) : 1;
	    return function (raw) {
	      return Math.floor(Math.round(parseFloat(raw) / v) * v * p) / p + (_isNumber(raw) ? 0 : getUnit(raw));
	    };
	  },
	      snap = function snap(snapTo, value) {
	    var isArray = _isArray(snapTo),
	        radius,
	        is2D;
	
	    if (!isArray && _isObject(snapTo)) {
	      radius = isArray = snapTo.radius || _bigNum;
	
	      if (snapTo.values) {
	        snapTo = toArray(snapTo.values);
	
	        if (is2D = !_isNumber(snapTo[0])) {
	          radius *= radius;
	        }
	      } else {
	        snapTo = _roundModifier(snapTo.increment);
	      }
	    }
	
	    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function (raw) {
	      is2D = snapTo(raw);
	      return Math.abs(is2D - raw) <= radius ? is2D : raw;
	    } : function (raw) {
	      var x = parseFloat(is2D ? raw.x : raw),
	          y = parseFloat(is2D ? raw.y : 0),
	          min = _bigNum,
	          closest = 0,
	          i = snapTo.length,
	          dx,
	          dy;
	
	      while (i--) {
	        if (is2D) {
	          dx = snapTo[i].x - x;
	          dy = snapTo[i].y - y;
	          dx = dx * dx + dy * dy;
	        } else {
	          dx = Math.abs(snapTo[i] - x);
	        }
	
	        if (dx < min) {
	          min = dx;
	          closest = i;
	        }
	      }
	
	      closest = !radius || min <= radius ? snapTo[closest] : raw;
	      return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
	    });
	  },
	      random = function random(min, max, roundingIncrement, returnFunction) {
	    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? !!(roundingIncrement = 0) : !returnFunction, function () {
	      return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5) && (returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min + Math.random() * (max - min)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
	    });
	  },
	      pipe = function pipe() {
	    for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
	      functions[_key] = arguments[_key];
	    }
	
	    return function (value) {
	      return functions.reduce(function (v, f) {
	        return f(v);
	      }, value);
	    };
	  },
	      unitize = function unitize(func, unit) {
	    return function (value) {
	      return func(parseFloat(value)) + (unit || getUnit(value));
	    };
	  },
	      normalize = function normalize(min, max, value) {
	    return mapRange(min, max, 0, 1, value);
	  },
	      _wrapArray = function _wrapArray(a, wrapper, value) {
	    return _conditionalReturn(value, function (index) {
	      return a[~~wrapper(index)];
	    });
	  },
	      wrap = function wrap(min, max, value) {
	    var range = max - min;
	    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function (value) {
	      return (range + (value - min) % range) % range + min;
	    });
	  },
	      wrapYoyo = function wrapYoyo(min, max, value) {
	    var range = max - min,
	        total = range * 2;
	    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function (value) {
	      value = (total + (value - min) % total) % total;
	      return min + (value > range ? total - value : value);
	    });
	  },
	      _replaceRandom = function _replaceRandom(value) {
	    var prev = 0,
	        s = "",
	        i,
	        nums,
	        end,
	        isArray;
	
	    while (~(i = value.indexOf("random(", prev))) {
	      end = value.indexOf(")", i);
	      isArray = value.charAt(i + 7) === "[";
	      nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
	      s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], +nums[1], +nums[2] || 1e-5);
	      prev = end + 1;
	    }
	
	    return s + value.substr(prev, value.length - prev);
	  },
	      mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
	    var inRange = inMax - inMin,
	        outRange = outMax - outMin;
	    return _conditionalReturn(value, function (value) {
	      return outMin + ((value - inMin) / inRange * outRange || 0);
	    });
	  },
	      interpolate = function interpolate(start, end, progress, mutate) {
	    var func = isNaN(start + end) ? 0 : function (p) {
	      return (1 - p) * start + p * end;
	    };
	
	    if (!func) {
	      var isString = _isString(start),
	          master = {},
	          p,
	          i,
	          interpolators,
	          l,
	          il;
	
	      progress === true && (mutate = 1) && (progress = null);
	
	      if (isString) {
	        start = {
	          p: start
	        };
	        end = {
	          p: end
	        };
	      } else if (_isArray(start) && !_isArray(end)) {
	        interpolators = [];
	        l = start.length;
	        il = l - 2;
	
	        for (i = 1; i < l; i++) {
	          interpolators.push(interpolate(start[i - 1], start[i]));
	        }
	
	        l--;
	
	        func = function func(p) {
	          p *= l;
	          var i = Math.min(il, ~~p);
	          return interpolators[i](p - i);
	        };
	
	        progress = end;
	      } else if (!mutate) {
	        start = _merge(_isArray(start) ? [] : {}, start);
	      }
	
	      if (!interpolators) {
	        for (p in end) {
	          _addPropTween.call(master, start, p, "get", end[p]);
	        }
	
	        func = function func(p) {
	          return _renderPropTweens(p, master) || (isString ? start.p : start);
	        };
	      }
	    }
	
	    return _conditionalReturn(progress, func);
	  },
	      _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
	    var labels = timeline.labels,
	        min = _bigNum,
	        p,
	        distance,
	        label;
	
	    for (p in labels) {
	      distance = labels[p] - fromTime;
	
	      if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
	        label = p;
	        min = distance;
	      }
	    }
	
	    return label;
	  },
	      _callback = function _callback(animation, type, executeLazyFirst) {
	    var v = animation.vars,
	        callback = v[type],
	        params,
	        scope;
	
	    if (!callback) {
	      return;
	    }
	
	    params = v[type + "Params"];
	    scope = v.callbackScope || animation;
	    executeLazyFirst && _lazyTweens.length && _lazyRender();
	    return params ? callback.apply(scope, params) : callback.call(scope);
	  },
	      _interrupt = function _interrupt(animation) {
	    _removeFromParent(animation);
	
	    if (animation.progress() < 1) {
	      _callback(animation, "onInterrupt");
	    }
	
	    return animation;
	  },
	      _quickTween,
	      _createPlugin = function _createPlugin(config) {
	    config = !config.name && config["default"] || config;
	
	    var name = config.name,
	        isFunc = _isFunction(config),
	        Plugin = name && !isFunc && config.init ? function () {
	      this._props = [];
	    } : config,
	        instanceDefaults = {
	      init: _emptyFunc,
	      render: _renderPropTweens,
	      add: _addPropTween,
	      kill: _killPropTweensOf,
	      modifier: _addPluginModifier,
	      rawVars: 0
	    },
	        statics = {
	      targetTest: 0,
	      get: 0,
	      getSetter: _getSetter,
	      aliases: {},
	      register: 0
	    };
	
	    _wake();
	
	    if (config !== Plugin) {
	      if (_plugins[name]) {
	        return;
	      }
	
	      _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics));
	
	      _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics)));
	
	      _plugins[Plugin.prop = name] = Plugin;
	
	      if (config.targetTest) {
	        _harnessPlugins.push(Plugin);
	
	        _reservedProps[name] = 1;
	      }
	
	      name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin";
	    }
	
	    _addGlobal(name, Plugin);
	
	    if (config.register) {
	      config.register(gsap, Plugin, PropTween);
	    }
	  },
	      _255 = 255,
	      _colorLookup = {
	    aqua: [0, _255, _255],
	    lime: [0, _255, 0],
	    silver: [192, 192, 192],
	    black: [0, 0, 0],
	    maroon: [128, 0, 0],
	    teal: [0, 128, 128],
	    blue: [0, 0, _255],
	    navy: [0, 0, 128],
	    white: [_255, _255, _255],
	    olive: [128, 128, 0],
	    yellow: [_255, _255, 0],
	    orange: [_255, 165, 0],
	    gray: [128, 128, 128],
	    purple: [128, 0, 128],
	    green: [0, 128, 0],
	    red: [_255, 0, 0],
	    pink: [_255, 192, 203],
	    cyan: [0, _255, _255],
	    transparent: [_255, _255, _255, 0]
	  },
	      _hue = function _hue(h, m1, m2) {
	    h = h < 0 ? h + 1 : h > 1 ? h - 1 : h;
	    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
	  },
	      splitColor = function splitColor(v, toHSL, forceAlpha) {
	    var a = !v ? _colorLookup.black : _isNumber(v) ? [v >> 16, v >> 8 & _255, v & _255] : 0,
	        r,
	        g,
	        b,
	        h,
	        s,
	        l,
	        max,
	        min,
	        d,
	        wasHSL;
	
	    if (!a) {
	      if (v.substr(-1) === ",") {
	        v = v.substr(0, v.length - 1);
	      }
	
	      if (_colorLookup[v]) {
	        a = _colorLookup[v];
	      } else if (v.charAt(0) === "#") {
	        if (v.length === 4) {
	          r = v.charAt(1);
	          g = v.charAt(2);
	          b = v.charAt(3);
	          v = "#" + r + r + g + g + b + b;
	        }
	
	        v = parseInt(v.substr(1), 16);
	        a = [v >> 16, v >> 8 & _255, v & _255];
	      } else if (v.substr(0, 3) === "hsl") {
	        a = wasHSL = v.match(_strictNumExp);
	
	        if (!toHSL) {
	          h = +a[0] % 360 / 360;
	          s = +a[1] / 100;
	          l = +a[2] / 100;
	          g = l <= .5 ? l * (s + 1) : l + s - l * s;
	          r = l * 2 - g;
	
	          if (a.length > 3) {
	            a[3] *= 1;
	          }
	
	          a[0] = _hue(h + 1 / 3, r, g);
	          a[1] = _hue(h, r, g);
	          a[2] = _hue(h - 1 / 3, r, g);
	        } else if (~v.indexOf("=")) {
	          a = v.match(_numExp);
	          forceAlpha && a.length < 4 && (a[3] = 1);
	          return a;
	        }
	      } else {
	        a = v.match(_strictNumExp) || _colorLookup.transparent;
	      }
	
	      a = a.map(Number);
	    }
	
	    if (toHSL && !wasHSL) {
	      r = a[0] / _255;
	      g = a[1] / _255;
	      b = a[2] / _255;
	      max = Math.max(r, g, b);
	      min = Math.min(r, g, b);
	      l = (max + min) / 2;
	
	      if (max === min) {
	        h = s = 0;
	      } else {
	        d = max - min;
	        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	        h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
	        h *= 60;
	      }
	
	      a[0] = ~~(h + .5);
	      a[1] = ~~(s * 100 + .5);
	      a[2] = ~~(l * 100 + .5);
	    }
	
	    forceAlpha && a.length < 4 && (a[3] = 1);
	    return a;
	  },
	      _colorOrderData = function _colorOrderData(v) {
	    var values = [],
	        c = [],
	        i = -1;
	    v.split(_colorExp).forEach(function (v) {
	      var a = v.match(_numWithUnitExp) || [];
	      values.push.apply(values, a);
	      c.push(i += a.length + 1);
	    });
	    values.c = c;
	    return values;
	  },
	      _formatColors = function _formatColors(s, toHSL, orderMatchData) {
	    var result = "",
	        colors = (s + result).match(_colorExp),
	        type = toHSL ? "hsla(" : "rgba(",
	        i = 0,
	        c,
	        shell,
	        d,
	        l;
	
	    if (!colors) {
	      return s;
	    }
	
	    colors = colors.map(function (color) {
	      return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
	    });
	
	    if (orderMatchData) {
	      d = _colorOrderData(s);
	      c = orderMatchData.c;
	
	      if (c.join(result) !== d.c.join(result)) {
	        shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
	        l = shell.length - 1;
	
	        for (; i < l; i++) {
	          result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
	        }
	      }
	    }
	
	    if (!shell) {
	      shell = s.split(_colorExp);
	      l = shell.length - 1;
	
	      for (; i < l; i++) {
	        result += shell[i] + colors[i];
	      }
	    }
	
	    return result + shell[l];
	  },
	      _colorExp = function () {
	    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b",
	        p;
	
	    for (p in _colorLookup) {
	      s += "|" + p + "\\b";
	    }
	
	    return new RegExp(s + ")", "gi");
	  }(),
	      _hslExp = /hsl[a]?\(/,
	      _colorStringFilter = function _colorStringFilter(a) {
	    var combined = a.join(" "),
	        toHSL;
	    _colorExp.lastIndex = 0;
	
	    if (_colorExp.test(combined)) {
	      toHSL = _hslExp.test(combined);
	      a[1] = _formatColors(a[1], toHSL);
	      a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1]));
	      return true;
	    }
	  },
	      _tickerActive,
	      _ticker = function () {
	    var _getTime = Date.now,
	        _lagThreshold = 500,
	        _adjustedLag = 33,
	        _startTime = _getTime(),
	        _lastUpdate = _startTime,
	        _gap = 1 / 240,
	        _nextTime = _gap,
	        _listeners = [],
	        _id,
	        _req,
	        _raf,
	        _self,
	        _tick = function _tick(v) {
	      var elapsed = _getTime() - _lastUpdate,
	          manual = v === true,
	          overlap,
	          dispatch;
	
	      if (elapsed > _lagThreshold) {
	        _startTime += elapsed - _adjustedLag;
	      }
	
	      _lastUpdate += elapsed;
	      _self.time = (_lastUpdate - _startTime) / 1000;
	      overlap = _self.time - _nextTime;
	
	      if (overlap > 0 || manual) {
	        _self.frame++;
	        _nextTime += overlap + (overlap >= _gap ? 0.004 : _gap - overlap);
	        dispatch = 1;
	      }
	
	      manual || (_id = _req(_tick));
	      dispatch && _listeners.forEach(function (l) {
	        return l(_self.time, elapsed, _self.frame, v);
	      });
	    };
	
	    _self = {
	      time: 0,
	      frame: 0,
	      tick: function tick() {
	        _tick(true);
	      },
	      wake: function wake() {
	        if (_coreReady) {
	          if (!_coreInitted && _windowExists()) {
	            _win = _coreInitted = window;
	            _doc = _win.document || {};
	            _globals.gsap = gsap;
	            (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
	
	            _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
	
	            _raf = _win.requestAnimationFrame;
	          }
	
	          _id && _self.sleep();
	
	          _req = _raf || function (f) {
	            return setTimeout(f, (_nextTime - _self.time) * 1000 + 1 | 0);
	          };
	
	          _tickerActive = 1;
	
	          _tick(2);
	        }
	      },
	      sleep: function sleep() {
	        (_raf ? _win.cancelAnimationFrame : clearTimeout)(_id);
	        _tickerActive = 0;
	        _req = _emptyFunc;
	      },
	      lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
	        _lagThreshold = threshold || 1 / _tinyNum;
	        _adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
	      },
	      fps: function fps(_fps) {
	        _gap = 1 / (_fps || 240);
	        _nextTime = _self.time + _gap;
	      },
	      add: function add(callback) {
	        _listeners.indexOf(callback) < 0 && _listeners.push(callback);
	
	        _wake();
	      },
	      remove: function remove(callback) {
	        var i;
	        ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1);
	      },
	      _listeners: _listeners
	    };
	    return _self;
	  }(),
	      _wake = function _wake() {
	    return !_tickerActive && _ticker.wake();
	  },
	      _easeMap = {},
	      _customEaseExp = /^[\d.\-M][\d.\-,\s]/,
	      _quotesExp = /["']/g,
	      _parseObjectInString = function _parseObjectInString(value) {
	    var obj = {},
	        split = value.substr(1, value.length - 3).split(":"),
	        key = split[0],
	        i = 1,
	        l = split.length,
	        index,
	        val,
	        parsedVal;
	
	    for (; i < l; i++) {
	      val = split[i];
	      index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
	      parsedVal = val.substr(0, index);
	      obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
	      key = val.substr(index + 1).trim();
	    }
	
	    return obj;
	  },
	      _configEaseFromString = function _configEaseFromString(name) {
	    var split = (name + "").split("("),
	        ease = _easeMap[split[0]];
	    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [_parseObjectInString(split[1])] : _parenthesesExp.exec(name)[1].split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
	  },
	      _invertEase = function _invertEase(ease) {
	    return function (p) {
	      return 1 - ease(1 - p);
	    };
	  },
	      _propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
	    var child = timeline._first,
	        ease;
	
	    while (child) {
	      if (child instanceof Timeline) {
	        _propagateYoyoEase(child, isYoyo);
	      } else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
	        if (child.timeline) {
	          _propagateYoyoEase(child.timeline, isYoyo);
	        } else {
	          ease = child._ease;
	          child._ease = child._yEase;
	          child._yEase = ease;
	          child._yoyo = isYoyo;
	        }
	      }
	
	      child = child._next;
	    }
	  },
	      _parseEase = function _parseEase(ease, defaultEase) {
	    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
	  },
	      _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
	    if (easeOut === void 0) {
	      easeOut = function easeOut(p) {
	        return 1 - easeIn(1 - p);
	      };
	    }
	
	    if (easeInOut === void 0) {
	      easeInOut = function easeInOut(p) {
	        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
	      };
	    }
	
	    var ease = {
	      easeIn: easeIn,
	      easeOut: easeOut,
	      easeInOut: easeInOut
	    },
	        lowercaseName;
	
	    _forEachName(names, function (name) {
	      _easeMap[name] = _globals[name] = ease;
	      _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
	
	      for (var p in ease) {
	        _easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
	      }
	    });
	
	    return ease;
	  },
	      _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
	    return function (p) {
	      return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
	    };
	  },
	      _configElastic = function _configElastic(type, amplitude, period) {
	    var p1 = amplitude >= 1 ? amplitude : 1,
	        p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1),
	        p3 = p2 / _2PI * (Math.asin(1 / p1) || 0),
	        easeOut = function easeOut(p) {
	      return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
	    },
	        ease = type === "out" ? easeOut : type === "in" ? function (p) {
	      return 1 - easeOut(1 - p);
	    } : _easeInOutFromOut(easeOut);
	
	    p2 = _2PI / p2;
	
	    ease.config = function (amplitude, period) {
	      return _configElastic(type, amplitude, period);
	    };
	
	    return ease;
	  },
	      _configBack = function _configBack(type, overshoot) {
	    if (overshoot === void 0) {
	      overshoot = 1.70158;
	    }
	
	    var easeOut = function easeOut(p) {
	      return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
	    },
	        ease = type === "out" ? easeOut : type === "in" ? function (p) {
	      return 1 - easeOut(1 - p);
	    } : _easeInOutFromOut(easeOut);
	
	    ease.config = function (overshoot) {
	      return _configBack(type, overshoot);
	    };
	
	    return ease;
	  };
	
	  _forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function (name, i) {
	    var power = i < 5 ? i + 1 : i;
	
	    _insertEase(name + ",Power" + (power - 1), i ? function (p) {
	      return Math.pow(p, power);
	    } : function (p) {
	      return p;
	    }, function (p) {
	      return 1 - Math.pow(1 - p, power);
	    }, function (p) {
	      return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
	    });
	  });
	
	  _easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
	
	  _insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
	
	  (function (n, c) {
	    var n1 = 1 / c,
	        n2 = 2 * n1,
	        n3 = 2.5 * n1,
	        easeOut = function easeOut(p) {
	      return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
	    };
	
	    _insertEase("Bounce", function (p) {
	      return 1 - easeOut(1 - p);
	    }, easeOut);
	  })(7.5625, 2.75);
	
	  _insertEase("Expo", function (p) {
	    return p ? Math.pow(2, 10 * (p - 1)) : 0;
	  });
	
	  _insertEase("Circ", function (p) {
	    return -(_sqrt(1 - p * p) - 1);
	  });
	
	  _insertEase("Sine", function (p) {
	    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
	  });
	
	  _insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
	
	  _easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
	    config: function config(steps, immediateStart) {
	      if (steps === void 0) {
	        steps = 1;
	      }
	
	      var p1 = 1 / steps,
	          p2 = steps + (immediateStart ? 0 : 1),
	          p3 = immediateStart ? 1 : 0,
	          max = 1 - _tinyNum;
	      return function (p) {
	        return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
	      };
	    }
	  };
	  _defaults.ease = _easeMap["quad.out"];
	
	  _forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function (name) {
	    return _callbackNames += name + "," + name + "Params,";
	  });
	
	  var GSCache = function GSCache(target, harness) {
	    this.id = _gsID++;
	    target._gsap = this;
	    this.target = target;
	    this.harness = harness;
	    this.get = harness ? harness.get : _getProperty;
	    this.set = harness ? harness.getSetter : _getSetter;
	  };
	  var Animation = function () {
	    function Animation(vars, time) {
	      var parent = vars.parent || _globalTimeline;
	      this.vars = vars;
	      this._delay = +vars.delay || 0;
	
	      if (this._repeat = vars.repeat || 0) {
	        this._rDelay = vars.repeatDelay || 0;
	        this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
	      }
	
	      this._ts = 1;
	
	      _setDuration(this, +vars.duration, 1);
	
	      this.data = vars.data;
	      _tickerActive || _ticker.wake();
	      parent && _addToTimeline(parent, this, time || time === 0 ? time : parent._time, 1);
	      vars.reversed && this.reverse();
	      vars.paused && this.paused(true);
	    }
	
	    var _proto = Animation.prototype;
	
	    _proto.delay = function delay(value) {
	      if (value || value === 0) {
	        this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
	        this._delay = value;
	        return this;
	      }
	
	      return this._delay;
	    };
	
	    _proto.duration = function duration(value) {
	      return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
	    };
	
	    _proto.totalDuration = function totalDuration(value) {
	      if (!arguments.length) {
	        return this._tDur;
	      }
	
	      this._dirty = 0;
	      return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
	    };
	
	    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
	      _wake();
	
	      if (!arguments.length) {
	        return this._tTime;
	      }
	
	      var parent = this.parent || this._dp;
	
	      if (parent && parent.smoothChildTiming && this._ts) {
	        this._start = _round(parent._time - (this._ts > 0 ? _totalTime / this._ts : ((this._dirty ? this.totalDuration() : this._tDur) - _totalTime) / -this._ts));
	
	        _setEnd(this);
	
	        if (!parent._dirty) {
	          _uncache(parent);
	        }
	
	        while (parent.parent) {
	          if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) {
	            parent.totalTime(parent._tTime, true);
	          }
	
	          parent = parent.parent;
	        }
	
	        if (!this.parent && this._dp.autoRemoveChildren) {
	          _addToTimeline(this._dp, this, this._start - this._delay);
	        }
	      }
	
	      if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted) {
	        this._ts || (this._pTime = _totalTime);
	
	        _lazySafeRender(this, _totalTime, suppressEvents);
	      }
	
	      return this;
	    };
	
	    _proto.time = function time(value, suppressEvents) {
	      return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % this._dur || (value ? this._dur : 0), suppressEvents) : this._time;
	    };
	
	    _proto.totalProgress = function totalProgress(value, suppressEvents) {
	      return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
	    };
	
	    _proto.progress = function progress(value, suppressEvents) {
	      return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
	    };
	
	    _proto.iteration = function iteration(value, suppressEvents) {
	      var cycleDuration = this.duration() + this._rDelay;
	
	      return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
	    };
	
	    _proto.timeScale = function timeScale(value) {
	      if (!arguments.length) {
	        return this._rts === -_tinyNum ? 0 : this._rts;
	      }
	
	      if (this._rts === value) {
	        return this;
	      }
	
	      var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime;
	      this._rts = +value || 0;
	      this._ts = this._ps || value === -_tinyNum ? 0 : this._rts;
	      return _recacheAncestors(this.totalTime(_clamp(0, this._tDur, tTime), true));
	    };
	
	    _proto.paused = function paused(value) {
	      if (!arguments.length) {
	        return this._ps;
	      }
	
	      if (this._ps !== value) {
	        this._ps = value;
	
	        if (value) {
	          this._pTime = this._tTime || Math.max(-this._delay, this.rawTime());
	          this._ts = this._act = 0;
	        } else {
	          _wake();
	
	          this._ts = this._rts;
	          this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && (this._tTime -= _tinyNum) && Math.abs(this._zTime) !== _tinyNum);
	        }
	      }
	
	      return this;
	    };
	
	    _proto.startTime = function startTime(value) {
	      if (arguments.length) {
	        this._start = value;
	        var parent = this.parent || this._dp;
	        parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
	        return this;
	      }
	
	      return this._start;
	    };
	
	    _proto.endTime = function endTime(includeRepeats) {
	      return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts);
	    };
	
	    _proto.rawTime = function rawTime(wrapRepeats) {
	      var parent = this.parent || this._dp;
	      return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
	    };
	
	    _proto.repeat = function repeat(value) {
	      if (arguments.length) {
	        this._repeat = value;
	        return _onUpdateTotalDuration(this);
	      }
	
	      return this._repeat;
	    };
	
	    _proto.repeatDelay = function repeatDelay(value) {
	      if (arguments.length) {
	        this._rDelay = value;
	        return _onUpdateTotalDuration(this);
	      }
	
	      return this._rDelay;
	    };
	
	    _proto.yoyo = function yoyo(value) {
	      if (arguments.length) {
	        this._yoyo = value;
	        return this;
	      }
	
	      return this._yoyo;
	    };
	
	    _proto.seek = function seek(position, suppressEvents) {
	      return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
	    };
	
	    _proto.restart = function restart(includeDelay, suppressEvents) {
	      return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
	    };
	
	    _proto.play = function play(from, suppressEvents) {
	      if (from != null) {
	        this.seek(from, suppressEvents);
	      }
	
	      return this.reversed(false).paused(false);
	    };
	
	    _proto.reverse = function reverse(from, suppressEvents) {
	      if (from != null) {
	        this.seek(from || this.totalDuration(), suppressEvents);
	      }
	
	      return this.reversed(true).paused(false);
	    };
	
	    _proto.pause = function pause(atTime, suppressEvents) {
	      if (atTime != null) {
	        this.seek(atTime, suppressEvents);
	      }
	
	      return this.paused(true);
	    };
	
	    _proto.resume = function resume() {
	      return this.paused(false);
	    };
	
	    _proto.reversed = function reversed(value) {
	      if (arguments.length) {
	        if (!!value !== this.reversed()) {
	          this.timeScale(-this._rts || (value ? -_tinyNum : 0));
	        }
	
	        return this;
	      }
	
	      return this._rts < 0;
	    };
	
	    _proto.invalidate = function invalidate() {
	      this._initted = 0;
	      this._zTime = -_tinyNum;
	      return this;
	    };
	
	    _proto.isActive = function isActive(hasStarted) {
	      var parent = this.parent || this._dp,
	          start = this._start,
	          rawTime;
	      return !!(!parent || this._ts && (this._initted || !hasStarted) && parent.isActive(hasStarted) && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
	    };
	
	    _proto.eventCallback = function eventCallback(type, callback, params) {
	      var vars = this.vars;
	
	      if (arguments.length > 1) {
	        if (!callback) {
	          delete vars[type];
	        } else {
	          vars[type] = callback;
	
	          if (params) {
	            vars[type + "Params"] = params;
	          }
	
	          if (type === "onUpdate") {
	            this._onUpdate = callback;
	          }
	        }
	
	        return this;
	      }
	
	      return vars[type];
	    };
	
	    _proto.then = function then(onFulfilled) {
	      var self = this;
	      return new Promise(function (resolve) {
	        var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough,
	            _resolve = function _resolve() {
	          var _then = self.then;
	          self.then = null;
	          _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
	          resolve(f);
	          self.then = _then;
	        };
	
	        if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) {
	          _resolve();
	        } else {
	          self._prom = _resolve;
	        }
	      });
	    };
	
	    _proto.kill = function kill() {
	      _interrupt(this);
	    };
	
	    return Animation;
	  }();
	
	  _setDefaults(Animation.prototype, {
	    _time: 0,
	    _start: 0,
	    _end: 0,
	    _tTime: 0,
	    _tDur: 0,
	    _dirty: 0,
	    _repeat: 0,
	    _yoyo: false,
	    parent: null,
	    _initted: false,
	    _rDelay: 0,
	    _ts: 1,
	    _dp: 0,
	    ratio: 0,
	    _zTime: -_tinyNum,
	    _prom: 0,
	    _ps: false,
	    _rts: 1
	  });
	
	  var Timeline = function (_Animation) {
	    _inheritsLoose(Timeline, _Animation);
	
	    function Timeline(vars, time) {
	      var _this;
	
	      if (vars === void 0) {
	        vars = {};
	      }
	
	      _this = _Animation.call(this, vars, time) || this;
	      _this.labels = {};
	      _this.smoothChildTiming = !!vars.smoothChildTiming;
	      _this.autoRemoveChildren = !!vars.autoRemoveChildren;
	      _this._sort = _isNotFalse(vars.sortChildren);
	      _this.parent && _postAddChecks(_this.parent, _assertThisInitialized(_this));
	      vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
	      return _this;
	    }
	
	    var _proto2 = Timeline.prototype;
	
	    _proto2.to = function to(targets, vars, position) {
	      new Tween(targets, _parseVars(arguments, 0, this), _parsePosition(this, _isNumber(vars) ? arguments[3] : position));
	      return this;
	    };
	
	    _proto2.from = function from(targets, vars, position) {
	      new Tween(targets, _parseVars(arguments, 1, this), _parsePosition(this, _isNumber(vars) ? arguments[3] : position));
	      return this;
	    };
	
	    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
	      new Tween(targets, _parseVars(arguments, 2, this), _parsePosition(this, _isNumber(fromVars) ? arguments[4] : position));
	      return this;
	    };
	
	    _proto2.set = function set(targets, vars, position) {
	      vars.duration = 0;
	      vars.parent = this;
	      _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
	      vars.immediateRender = !!vars.immediateRender;
	      new Tween(targets, vars, _parsePosition(this, position), 1);
	      return this;
	    };
	
	    _proto2.call = function call(callback, params, position) {
	      return _addToTimeline(this, Tween.delayedCall(0, callback, params), _parsePosition(this, position));
	    };
	
	    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
	      vars.duration = duration;
	      vars.stagger = vars.stagger || stagger;
	      vars.onComplete = onCompleteAll;
	      vars.onCompleteParams = onCompleteAllParams;
	      vars.parent = this;
	      new Tween(targets, vars, _parsePosition(this, position));
	      return this;
	    };
	
	    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
	      vars.runBackwards = 1;
	      _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
	      return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
	    };
	
	    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
	      toVars.startAt = fromVars;
	      _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
	      return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
	    };
	
	    _proto2.render = function render(totalTime, suppressEvents, force) {
	      var prevTime = this._time,
	          tDur = this._dirty ? this.totalDuration() : this._tDur,
	          dur = this._dur,
	          tTime = this !== _globalTimeline && totalTime > tDur - _tinyNum && totalTime >= 0 ? tDur : totalTime < _tinyNum ? 0 : totalTime,
	          crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur),
	          time,
	          child,
	          next,
	          iteration,
	          cycleDuration,
	          prevPaused,
	          pauseTween,
	          timeScale,
	          prevStart,
	          prevIteration,
	          yoyo,
	          isYoyo;
	
	      if (tTime !== this._tTime || force || crossingStart) {
	        if (prevTime !== this._time && dur) {
	          tTime += this._time - prevTime;
	          totalTime += this._time - prevTime;
	        }
	
	        time = tTime;
	        prevStart = this._start;
	        timeScale = this._ts;
	        prevPaused = !timeScale;
	
	        if (crossingStart) {
	          dur || (prevTime = this._zTime);
	          (totalTime || !suppressEvents) && (this._zTime = totalTime);
	        }
	
	        if (this._repeat) {
	          yoyo = this._yoyo;
	          cycleDuration = dur + this._rDelay;
	          time = _round(tTime % cycleDuration);
	
	          if (time > dur || tDur === tTime) {
	            time = dur;
	          }
	
	          iteration = ~~(tTime / cycleDuration);
	
	          if (iteration && iteration === tTime / cycleDuration) {
	            time = dur;
	            iteration--;
	          }
	
	          prevIteration = _animationCycle(this._tTime, cycleDuration);
	          !prevTime && this._tTime && prevIteration !== iteration && (prevIteration = iteration);
	
	          if (yoyo && iteration & 1) {
	            time = dur - time;
	            isYoyo = 1;
	          }
	
	          if (iteration !== prevIteration && !this._lock) {
	            var rewinding = yoyo && prevIteration & 1,
	                doesWrap = rewinding === (yoyo && iteration & 1);
	
	            if (iteration < prevIteration) {
	              rewinding = !rewinding;
	            }
	
	            prevTime = rewinding ? 0 : dur;
	            this._lock = 1;
	            this.render(prevTime || (isYoyo ? 0 : _round(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
	
	            if (!suppressEvents && this.parent) {
	              _callback(this, "onRepeat");
	            }
	
	            this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
	
	            if (prevTime !== this._time || prevPaused !== !this._ts) {
	              return this;
	            }
	
	            if (doesWrap) {
	              this._lock = 2;
	              prevTime = rewinding ? dur + 0.0001 : -0.0001;
	              this.render(prevTime, true);
	              this.vars.repeatRefresh && !isYoyo && this.invalidate();
	            }
	
	            this._lock = 0;
	
	            if (!this._ts && !prevPaused) {
	              return this;
	            }
	
	            _propagateYoyoEase(this, isYoyo);
	          }
	        }
	
	        if (this._hasPause && !this._forcing && this._lock < 2) {
	          pauseTween = _findNextPauseTween(this, _round(prevTime), _round(time));
	
	          if (pauseTween) {
	            tTime -= time - (time = pauseTween._start);
	          }
	        }
	
	        this._tTime = tTime;
	        this._time = time;
	        this._act = !timeScale;
	
	        if (!this._initted) {
	          this._onUpdate = this.vars.onUpdate;
	          this._initted = 1;
	          this._zTime = totalTime;
	        }
	
	        if (!prevTime && time && !suppressEvents) {
	          _callback(this, "onStart");
	        }
	
	        if (time >= prevTime && totalTime >= 0) {
	          child = this._first;
	
	          while (child) {
	            next = child._next;
	
	            if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
	              if (child.parent !== this) {
	                return this.render(totalTime, suppressEvents, force);
	              }
	
	              child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
	
	              if (time !== this._time || !this._ts && !prevPaused) {
	                pauseTween = 0;
	                next && (tTime += this._zTime = -_tinyNum);
	                break;
	              }
	            }
	
	            child = next;
	          }
	        } else {
	          child = this._last;
	          var adjustedTime = totalTime < 0 ? totalTime : time;
	
	          while (child) {
	            next = child._prev;
	
	            if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
	              if (child.parent !== this) {
	                return this.render(totalTime, suppressEvents, force);
	              }
	
	              child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force);
	
	              if (time !== this._time || !this._ts && !prevPaused) {
	                pauseTween = 0;
	                next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum);
	                break;
	              }
	            }
	
	            child = next;
	          }
	        }
	
	        if (pauseTween && !suppressEvents) {
	          this.pause();
	          pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
	
	          if (this._ts) {
	            this._start = prevStart;
	
	            _setEnd(this);
	
	            return this.render(totalTime, suppressEvents, force);
	          }
	        }
	
	        this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
	        if (tTime === tDur && tDur >= this.totalDuration() || !tTime && prevTime) if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) if (!this._lock) {
	          (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1);
	
	          if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime)) {
	            _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
	
	            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
	          }
	        }
	      }
	
	      return this;
	    };
	
	    _proto2.add = function add(child, position) {
	      var _this2 = this;
	
	      if (!_isNumber(position)) {
	        position = _parsePosition(this, position);
	      }
	
	      if (!(child instanceof Animation)) {
	        if (_isArray(child)) {
	          child.forEach(function (obj) {
	            return _this2.add(obj, position);
	          });
	          return _uncache(this);
	        }
	
	        if (_isString(child)) {
	          return this.addLabel(child, position);
	        }
	
	        if (_isFunction(child)) {
	          child = Tween.delayedCall(0, child);
	        } else {
	          return this;
	        }
	      }
	
	      return this !== child ? _addToTimeline(this, child, position) : this;
	    };
	
	    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
	      if (nested === void 0) {
	        nested = true;
	      }
	
	      if (tweens === void 0) {
	        tweens = true;
	      }
	
	      if (timelines === void 0) {
	        timelines = true;
	      }
	
	      if (ignoreBeforeTime === void 0) {
	        ignoreBeforeTime = -_bigNum;
	      }
	
	      var a = [],
	          child = this._first;
	
	      while (child) {
	        if (child._start >= ignoreBeforeTime) {
	          if (child instanceof Tween) {
	            tweens && a.push(child);
	          } else {
	            timelines && a.push(child);
	            nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
	          }
	        }
	
	        child = child._next;
	      }
	
	      return a;
	    };
	
	    _proto2.getById = function getById(id) {
	      var animations = this.getChildren(1, 1, 1),
	          i = animations.length;
	
	      while (i--) {
	        if (animations[i].vars.id === id) {
	          return animations[i];
	        }
	      }
	    };
	
	    _proto2.remove = function remove(child) {
	      if (_isString(child)) {
	        return this.removeLabel(child);
	      }
	
	      if (_isFunction(child)) {
	        return this.killTweensOf(child);
	      }
	
	      _removeLinkedListItem(this, child);
	
	      if (child === this._recent) {
	        this._recent = this._last;
	      }
	
	      return _uncache(this);
	    };
	
	    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
	      if (!arguments.length) {
	        return this._tTime;
	      }
	
	      this._forcing = 1;
	
	      if (!this.parent && !this._dp && this._ts) {
	        this._start = _round(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
	      }
	
	      _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
	
	      this._forcing = 0;
	      return this;
	    };
	
	    _proto2.addLabel = function addLabel(label, position) {
	      this.labels[label] = _parsePosition(this, position);
	      return this;
	    };
	
	    _proto2.removeLabel = function removeLabel(label) {
	      delete this.labels[label];
	      return this;
	    };
	
	    _proto2.addPause = function addPause(position, callback, params) {
	      var t = Tween.delayedCall(0, callback || _emptyFunc, params);
	      t.data = "isPause";
	      this._hasPause = 1;
	      return _addToTimeline(this, t, _parsePosition(this, position));
	    };
	
	    _proto2.removePause = function removePause(position) {
	      var child = this._first;
	      position = _parsePosition(this, position);
	
	      while (child) {
	        if (child._start === position && child.data === "isPause") {
	          _removeFromParent(child);
	        }
	
	        child = child._next;
	      }
	    };
	
	    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
	      var tweens = this.getTweensOf(targets, onlyActive),
	          i = tweens.length;
	
	      while (i--) {
	        _overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
	      }
	
	      return this;
	    };
	
	    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
	      var a = [],
	          parsedTargets = toArray(targets),
	          child = this._first,
	          children;
	
	      while (child) {
	        if (child instanceof Tween) {
	          if (_arrayContainsAny(child._targets, parsedTargets) && (!onlyActive || child.isActive(onlyActive === "started"))) {
	            a.push(child);
	          }
	        } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) {
	          a.push.apply(a, children);
	        }
	
	        child = child._next;
	      }
	
	      return a;
	    };
	
	    _proto2.tweenTo = function tweenTo(position, vars) {
	      vars = vars || {};
	
	      var tl = this,
	          endTime = _parsePosition(tl, position),
	          _vars = vars,
	          startAt = _vars.startAt,
	          _onStart = _vars.onStart,
	          onStartParams = _vars.onStartParams,
	          tween = Tween.to(tl, _setDefaults(vars, {
	        ease: "none",
	        lazy: false,
	        time: endTime,
	        duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
	        onStart: function onStart() {
	          tl.pause();
	          var duration = vars.duration || Math.abs((endTime - tl._time) / tl.timeScale());
	          tween._dur !== duration && _setDuration(tween, duration).render(tween._time, true, true);
	          _onStart && _onStart.apply(tween, onStartParams || []);
	        }
	      }));
	
	      return tween;
	    };
	
	    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
	      return this.tweenTo(toPosition, _setDefaults({
	        startAt: {
	          time: _parsePosition(this, fromPosition)
	        }
	      }, vars));
	    };
	
	    _proto2.recent = function recent() {
	      return this._recent;
	    };
	
	    _proto2.nextLabel = function nextLabel(afterTime) {
	      if (afterTime === void 0) {
	        afterTime = this._time;
	      }
	
	      return _getLabelInDirection(this, _parsePosition(this, afterTime));
	    };
	
	    _proto2.previousLabel = function previousLabel(beforeTime) {
	      if (beforeTime === void 0) {
	        beforeTime = this._time;
	      }
	
	      return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
	    };
	
	    _proto2.currentLabel = function currentLabel(value) {
	      return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
	    };
	
	    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
	      if (ignoreBeforeTime === void 0) {
	        ignoreBeforeTime = 0;
	      }
	
	      var child = this._first,
	          labels = this.labels,
	          p;
	
	      while (child) {
	        if (child._start >= ignoreBeforeTime) {
	          child._start += amount;
	        }
	
	        child = child._next;
	      }
	
	      if (adjustLabels) {
	        for (p in labels) {
	          if (labels[p] >= ignoreBeforeTime) {
	            labels[p] += amount;
	          }
	        }
	      }
	
	      return _uncache(this);
	    };
	
	    _proto2.invalidate = function invalidate() {
	      var child = this._first;
	      this._lock = 0;
	
	      while (child) {
	        child.invalidate();
	        child = child._next;
	      }
	
	      return _Animation.prototype.invalidate.call(this);
	    };
	
	    _proto2.clear = function clear(includeLabels) {
	      if (includeLabels === void 0) {
	        includeLabels = true;
	      }
	
	      var child = this._first,
	          next;
	
	      while (child) {
	        next = child._next;
	        this.remove(child);
	        child = next;
	      }
	
	      this._time = this._tTime = this._pTime = 0;
	
	      if (includeLabels) {
	        this.labels = {};
	      }
	
	      return _uncache(this);
	    };
	
	    _proto2.totalDuration = function totalDuration(value) {
	      var max = 0,
	          self = this,
	          child = self._last,
	          prevStart = _bigNum,
	          prev,
	          end,
	          start,
	          parent;
	
	      if (arguments.length) {
	        return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
	      }
	
	      if (self._dirty) {
	        parent = self.parent;
	
	        while (child) {
	          prev = child._prev;
	          child._dirty && child.totalDuration();
	          start = child._start;
	
	          if (start > prevStart && self._sort && child._ts && !self._lock) {
	            self._lock = 1;
	            _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
	          } else {
	            prevStart = start;
	          }
	
	          if (start < 0 && child._ts) {
	            max -= start;
	
	            if (!parent && !self._dp || parent && parent.smoothChildTiming) {
	              self._start += start / self._ts;
	              self._time -= start;
	              self._tTime -= start;
	            }
	
	            self.shiftChildren(-start, false, -1e999);
	            prevStart = 0;
	          }
	
	          end = _setEnd(child);
	
	          if (end > max && child._ts) {
	            max = end;
	          }
	
	          child = prev;
	        }
	
	        _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1);
	
	        self._dirty = 0;
	      }
	
	      return self._tDur;
	    };
	
	    Timeline.updateRoot = function updateRoot(time) {
	      if (_globalTimeline._ts) {
	        _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
	
	        _lastRenderedFrame = _ticker.frame;
	      }
	
	      if (_ticker.frame >= _nextGCFrame) {
	        _nextGCFrame += _config.autoSleep || 120;
	        var child = _globalTimeline._first;
	        if (!child || !child._ts) if (_config.autoSleep && _ticker._listeners.length < 2) {
	          while (child && !child._ts) {
	            child = child._next;
	          }
	
	          child || _ticker.sleep();
	        }
	      }
	    };
	
	    return Timeline;
	  }(Animation);
	
	  _setDefaults(Timeline.prototype, {
	    _lock: 0,
	    _hasPause: 0,
	    _forcing: 0
	  });
	
	  var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
	    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter),
	        index = 0,
	        matchIndex = 0,
	        result,
	        startNums,
	        color,
	        endNum,
	        chunk,
	        startNum,
	        hasRandom,
	        a;
	    pt.b = start;
	    pt.e = end;
	    start += "";
	    end += "";
	
	    if (hasRandom = ~end.indexOf("random(")) {
	      end = _replaceRandom(end);
	    }
	
	    if (stringFilter) {
	      a = [start, end];
	      stringFilter(a, target, prop);
	      start = a[0];
	      end = a[1];
	    }
	
	    startNums = start.match(_complexStringNumExp) || [];
	
	    while (result = _complexStringNumExp.exec(end)) {
	      endNum = result[0];
	      chunk = end.substring(index, result.index);
	
	      if (color) {
	        color = (color + 1) % 5;
	      } else if (chunk.substr(-5) === "rgba(") {
	        color = 1;
	      }
	
	      if (endNum !== startNums[matchIndex++]) {
	        startNum = parseFloat(startNums[matchIndex - 1]) || 0;
	        pt._pt = {
	          _next: pt._pt,
	          p: chunk || matchIndex === 1 ? chunk : ",",
	          s: startNum,
	          c: endNum.charAt(1) === "=" ? parseFloat(endNum.substr(2)) * (endNum.charAt(0) === "-" ? -1 : 1) : parseFloat(endNum) - startNum,
	          m: color && color < 4 ? Math.round : 0
	        };
	        index = _complexStringNumExp.lastIndex;
	      }
	    }
	
	    pt.c = index < end.length ? end.substring(index, end.length) : "";
	    pt.fp = funcParam;
	
	    if (_relExp.test(end) || hasRandom) {
	      pt.e = 0;
	    }
	
	    this._pt = pt;
	    return pt;
	  },
	      _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam) {
	    _isFunction(end) && (end = end(index || 0, target, targets));
	    var currentValue = target[prop],
	        parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](),
	        setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc,
	        pt;
	
	    if (_isString(end)) {
	      if (~end.indexOf("random(")) {
	        end = _replaceRandom(end);
	      }
	
	      if (end.charAt(1) === "=") {
	        end = parseFloat(parsedStart) + parseFloat(end.substr(2)) * (end.charAt(0) === "-" ? -1 : 1) + (getUnit(parsedStart) || 0);
	      }
	    }
	
	    if (parsedStart !== end) {
	      if (!isNaN(parsedStart + end)) {
	        pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
	        funcParam && (pt.fp = funcParam);
	        modifier && pt.modifier(modifier, this, target);
	        return this._pt = pt;
	      }
	
	      !currentValue && !(prop in target) && _missingPlugin(prop, end);
	      return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
	    }
	  },
	      _processVars = function _processVars(vars, index, target, targets, tween) {
	    if (_isFunction(vars)) {
	      vars = _parseFuncOrString(vars, tween, index, target, targets);
	    }
	
	    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars)) {
	      return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
	    }
	
	    var copy = {},
	        p;
	
	    for (p in vars) {
	      copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
	    }
	
	    return copy;
	  },
	      _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
	    var plugin, pt, ptLookup, i;
	
	    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
	      tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
	
	      if (tween !== _quickTween) {
	        ptLookup = tween._ptLookup[tween._targets.indexOf(target)];
	        i = plugin._props.length;
	
	        while (i--) {
	          ptLookup[plugin._props[i]] = pt;
	        }
	      }
	    }
	
	    return plugin;
	  },
	      _overwritingTween,
	      _initTween = function _initTween(tween, time) {
	    var vars = tween.vars,
	        ease = vars.ease,
	        startAt = vars.startAt,
	        immediateRender = vars.immediateRender,
	        lazy = vars.lazy,
	        onUpdate = vars.onUpdate,
	        onUpdateParams = vars.onUpdateParams,
	        callbackScope = vars.callbackScope,
	        runBackwards = vars.runBackwards,
	        yoyoEase = vars.yoyoEase,
	        keyframes = vars.keyframes,
	        autoRevert = vars.autoRevert,
	        dur = tween._dur,
	        prevStartAt = tween._startAt,
	        targets = tween._targets,
	        parent = tween.parent,
	        fullTargets = parent && parent.data === "nested" ? parent.parent._targets : targets,
	        autoOverwrite = tween._overwrite === "auto",
	        tl = tween.timeline,
	        cleanVars,
	        i,
	        p,
	        pt,
	        target,
	        hasPriority,
	        gsData,
	        harness,
	        plugin,
	        ptLookup,
	        index,
	        harnessVars;
	    tl && (!keyframes || !ease) && (ease = "none");
	    tween._ease = _parseEase(ease, _defaults.ease);
	    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
	
	    if (yoyoEase && tween._yoyo && !tween._repeat) {
	      yoyoEase = tween._yEase;
	      tween._yEase = tween._ease;
	      tween._ease = yoyoEase;
	    }
	
	    if (!tl) {
	      harness = targets[0] ? _getCache(targets[0]).harness : 0;
	      harnessVars = harness && vars[harness.prop];
	      cleanVars = _copyExcluding(vars, _reservedProps);
	      prevStartAt && prevStartAt.render(-1, true).kill();
	
	      if (startAt) {
	        _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
	          data: "isStart",
	          overwrite: false,
	          parent: parent,
	          immediateRender: true,
	          lazy: _isNotFalse(lazy),
	          startAt: null,
	          delay: 0,
	          onUpdate: onUpdate,
	          onUpdateParams: onUpdateParams,
	          callbackScope: callbackScope,
	          stagger: 0
	        }, startAt)));
	
	        if (immediateRender) {
	          if (time > 0) {
	            !autoRevert && (tween._startAt = 0);
	          } else if (dur) {
	            return;
	          }
	        }
	      } else if (runBackwards && dur) {
	        if (prevStartAt) {
	          !autoRevert && (tween._startAt = 0);
	        } else {
	          time && (immediateRender = false);
	          p = _merge(cleanVars, {
	            overwrite: false,
	            data: "isFromStart",
	            lazy: immediateRender && _isNotFalse(lazy),
	            immediateRender: immediateRender,
	            stagger: 0,
	            parent: parent
	          });
	          harnessVars && (p[harness.prop] = harnessVars);
	
	          _removeFromParent(tween._startAt = Tween.set(targets, p));
	
	          if (!immediateRender) {
	            _initTween(tween._startAt, _tinyNum);
	          } else if (!time) {
	            return;
	          }
	        }
	      }
	
	      tween._pt = 0;
	      lazy = dur && _isNotFalse(lazy) || lazy && !dur;
	
	      for (i = 0; i < targets.length; i++) {
	        target = targets[i];
	        gsData = target._gsap || _harness(targets)[i]._gsap;
	        tween._ptLookup[i] = ptLookup = {};
	        _lazyLookup[gsData.id] && _lazyRender();
	        index = fullTargets === targets ? i : fullTargets.indexOf(target);
	
	        if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
	          tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
	
	          plugin._props.forEach(function (name) {
	            ptLookup[name] = pt;
	          });
	
	          plugin.priority && (hasPriority = 1);
	        }
	
	        if (!harness || harnessVars) {
	          for (p in cleanVars) {
	            if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) {
	              plugin.priority && (hasPriority = 1);
	            } else {
	              ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
	            }
	          }
	        }
	
	        tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
	
	        if (autoOverwrite && tween._pt) {
	          _overwritingTween = tween;
	
	          _globalTimeline.killTweensOf(target, ptLookup, "started");
	
	          _overwritingTween = 0;
	        }
	
	        tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
	      }
	
	      hasPriority && _sortPropTweensByPriority(tween);
	      tween._onInit && tween._onInit(tween);
	    }
	
	    tween._from = !tl && !!vars.runBackwards;
	    tween._onUpdate = onUpdate;
	    tween._initted = 1;
	  },
	      _addAliasesToVars = function _addAliasesToVars(targets, vars) {
	    var harness = targets[0] ? _getCache(targets[0]).harness : 0,
	        propertyAliases = harness && harness.aliases,
	        copy,
	        p,
	        i,
	        aliases;
	
	    if (!propertyAliases) {
	      return vars;
	    }
	
	    copy = _merge({}, vars);
	
	    for (p in propertyAliases) {
	      if (p in copy) {
	        aliases = propertyAliases[p].split(",");
	        i = aliases.length;
	
	        while (i--) {
	          copy[aliases[i]] = copy[p];
	        }
	      }
	    }
	
	    return copy;
	  },
	      _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
	    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
	  },
	      _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase",
	      _staggerPropsToSkip = (_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger").split(",");
	
	  var Tween = function (_Animation2) {
	    _inheritsLoose(Tween, _Animation2);
	
	    function Tween(targets, vars, time, skipInherit) {
	      var _this3;
	
	      if (typeof vars === "number") {
	        time.duration = vars;
	        vars = time;
	        time = null;
	      }
	
	      _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars), time) || this;
	      var _this3$vars = _this3.vars,
	          duration = _this3$vars.duration,
	          delay = _this3$vars.delay,
	          immediateRender = _this3$vars.immediateRender,
	          stagger = _this3$vars.stagger,
	          overwrite = _this3$vars.overwrite,
	          keyframes = _this3$vars.keyframes,
	          defaults = _this3$vars.defaults,
	          scrollTrigger = _this3$vars.scrollTrigger,
	          yoyoEase = _this3$vars.yoyoEase,
	          parent = _this3.parent,
	          parsedTargets = (_isArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [targets] : toArray(targets),
	          tl,
	          i,
	          copy,
	          l,
	          p,
	          curTarget,
	          staggerFunc,
	          staggerVarsToMerge;
	      _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://greensock.com", !_config.nullTargetWarn) || [];
	      _this3._ptLookup = [];
	      _this3._overwrite = overwrite;
	
	      if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
	        vars = _this3.vars;
	        tl = _this3.timeline = new Timeline({
	          data: "nested",
	          defaults: defaults || {}
	        });
	        tl.kill();
	        tl.parent = _assertThisInitialized(_this3);
	
	        if (keyframes) {
	          _setDefaults(tl.vars.defaults, {
	            ease: "none"
	          });
	
	          keyframes.forEach(function (frame) {
	            return tl.to(parsedTargets, frame, ">");
	          });
	        } else {
	          l = parsedTargets.length;
	          staggerFunc = stagger ? distribute(stagger) : _emptyFunc;
	
	          if (_isObject(stagger)) {
	            for (p in stagger) {
	              if (~_staggerTweenProps.indexOf(p)) {
	                staggerVarsToMerge || (staggerVarsToMerge = {});
	                staggerVarsToMerge[p] = stagger[p];
	              }
	            }
	          }
	
	          for (i = 0; i < l; i++) {
	            copy = {};
	
	            for (p in vars) {
	              if (_staggerPropsToSkip.indexOf(p) < 0) {
	                copy[p] = vars[p];
	              }
	            }
	
	            copy.stagger = 0;
	            yoyoEase && (copy.yoyoEase = yoyoEase);
	            staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
	            curTarget = parsedTargets[i];
	            copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
	            copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
	
	            if (!stagger && l === 1 && copy.delay) {
	              _this3._delay = delay = copy.delay;
	              _this3._start += delay;
	              copy.delay = 0;
	            }
	
	            tl.to(curTarget, copy, staggerFunc(i, curTarget, parsedTargets));
	          }
	
	          tl.duration() ? duration = delay = 0 : _this3.timeline = 0;
	        }
	
	        duration || _this3.duration(duration = tl.duration());
	      } else {
	        _this3.timeline = 0;
	      }
	
	      if (overwrite === true) {
	        _overwritingTween = _assertThisInitialized(_this3);
	
	        _globalTimeline.killTweensOf(parsedTargets);
	
	        _overwritingTween = 0;
	      }
	
	      parent && _postAddChecks(parent, _assertThisInitialized(_this3));
	
	      if (immediateRender || !duration && !keyframes && _this3._start === _round(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
	        _this3._tTime = -_tinyNum;
	
	        _this3.render(Math.max(0, -delay));
	      }
	
	      scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
	      return _this3;
	    }
	
	    var _proto3 = Tween.prototype;
	
	    _proto3.render = function render(totalTime, suppressEvents, force) {
	      var prevTime = this._time,
	          tDur = this._tDur,
	          dur = this._dur,
	          tTime = totalTime > tDur - _tinyNum && totalTime >= 0 ? tDur : totalTime < _tinyNum ? 0 : totalTime,
	          time,
	          pt,
	          iteration,
	          cycleDuration,
	          prevIteration,
	          isYoyo,
	          ratio,
	          timeline,
	          yoyoEase;
	
	      if (!dur) {
	        _renderZeroDurationTween(this, totalTime, suppressEvents, force);
	      } else if (tTime !== this._tTime || !totalTime || force || this._startAt && this._zTime < 0 !== totalTime < 0) {
	        time = tTime;
	        timeline = this.timeline;
	
	        if (this._repeat) {
	          cycleDuration = dur + this._rDelay;
	          time = _round(tTime % cycleDuration);
	
	          if (time > dur || tDur === tTime) {
	            time = dur;
	          }
	
	          iteration = ~~(tTime / cycleDuration);
	
	          if (iteration && iteration === tTime / cycleDuration) {
	            time = dur;
	            iteration--;
	          }
	
	          isYoyo = this._yoyo && iteration & 1;
	
	          if (isYoyo) {
	            yoyoEase = this._yEase;
	            time = dur - time;
	          }
	
	          prevIteration = _animationCycle(this._tTime, cycleDuration);
	
	          if (time === prevTime && !force && this._initted) {
	            return this;
	          }
	
	          if (iteration !== prevIteration) {
	            timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo);
	
	            if (this.vars.repeatRefresh && !isYoyo && !this._lock) {
	              this._lock = force = 1;
	              this.render(_round(cycleDuration * iteration), true).invalidate()._lock = 0;
	            }
	          }
	        }
	
	        if (!this._initted) {
	          if (_attemptInitTween(this, time, force, suppressEvents)) {
	            this._tTime = 0;
	            return this;
	          }
	
	          if (dur !== this._dur) {
	            return this.render(totalTime, suppressEvents, force);
	          }
	        }
	
	        this._tTime = tTime;
	        this._time = time;
	
	        if (!this._act && this._ts) {
	          this._act = 1;
	          this._lazy = 0;
	        }
	
	        this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
	
	        if (this._from) {
	          this.ratio = ratio = 1 - ratio;
	        }
	
	        time && !prevTime && !suppressEvents && _callback(this, "onStart");
	        pt = this._pt;
	
	        while (pt) {
	          pt.r(ratio, pt.d);
	          pt = pt._next;
	        }
	
	        timeline && timeline.render(totalTime < 0 ? totalTime : !time && isYoyo ? -_tinyNum : timeline._dur * ratio, suppressEvents, force) || this._startAt && (this._zTime = totalTime);
	
	        if (this._onUpdate && !suppressEvents) {
	          if (totalTime < 0 && this._startAt) {
	            this._startAt.render(totalTime, true, force);
	          }
	
	          _callback(this, "onUpdate");
	        }
	
	        this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
	
	        if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
	          if (totalTime < 0 && this._startAt && !this._onUpdate) {
	            this._startAt.render(totalTime, true, force);
	          }
	
	          (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1);
	
	          if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime)) {
	            _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
	
	            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
	          }
	        }
	      }
	
	      return this;
	    };
	
	    _proto3.targets = function targets() {
	      return this._targets;
	    };
	
	    _proto3.invalidate = function invalidate() {
	      this._pt = this._op = this._startAt = this._onUpdate = this._act = this._lazy = 0;
	      this._ptLookup = [];
	      this.timeline && this.timeline.invalidate();
	      return _Animation2.prototype.invalidate.call(this);
	    };
	
	    _proto3.kill = function kill(targets, vars) {
	      if (vars === void 0) {
	        vars = "all";
	      }
	
	      if (!targets && (!vars || vars === "all")) {
	        this._lazy = 0;
	
	        if (this.parent) {
	          return _interrupt(this);
	        }
	      }
	
	      if (this.timeline) {
	        var tDur = this.timeline.totalDuration();
	        this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this);
	        this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur);
	        return this;
	      }
	
	      var parsedTargets = this._targets,
	          killingTargets = targets ? toArray(targets) : parsedTargets,
	          propTweenLookup = this._ptLookup,
	          firstPT = this._pt,
	          overwrittenProps,
	          curLookup,
	          curOverwriteProps,
	          props,
	          p,
	          pt,
	          i;
	
	      if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
	        return _interrupt(this);
	      }
	
	      overwrittenProps = this._op = this._op || [];
	
	      if (vars !== "all") {
	        if (_isString(vars)) {
	          p = {};
	
	          _forEachName(vars, function (name) {
	            return p[name] = 1;
	          });
	
	          vars = p;
	        }
	
	        vars = _addAliasesToVars(parsedTargets, vars);
	      }
	
	      i = parsedTargets.length;
	
	      while (i--) {
	        if (~killingTargets.indexOf(parsedTargets[i])) {
	          curLookup = propTweenLookup[i];
	
	          if (vars === "all") {
	            overwrittenProps[i] = vars;
	            props = curLookup;
	            curOverwriteProps = {};
	          } else {
	            curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
	            props = vars;
	          }
	
	          for (p in props) {
	            pt = curLookup && curLookup[p];
	
	            if (pt) {
	              if (!("kill" in pt.d) || pt.d.kill(p) === true) {
	                _removeLinkedListItem(this, pt, "_pt");
	              }
	
	              delete curLookup[p];
	            }
	
	            if (curOverwriteProps !== "all") {
	              curOverwriteProps[p] = 1;
	            }
	          }
	        }
	      }
	
	      if (this._initted && !this._pt && firstPT) {
	        _interrupt(this);
	      }
	
	      return this;
	    };
	
	    Tween.to = function to(targets, vars) {
	      return new Tween(targets, vars, arguments[2]);
	    };
	
	    Tween.from = function from(targets, vars) {
	      return new Tween(targets, _parseVars(arguments, 1));
	    };
	
	    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
	      return new Tween(callback, 0, {
	        immediateRender: false,
	        lazy: false,
	        overwrite: false,
	        delay: delay,
	        onComplete: callback,
	        onReverseComplete: callback,
	        onCompleteParams: params,
	        onReverseCompleteParams: params,
	        callbackScope: scope
	      });
	    };
	
	    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
	      return new Tween(targets, _parseVars(arguments, 2));
	    };
	
	    Tween.set = function set(targets, vars) {
	      vars.duration = 0;
	      vars.repeatDelay || (vars.repeat = 0);
	      return new Tween(targets, vars);
	    };
	
	    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
	      return _globalTimeline.killTweensOf(targets, props, onlyActive);
	    };
	
	    return Tween;
	  }(Animation);
	
	  _setDefaults(Tween.prototype, {
	    _targets: [],
	    _lazy: 0,
	    _startAt: 0,
	    _op: 0,
	    _onInit: 0
	  });
	
	  _forEachName("staggerTo,staggerFrom,staggerFromTo", function (name) {
	    Tween[name] = function () {
	      var tl = new Timeline(),
	          params = _slice.call(arguments, 0);
	
	      params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
	      return tl[name].apply(tl, params);
	    };
	  });
	
	  var _setterPlain = function _setterPlain(target, property, value) {
	    return target[property] = value;
	  },
	      _setterFunc = function _setterFunc(target, property, value) {
	    return target[property](value);
	  },
	      _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
	    return target[property](data.fp, value);
	  },
	      _setterAttribute = function _setterAttribute(target, property, value) {
	    return target.setAttribute(property, value);
	  },
	      _getSetter = function _getSetter(target, property) {
	    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
	  },
	      _renderPlain = function _renderPlain(ratio, data) {
	    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000, data);
	  },
	      _renderBoolean = function _renderBoolean(ratio, data) {
	    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
	  },
	      _renderComplexString = function _renderComplexString(ratio, data) {
	    var pt = data._pt,
	        s = "";
	
	    if (!ratio && data.b) {
	      s = data.b;
	    } else if (ratio === 1 && data.e) {
	      s = data.e;
	    } else {
	      while (pt) {
	        s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s;
	        pt = pt._next;
	      }
	
	      s += data.c;
	    }
	
	    data.set(data.t, data.p, s, data);
	  },
	      _renderPropTweens = function _renderPropTweens(ratio, data) {
	    var pt = data._pt;
	
	    while (pt) {
	      pt.r(ratio, pt.d);
	      pt = pt._next;
	    }
	  },
	      _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
	    var pt = this._pt,
	        next;
	
	    while (pt) {
	      next = pt._next;
	
	      if (pt.p === property) {
	        pt.modifier(modifier, tween, target);
	      }
	
	      pt = next;
	    }
	  },
	      _killPropTweensOf = function _killPropTweensOf(property) {
	    var pt = this._pt,
	        hasNonDependentRemaining,
	        next;
	
	    while (pt) {
	      next = pt._next;
	
	      if (pt.p === property && !pt.op || pt.op === property) {
	        _removeLinkedListItem(this, pt, "_pt");
	      } else if (!pt.dep) {
	        hasNonDependentRemaining = 1;
	      }
	
	      pt = next;
	    }
	
	    return !hasNonDependentRemaining;
	  },
	      _setterWithModifier = function _setterWithModifier(target, property, value, data) {
	    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
	  },
	      _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
	    var pt = parent._pt,
	        next,
	        pt2,
	        first,
	        last;
	
	    while (pt) {
	      next = pt._next;
	      pt2 = first;
	
	      while (pt2 && pt2.pr > pt.pr) {
	        pt2 = pt2._next;
	      }
	
	      if (pt._prev = pt2 ? pt2._prev : last) {
	        pt._prev._next = pt;
	      } else {
	        first = pt;
	      }
	
	      if (pt._next = pt2) {
	        pt2._prev = pt;
	      } else {
	        last = pt;
	      }
	
	      pt = next;
	    }
	
	    parent._pt = first;
	  };
	
	  var PropTween = function () {
	    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
	      this.t = target;
	      this.s = start;
	      this.c = change;
	      this.p = prop;
	      this.r = renderer || _renderPlain;
	      this.d = data || this;
	      this.set = setter || _setterPlain;
	      this.pr = priority || 0;
	      this._next = next;
	
	      if (next) {
	        next._prev = this;
	      }
	    }
	
	    var _proto4 = PropTween.prototype;
	
	    _proto4.modifier = function modifier(func, tween, target) {
	      this.mSet = this.mSet || this.set;
	      this.set = _setterWithModifier;
	      this.m = func;
	      this.mt = target;
	      this.tween = tween;
	    };
	
	    return PropTween;
	  }();
	
	  _forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function (name) {
	    return _reservedProps[name] = 1;
	  });
	
	  _globals.TweenMax = _globals.TweenLite = Tween;
	  _globals.TimelineLite = _globals.TimelineMax = Timeline;
	  _globalTimeline = new Timeline({
	    sortChildren: false,
	    defaults: _defaults,
	    autoRemoveChildren: true,
	    id: "root",
	    smoothChildTiming: true
	  });
	  _config.stringFilter = _colorStringFilter;
	  var _gsap = {
	    registerPlugin: function registerPlugin() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      args.forEach(function (config) {
	        return _createPlugin(config);
	      });
	    },
	    timeline: function timeline(vars) {
	      return new Timeline(vars);
	    },
	    getTweensOf: function getTweensOf(targets, onlyActive) {
	      return _globalTimeline.getTweensOf(targets, onlyActive);
	    },
	    getProperty: function getProperty(target, property, unit, uncache) {
	      if (_isString(target)) {
	        target = toArray(target)[0];
	      }
	
	      var getter = _getCache(target || {}).get,
	          format = unit ? _passThrough : _numericIfPossible;
	
	      if (unit === "native") {
	        unit = "";
	      }
	
	      return !target ? target : !property ? function (property, unit, uncache) {
	        return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
	      } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
	    },
	    quickSetter: function quickSetter(target, property, unit) {
	      target = toArray(target);
	
	      if (target.length > 1) {
	        var setters = target.map(function (t) {
	          return gsap.quickSetter(t, property, unit);
	        }),
	            l = setters.length;
	        return function (value) {
	          var i = l;
	
	          while (i--) {
	            setters[i](value);
	          }
	        };
	      }
	
	      target = target[0] || {};
	
	      var Plugin = _plugins[property],
	          cache = _getCache(target),
	          p = cache.harness && (cache.harness.aliases || {})[property] || property,
	          setter = Plugin ? function (value) {
	        var p = new Plugin();
	        _quickTween._pt = 0;
	        p.init(target, unit ? value + unit : value, _quickTween, 0, [target]);
	        p.render(1, p);
	        _quickTween._pt && _renderPropTweens(1, _quickTween);
	      } : cache.set(target, p);
	
	      return Plugin ? setter : function (value) {
	        return setter(target, p, unit ? value + unit : value, cache, 1);
	      };
	    },
	    isTweening: function isTweening(targets) {
	      return _globalTimeline.getTweensOf(targets, true).length > 0;
	    },
	    defaults: function defaults(value) {
	      if (value && value.ease) {
	        value.ease = _parseEase(value.ease, _defaults.ease);
	      }
	
	      return _mergeDeep(_defaults, value || {});
	    },
	    config: function config(value) {
	      return _mergeDeep(_config, value || {});
	    },
	    registerEffect: function registerEffect(_ref) {
	      var name = _ref.name,
	          effect = _ref.effect,
	          plugins = _ref.plugins,
	          defaults = _ref.defaults,
	          extendTimeline = _ref.extendTimeline;
	      (plugins || "").split(",").forEach(function (pluginName) {
	        return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
	      });
	
	      _effects[name] = function (targets, vars, tl) {
	        return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
	      };
	
	      if (extendTimeline) {
	        Timeline.prototype[name] = function (targets, vars, position) {
	          return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
	        };
	      }
	    },
	    registerEase: function registerEase(name, ease) {
	      _easeMap[name] = _parseEase(ease);
	    },
	    parseEase: function parseEase(ease, defaultEase) {
	      return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
	    },
	    getById: function getById(id) {
	      return _globalTimeline.getById(id);
	    },
	    exportRoot: function exportRoot(vars, includeDelayedCalls) {
	      if (vars === void 0) {
	        vars = {};
	      }
	
	      var tl = new Timeline(vars),
	          child,
	          next;
	      tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
	
	      _globalTimeline.remove(tl);
	
	      tl._dp = 0;
	      tl._time = tl._tTime = _globalTimeline._time;
	      child = _globalTimeline._first;
	
	      while (child) {
	        next = child._next;
	
	        if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) {
	          _addToTimeline(tl, child, child._start - child._delay);
	        }
	
	        child = next;
	      }
	
	      _addToTimeline(_globalTimeline, tl, 0);
	
	      return tl;
	    },
	    utils: {
	      wrap: wrap,
	      wrapYoyo: wrapYoyo,
	      distribute: distribute,
	      random: random,
	      snap: snap,
	      normalize: normalize,
	      getUnit: getUnit,
	      clamp: clamp,
	      splitColor: splitColor,
	      toArray: toArray,
	      mapRange: mapRange,
	      pipe: pipe,
	      unitize: unitize,
	      interpolate: interpolate,
	      shuffle: shuffle
	    },
	    install: _install,
	    effects: _effects,
	    ticker: _ticker,
	    updateRoot: Timeline.updateRoot,
	    plugins: _plugins,
	    globalTimeline: _globalTimeline,
	    core: {
	      PropTween: PropTween,
	      globals: _addGlobal,
	      Tween: Tween,
	      Timeline: Timeline,
	      Animation: Animation,
	      getCache: _getCache,
	      _removeLinkedListItem: _removeLinkedListItem
	    }
	  };
	
	  _forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function (name) {
	    return _gsap[name] = Tween[name];
	  });
	
	  _ticker.add(Timeline.updateRoot);
	
	  _quickTween = _gsap.to({}, {
	    duration: 0
	  });
	
	  var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
	    var pt = plugin._pt;
	
	    while (pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop) {
	      pt = pt._next;
	    }
	
	    return pt;
	  },
	      _addModifiers = function _addModifiers(tween, modifiers) {
	    var targets = tween._targets,
	        p,
	        i,
	        pt;
	
	    for (p in modifiers) {
	      i = targets.length;
	
	      while (i--) {
	        pt = tween._ptLookup[i][p];
	
	        if (pt && (pt = pt.d)) {
	          if (pt._pt) {
	            pt = _getPluginPropTween(pt, p);
	          }
	
	          pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
	        }
	      }
	    }
	  },
	      _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
	    return {
	      name: name,
	      rawVars: 1,
	      init: function init(target, vars, tween) {
	        tween._onInit = function (tween) {
	          var temp, p;
	
	          if (_isString(vars)) {
	            temp = {};
	
	            _forEachName(vars, function (name) {
	              return temp[name] = 1;
	            });
	
	            vars = temp;
	          }
	
	          if (modifier) {
	            temp = {};
	
	            for (p in vars) {
	              temp[p] = modifier(vars[p]);
	            }
	
	            vars = temp;
	          }
	
	          _addModifiers(tween, vars);
	        };
	      }
	    };
	  };
	
	  var gsap = _gsap.registerPlugin({
	    name: "attr",
	    init: function init(target, vars, tween, index, targets) {
	      var p, pt;
	
	      for (p in vars) {
	        pt = this.add(target, "setAttribute", (target.getAttribute(p) || 0) + "", vars[p], index, targets, 0, 0, p);
	        pt && (pt.op = p);
	
	        this._props.push(p);
	      }
	    }
	  }, {
	    name: "endArray",
	    init: function init(target, value) {
	      var i = value.length;
	
	      while (i--) {
	        this.add(target, i, target[i] || 0, value[i]);
	      }
	    }
	  }, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap;
	  Tween.version = Timeline.version = gsap.version = "3.3.1";
	  _coreReady = 1;
	
	  if (_windowExists()) {
	    _wake();
	  }
	
	  var Power0 = _easeMap.Power0,
	      Power1 = _easeMap.Power1,
	      Power2 = _easeMap.Power2,
	      Power3 = _easeMap.Power3,
	      Power4 = _easeMap.Power4,
	      Linear = _easeMap.Linear,
	      Quad = _easeMap.Quad,
	      Cubic = _easeMap.Cubic,
	      Quart = _easeMap.Quart,
	      Quint = _easeMap.Quint,
	      Strong = _easeMap.Strong,
	      Elastic = _easeMap.Elastic,
	      Back = _easeMap.Back,
	      SteppedEase = _easeMap.SteppedEase,
	      Bounce = _easeMap.Bounce,
	      Sine = _easeMap.Sine,
	      Expo = _easeMap.Expo,
	      Circ = _easeMap.Circ;
	
	  var _win$1,
	      _doc$1,
	      _docElement,
	      _pluginInitted,
	      _tempDiv,
	      _tempDivStyler,
	      _recentSetterPlugin,
	      _windowExists$1 = function _windowExists() {
	    return typeof window !== "undefined";
	  },
	      _transformProps = {},
	      _RAD2DEG = 180 / Math.PI,
	      _DEG2RAD = Math.PI / 180,
	      _atan2 = Math.atan2,
	      _bigNum$1 = 1e8,
	      _capsExp = /([A-Z])/g,
	      _horizontalExp = /(?:left|right|width|margin|padding|x)/i,
	      _complexExp = /[\s,\(]\S/,
	      _propertyAliases = {
	    autoAlpha: "opacity,visibility",
	    scale: "scaleX,scaleY",
	    alpha: "opacity"
	  },
	      _renderCSSProp = function _renderCSSProp(ratio, data) {
	    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
	  },
	      _renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
	    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
	  },
	      _renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
	    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
	  },
	      _renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
	    var value = data.s + data.c * ratio;
	    data.set(data.t, data.p, ~~(value + (value < 0 ? -.5 : .5)) + data.u, data);
	  },
	      _renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
	    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
	  },
	      _renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
	    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
	  },
	      _setterCSSStyle = function _setterCSSStyle(target, property, value) {
	    return target.style[property] = value;
	  },
	      _setterCSSProp = function _setterCSSProp(target, property, value) {
	    return target.style.setProperty(property, value);
	  },
	      _setterTransform = function _setterTransform(target, property, value) {
	    return target._gsap[property] = value;
	  },
	      _setterScale = function _setterScale(target, property, value) {
	    return target._gsap.scaleX = target._gsap.scaleY = value;
	  },
	      _setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
	    var cache = target._gsap;
	    cache.scaleX = cache.scaleY = value;
	    cache.renderTransform(ratio, cache);
	  },
	      _setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
	    var cache = target._gsap;
	    cache[property] = value;
	    cache.renderTransform(ratio, cache);
	  },
	      _transformProp = "transform",
	      _transformOriginProp = _transformProp + "Origin",
	      _supports3D,
	      _createElement = function _createElement(type, ns) {
	    var e = _doc$1.createElementNS ? _doc$1.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : _doc$1.createElement(type);
	    return e.style ? e : _doc$1.createElement(type);
	  },
	      _getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
	    var cs = getComputedStyle(target);
	    return cs[property] || cs.getPropertyValue(property.replace(_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, _checkPropPrefix(property) || property, 1) || "";
	  },
	      _prefixes = "O,Moz,ms,Ms,Webkit".split(","),
	      _checkPropPrefix = function _checkPropPrefix(property, element, preferPrefix) {
	    var e = element || _tempDiv,
	        s = e.style,
	        i = 5;
	
	    if (property in s && !preferPrefix) {
	      return property;
	    }
	
	    property = property.charAt(0).toUpperCase() + property.substr(1);
	
	    while (i-- && !(_prefixes[i] + property in s)) {}
	
	    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? _prefixes[i] : "") + property;
	  },
	      _initCore = function _initCore() {
	    if (_windowExists$1() && window.document) {
	      _win$1 = window;
	      _doc$1 = _win$1.document;
	      _docElement = _doc$1.documentElement;
	      _tempDiv = _createElement("div") || {
	        style: {}
	      };
	      _tempDivStyler = _createElement("div");
	      _transformProp = _checkPropPrefix(_transformProp);
	      _transformOriginProp = _checkPropPrefix(_transformOriginProp);
	      _tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0";
	      _supports3D = !!_checkPropPrefix("perspective");
	      _pluginInitted = 1;
	    }
	  },
	      _getBBoxHack = function _getBBoxHack(swapIfPossible) {
	    var svg = _createElement("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"),
	        oldParent = this.parentNode,
	        oldSibling = this.nextSibling,
	        oldCSS = this.style.cssText,
	        bbox;
	
	    _docElement.appendChild(svg);
	
	    svg.appendChild(this);
	    this.style.display = "block";
	
	    if (swapIfPossible) {
	      try {
	        bbox = this.getBBox();
	        this._gsapBBox = this.getBBox;
	        this.getBBox = _getBBoxHack;
	      } catch (e) {}
	    } else if (this._gsapBBox) {
	      bbox = this._gsapBBox();
	    }
	
	    if (oldParent) {
	      if (oldSibling) {
	        oldParent.insertBefore(this, oldSibling);
	      } else {
	        oldParent.appendChild(this);
	      }
	    }
	
	    _docElement.removeChild(svg);
	
	    this.style.cssText = oldCSS;
	    return bbox;
	  },
	      _getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
	    var i = attributesArray.length;
	
	    while (i--) {
	      if (target.hasAttribute(attributesArray[i])) {
	        return target.getAttribute(attributesArray[i]);
	      }
	    }
	  },
	      _getBBox = function _getBBox(target) {
	    var bounds;
	
	    try {
	      bounds = target.getBBox();
	    } catch (error) {
	      bounds = _getBBoxHack.call(target, true);
	    }
	
	    bounds && (bounds.width || bounds.height) || target.getBBox === _getBBoxHack || (bounds = _getBBoxHack.call(target, true));
	    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
	      x: +_getAttributeFallbacks(target, ["x", "cx", "x1"]) || 0,
	      y: +_getAttributeFallbacks(target, ["y", "cy", "y1"]) || 0,
	      width: 0,
	      height: 0
	    } : bounds;
	  },
	      _isSVG = function _isSVG(e) {
	    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && _getBBox(e));
	  },
	      _removeProperty = function _removeProperty(target, property) {
	    if (property) {
	      var style = target.style;
	
	      if (property in _transformProps) {
	        property = _transformProp;
	      }
	
	      if (style.removeProperty) {
	        if (property.substr(0, 2) === "ms" || property.substr(0, 6) === "webkit") {
	          property = "-" + property;
	        }
	
	        style.removeProperty(property.replace(_capsExp, "-$1").toLowerCase());
	      } else {
	        style.removeAttribute(property);
	      }
	    }
	  },
	      _addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
	    var pt = new PropTween(plugin._pt, target, property, 0, 1, onlySetAtEnd ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue);
	    plugin._pt = pt;
	    pt.b = beginning;
	    pt.e = end;
	
	    plugin._props.push(property);
	
	    return pt;
	  },
	      _nonConvertibleUnits = {
	    deg: 1,
	    rad: 1,
	    turn: 1
	  },
	      _convertToUnit = function _convertToUnit(target, property, value, unit) {
	    var curValue = parseFloat(value) || 0,
	        curUnit = (value + "").trim().substr((curValue + "").length) || "px",
	        style = _tempDiv.style,
	        horizontal = _horizontalExp.test(property),
	        isRootSVG = target.tagName.toLowerCase() === "svg",
	        measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"),
	        amount = 100,
	        toPixels = unit === "px",
	        toPercent = unit === "%",
	        px,
	        parent,
	        cache,
	        isSVG;
	
	    if (unit === curUnit || !curValue || _nonConvertibleUnits[unit] || _nonConvertibleUnits[curUnit]) {
	      return curValue;
	    }
	
	    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
	    isSVG = target.getCTM && _isSVG(target);
	
	    if (toPercent && (_transformProps[property] || ~property.indexOf("adius"))) {
	      return _round(curValue / (isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty]) * amount);
	    }
	
	    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
	    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
	
	    if (isSVG) {
	      parent = (target.ownerSVGElement || {}).parentNode;
	    }
	
	    if (!parent || parent === _doc$1 || !parent.appendChild) {
	      parent = _doc$1.body;
	    }
	
	    cache = parent._gsap;
	
	    if (cache && toPercent && cache.width && horizontal && cache.time === _ticker.time) {
	      return _round(curValue / cache.width * amount);
	    } else {
	      (toPercent || curUnit === "%") && (style.position = _getComputedProperty(target, "position"));
	      parent === target && (style.position = "static");
	      parent.appendChild(_tempDiv);
	      px = _tempDiv[measureProperty];
	      parent.removeChild(_tempDiv);
	      style.position = "absolute";
	
	      if (horizontal && toPercent) {
	        cache = _getCache(parent);
	        cache.time = _ticker.time;
	        cache.width = parent[measureProperty];
	      }
	    }
	
	    return _round(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
	  },
	      _get = function _get(target, property, unit, uncache) {
	    var value;
	
	    if (!_pluginInitted) {
	      _initCore();
	    }
	
	    if (property in _propertyAliases && property !== "transform") {
	      property = _propertyAliases[property];
	
	      if (~property.indexOf(",")) {
	        property = property.split(",")[0];
	      }
	    }
	
	    if (_transformProps[property] && property !== "transform") {
	      value = _parseTransform(target, uncache);
	      value = property !== "transformOrigin" ? value[property] : _firstTwoOnly(_getComputedProperty(target, _transformOriginProp)) + " " + value.zOrigin + "px";
	    } else {
	      value = target.style[property];
	
	      if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) {
	        value = _specialProps[property] && _specialProps[property](target, property, unit) || _getComputedProperty(target, property) || _getProperty(target, property) || (property === "opacity" ? 1 : 0);
	      }
	    }
	
	    return unit && !~(value + "").indexOf(" ") ? _convertToUnit(target, property, value, unit) + unit : value;
	  },
	      _tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
	    if (!start || start === "none") {
	      var p = _checkPropPrefix(prop, target, 1),
	          s = p && _getComputedProperty(target, p, 1);
	
	      if (s && s !== start) {
	        prop = p;
	        start = s;
	      }
	    }
	
	    var pt = new PropTween(this._pt, target.style, prop, 0, 1, _renderComplexString),
	        index = 0,
	        matchIndex = 0,
	        a,
	        result,
	        startValues,
	        startNum,
	        color,
	        startValue,
	        endValue,
	        endNum,
	        chunk,
	        endUnit,
	        startUnit,
	        relative,
	        endValues;
	    pt.b = start;
	    pt.e = end;
	    start += "";
	    end += "";
	
	    if (end === "auto") {
	      target.style[prop] = end;
	      end = _getComputedProperty(target, prop) || end;
	      target.style[prop] = start;
	    }
	
	    a = [start, end];
	
	    _colorStringFilter(a);
	
	    start = a[0];
	    end = a[1];
	    startValues = start.match(_numWithUnitExp) || [];
	    endValues = end.match(_numWithUnitExp) || [];
	
	    if (endValues.length) {
	      while (result = _numWithUnitExp.exec(end)) {
	        endValue = result[0];
	        chunk = end.substring(index, result.index);
	
	        if (color) {
	          color = (color + 1) % 5;
	        } else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") {
	          color = 1;
	        }
	
	        if (endValue !== (startValue = startValues[matchIndex++] || "")) {
	          startNum = parseFloat(startValue) || 0;
	          startUnit = startValue.substr((startNum + "").length);
	          relative = endValue.charAt(1) === "=" ? +(endValue.charAt(0) + "1") : 0;
	
	          if (relative) {
	            endValue = endValue.substr(2);
	          }
	
	          endNum = parseFloat(endValue);
	          endUnit = endValue.substr((endNum + "").length);
	          index = _numWithUnitExp.lastIndex - endUnit.length;
	
	          if (!endUnit) {
	            endUnit = endUnit || _config.units[prop] || startUnit;
	
	            if (index === end.length) {
	              end += endUnit;
	              pt.e += endUnit;
	            }
	          }
	
	          if (startUnit !== endUnit) {
	            startNum = _convertToUnit(target, prop, startValue, endUnit) || 0;
	          }
	
	          pt._pt = {
	            _next: pt._pt,
	            p: chunk || matchIndex === 1 ? chunk : ",",
	            s: startNum,
	            c: relative ? relative * endNum : endNum - startNum,
	            m: color && color < 4 ? Math.round : 0
	          };
	        }
	      }
	
	      pt.c = index < end.length ? end.substring(index, end.length) : "";
	    } else {
	      pt.r = prop === "display" && end === "none" ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue;
	    }
	
	    if (_relExp.test(end)) {
	      pt.e = 0;
	    }
	
	    this._pt = pt;
	    return pt;
	  },
	      _keywordToPercent = {
	    top: "0%",
	    bottom: "100%",
	    left: "0%",
	    right: "100%",
	    center: "50%"
	  },
	      _convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
	    var split = value.split(" "),
	        x = split[0],
	        y = split[1] || "50%";
	
	    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
	      value = x;
	      x = y;
	      y = value;
	    }
	
	    split[0] = _keywordToPercent[x] || x;
	    split[1] = _keywordToPercent[y] || y;
	    return split.join(" ");
	  },
	      _renderClearProps = function _renderClearProps(ratio, data) {
	    if (data.tween && data.tween._time === data.tween._dur) {
	      var target = data.t,
	          style = target.style,
	          props = data.u,
	          cache = target._gsap,
	          prop,
	          clearTransforms,
	          i;
	
	      if (props === "all" || props === true) {
	        style.cssText = "";
	        clearTransforms = 1;
	      } else {
	        props = props.split(",");
	        i = props.length;
	
	        while (--i > -1) {
	          prop = props[i];
	
	          if (_transformProps[prop]) {
	            clearTransforms = 1;
	            prop = prop === "transformOrigin" ? _transformOriginProp : _transformProp;
	          }
	
	          _removeProperty(target, prop);
	        }
	      }
	
	      if (clearTransforms) {
	        _removeProperty(target, _transformProp);
	
	        if (cache) {
	          cache.svg && target.removeAttribute("transform");
	
	          _parseTransform(target, 1);
	
	          cache.uncache = 1;
	        }
	      }
	    }
	  },
	      _specialProps = {
	    clearProps: function clearProps(plugin, target, property, endValue, tween) {
	      if (tween.data !== "isFromStart") {
	        var pt = plugin._pt = new PropTween(plugin._pt, target, property, 0, 0, _renderClearProps);
	        pt.u = endValue;
	        pt.pr = -10;
	        pt.tween = tween;
	
	        plugin._props.push(property);
	
	        return 1;
	      }
	    }
	  },
	      _identity2DMatrix = [1, 0, 0, 1, 0, 0],
	      _rotationalProperties = {},
	      _isNullTransform = function _isNullTransform(value) {
	    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
	  },
	      _getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
	    var matrixString = _getComputedProperty(target, _transformProp);
	
	    return _isNullTransform(matrixString) ? _identity2DMatrix : matrixString.substr(7).match(_numExp).map(_round);
	  },
	      _getMatrix = function _getMatrix(target, force2D) {
	    var cache = target._gsap || _getCache(target),
	        style = target.style,
	        matrix = _getComputedTransformMatrixAsArray(target),
	        parent,
	        nextSibling,
	        temp,
	        addedToDOM;
	
	    if (cache.svg && target.getAttribute("transform")) {
	      temp = target.transform.baseVal.consolidate().matrix;
	      matrix = [temp.a, temp.b, temp.c, temp.d, temp.e, temp.f];
	      return matrix.join(",") === "1,0,0,1,0,0" ? _identity2DMatrix : matrix;
	    } else if (matrix === _identity2DMatrix && !target.offsetParent && target !== _docElement && !cache.svg) {
	      temp = style.display;
	      style.display = "block";
	      parent = target.parentNode;
	
	      if (!parent || !_doc$1.body.contains(target)) {
	        addedToDOM = 1;
	        nextSibling = target.nextSibling;
	
	        _docElement.appendChild(target);
	      }
	
	      matrix = _getComputedTransformMatrixAsArray(target);
	
	      if (temp) {
	        style.display = temp;
	      } else {
	        _removeProperty(target, "display");
	      }
	
	      if (addedToDOM) {
	        if (nextSibling) {
	          parent.insertBefore(target, nextSibling);
	        } else if (parent) {
	          parent.appendChild(target);
	        } else {
	          _docElement.removeChild(target);
	        }
	      }
	    }
	
	    return force2D && matrix.length > 6 ? [matrix[0], matrix[1], matrix[4], matrix[5], matrix[12], matrix[13]] : matrix;
	  },
	      _applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
	    var cache = target._gsap,
	        matrix = matrixArray || _getMatrix(target, true),
	        xOriginOld = cache.xOrigin || 0,
	        yOriginOld = cache.yOrigin || 0,
	        xOffsetOld = cache.xOffset || 0,
	        yOffsetOld = cache.yOffset || 0,
	        a = matrix[0],
	        b = matrix[1],
	        c = matrix[2],
	        d = matrix[3],
	        tx = matrix[4],
	        ty = matrix[5],
	        originSplit = origin.split(" "),
	        xOrigin = parseFloat(originSplit[0]) || 0,
	        yOrigin = parseFloat(originSplit[1]) || 0,
	        bounds,
	        determinant,
	        x,
	        y;
	
	    if (!originIsAbsolute) {
	      bounds = _getBBox(target);
	      xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
	      yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin);
	    } else if (matrix !== _identity2DMatrix && (determinant = a * d - b * c)) {
	      x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
	      y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
	      xOrigin = x;
	      yOrigin = y;
	    }
	
	    if (smooth || smooth !== false && cache.smooth) {
	      tx = xOrigin - xOriginOld;
	      ty = yOrigin - yOriginOld;
	      cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
	      cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
	    } else {
	      cache.xOffset = cache.yOffset = 0;
	    }
	
	    cache.xOrigin = xOrigin;
	    cache.yOrigin = yOrigin;
	    cache.smooth = !!smooth;
	    cache.origin = origin;
	    cache.originIsAbsolute = !!originIsAbsolute;
	    target.style[_transformOriginProp] = "0px 0px";
	
	    if (pluginToAddPropTweensTo) {
	      _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
	
	      _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
	
	      _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
	
	      _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
	    }
	
	    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
	  },
	      _parseTransform = function _parseTransform(target, uncache) {
	    var cache = target._gsap || new GSCache(target);
	
	    if ("x" in cache && !uncache && !cache.uncache) {
	      return cache;
	    }
	
	    var style = target.style,
	        invertedScaleX = cache.scaleX < 0,
	        px = "px",
	        deg = "deg",
	        origin = _getComputedProperty(target, _transformOriginProp) || "0",
	        x,
	        y,
	        z,
	        scaleX,
	        scaleY,
	        rotation,
	        rotationX,
	        rotationY,
	        skewX,
	        skewY,
	        perspective,
	        xOrigin,
	        yOrigin,
	        matrix,
	        angle,
	        cos,
	        sin,
	        a,
	        b,
	        c,
	        d,
	        a12,
	        a22,
	        t1,
	        t2,
	        t3,
	        a13,
	        a23,
	        a33,
	        a42,
	        a43,
	        a32;
	    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
	    scaleX = scaleY = 1;
	    cache.svg = !!(target.getCTM && _isSVG(target));
	    matrix = _getMatrix(target, cache.svg);
	
	    if (cache.svg) {
	      t1 = !cache.uncache && target.getAttribute("data-svg-origin");
	
	      _applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
	    }
	
	    xOrigin = cache.xOrigin || 0;
	    yOrigin = cache.yOrigin || 0;
	
	    if (matrix !== _identity2DMatrix) {
	      a = matrix[0];
	      b = matrix[1];
	      c = matrix[2];
	      d = matrix[3];
	      x = a12 = matrix[4];
	      y = a22 = matrix[5];
	
	      if (matrix.length === 6) {
	        scaleX = Math.sqrt(a * a + b * b);
	        scaleY = Math.sqrt(d * d + c * c);
	        rotation = a || b ? _atan2(b, a) * _RAD2DEG : 0;
	        skewX = c || d ? _atan2(c, d) * _RAD2DEG + rotation : 0;
	        skewX && (scaleY *= Math.cos(skewX * _DEG2RAD));
	
	        if (cache.svg) {
	          x -= xOrigin - (xOrigin * a + yOrigin * c);
	          y -= yOrigin - (xOrigin * b + yOrigin * d);
	        }
	      } else {
	        a32 = matrix[6];
	        a42 = matrix[7];
	        a13 = matrix[8];
	        a23 = matrix[9];
	        a33 = matrix[10];
	        a43 = matrix[11];
	        x = matrix[12];
	        y = matrix[13];
	        z = matrix[14];
	        angle = _atan2(a32, a33);
	        rotationX = angle * _RAD2DEG;
	
	        if (angle) {
	          cos = Math.cos(-angle);
	          sin = Math.sin(-angle);
	          t1 = a12 * cos + a13 * sin;
	          t2 = a22 * cos + a23 * sin;
	          t3 = a32 * cos + a33 * sin;
	          a13 = a12 * -sin + a13 * cos;
	          a23 = a22 * -sin + a23 * cos;
	          a33 = a32 * -sin + a33 * cos;
	          a43 = a42 * -sin + a43 * cos;
	          a12 = t1;
	          a22 = t2;
	          a32 = t3;
	        }
	
	        angle = _atan2(-c, a33);
	        rotationY = angle * _RAD2DEG;
	
	        if (angle) {
	          cos = Math.cos(-angle);
	          sin = Math.sin(-angle);
	          t1 = a * cos - a13 * sin;
	          t2 = b * cos - a23 * sin;
	          t3 = c * cos - a33 * sin;
	          a43 = d * sin + a43 * cos;
	          a = t1;
	          b = t2;
	          c = t3;
	        }
	
	        angle = _atan2(b, a);
	        rotation = angle * _RAD2DEG;
	
	        if (angle) {
	          cos = Math.cos(angle);
	          sin = Math.sin(angle);
	          t1 = a * cos + b * sin;
	          t2 = a12 * cos + a22 * sin;
	          b = b * cos - a * sin;
	          a22 = a22 * cos - a12 * sin;
	          a = t1;
	          a12 = t2;
	        }
	
	        if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
	          rotationX = rotation = 0;
	          rotationY = 180 - rotationY;
	        }
	
	        scaleX = _round(Math.sqrt(a * a + b * b + c * c));
	        scaleY = _round(Math.sqrt(a22 * a22 + a32 * a32));
	        angle = _atan2(a12, a22);
	        skewX = Math.abs(angle) > 0.0002 ? angle * _RAD2DEG : 0;
	        perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
	      }
	
	      if (cache.svg) {
	        t1 = target.getAttribute("transform");
	        cache.forceCSS = target.setAttribute("transform", "") || !_isNullTransform(_getComputedProperty(target, _transformProp));
	        t1 && target.setAttribute("transform", t1);
	      }
	    }
	
	    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
	      if (invertedScaleX) {
	        scaleX *= -1;
	        skewX += rotation <= 0 ? 180 : -180;
	        rotation += rotation <= 0 ? 180 : -180;
	      } else {
	        scaleY *= -1;
	        skewX += skewX <= 0 ? 180 : -180;
	      }
	    }
	
	    cache.x = ((cache.xPercent = x && Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0) ? 0 : x) + px;
	    cache.y = ((cache.yPercent = y && Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0) ? 0 : y) + px;
	    cache.z = z + px;
	    cache.scaleX = _round(scaleX);
	    cache.scaleY = _round(scaleY);
	    cache.rotation = _round(rotation) + deg;
	    cache.rotationX = _round(rotationX) + deg;
	    cache.rotationY = _round(rotationY) + deg;
	    cache.skewX = skewX + deg;
	    cache.skewY = skewY + deg;
	    cache.transformPerspective = perspective + px;
	
	    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || 0) {
	      style[_transformOriginProp] = _firstTwoOnly(origin);
	    }
	
	    cache.xOffset = cache.yOffset = 0;
	    cache.force3D = _config.force3D;
	    cache.renderTransform = cache.svg ? _renderSVGTransforms : _supports3D ? _renderCSSTransforms : _renderNon3DTransforms;
	    cache.uncache = 0;
	    return cache;
	  },
	      _firstTwoOnly = function _firstTwoOnly(value) {
	    return (value = value.split(" "))[0] + " " + value[1];
	  },
	      _addPxTranslate = function _addPxTranslate(target, start, value) {
	    var unit = getUnit(start);
	    return _round(parseFloat(start) + parseFloat(_convertToUnit(target, "x", value + "px", unit))) + unit;
	  },
	      _renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
	    cache.z = "0px";
	    cache.rotationY = cache.rotationX = "0deg";
	    cache.force3D = 0;
	
	    _renderCSSTransforms(ratio, cache);
	  },
	      _zeroDeg = "0deg",
	      _zeroPx = "0px",
	      _endParenthesis = ") ",
	      _renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
	    var _ref = cache || this,
	        xPercent = _ref.xPercent,
	        yPercent = _ref.yPercent,
	        x = _ref.x,
	        y = _ref.y,
	        z = _ref.z,
	        rotation = _ref.rotation,
	        rotationY = _ref.rotationY,
	        rotationX = _ref.rotationX,
	        skewX = _ref.skewX,
	        skewY = _ref.skewY,
	        scaleX = _ref.scaleX,
	        scaleY = _ref.scaleY,
	        transformPerspective = _ref.transformPerspective,
	        force3D = _ref.force3D,
	        target = _ref.target,
	        zOrigin = _ref.zOrigin,
	        transforms = "",
	        use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true;
	
	    if (zOrigin && (rotationX !== _zeroDeg || rotationY !== _zeroDeg)) {
	      var angle = parseFloat(rotationY) * _DEG2RAD,
	          a13 = Math.sin(angle),
	          a33 = Math.cos(angle),
	          cos;
	
	      angle = parseFloat(rotationX) * _DEG2RAD;
	      cos = Math.cos(angle);
	      x = _addPxTranslate(target, x, a13 * cos * -zOrigin);
	      y = _addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
	      z = _addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
	    }
	
	    if (transformPerspective !== _zeroPx) {
	      transforms += "perspective(" + transformPerspective + _endParenthesis;
	    }
	
	    if (xPercent || yPercent) {
	      transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
	    }
	
	    if (use3D || x !== _zeroPx || y !== _zeroPx || z !== _zeroPx) {
	      transforms += z !== _zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + _endParenthesis;
	    }
	
	    if (rotation !== _zeroDeg) {
	      transforms += "rotate(" + rotation + _endParenthesis;
	    }
	
	    if (rotationY !== _zeroDeg) {
	      transforms += "rotateY(" + rotationY + _endParenthesis;
	    }
	
	    if (rotationX !== _zeroDeg) {
	      transforms += "rotateX(" + rotationX + _endParenthesis;
	    }
	
	    if (skewX !== _zeroDeg || skewY !== _zeroDeg) {
	      transforms += "skew(" + skewX + ", " + skewY + _endParenthesis;
	    }
	
	    if (scaleX !== 1 || scaleY !== 1) {
	      transforms += "scale(" + scaleX + ", " + scaleY + _endParenthesis;
	    }
	
	    target.style[_transformProp] = transforms || "translate(0, 0)";
	  },
	      _renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
	    var _ref2 = cache || this,
	        xPercent = _ref2.xPercent,
	        yPercent = _ref2.yPercent,
	        x = _ref2.x,
	        y = _ref2.y,
	        rotation = _ref2.rotation,
	        skewX = _ref2.skewX,
	        skewY = _ref2.skewY,
	        scaleX = _ref2.scaleX,
	        scaleY = _ref2.scaleY,
	        target = _ref2.target,
	        xOrigin = _ref2.xOrigin,
	        yOrigin = _ref2.yOrigin,
	        xOffset = _ref2.xOffset,
	        yOffset = _ref2.yOffset,
	        forceCSS = _ref2.forceCSS,
	        tx = parseFloat(x),
	        ty = parseFloat(y),
	        a11,
	        a21,
	        a12,
	        a22,
	        temp;
	
	    rotation = parseFloat(rotation);
	    skewX = parseFloat(skewX);
	    skewY = parseFloat(skewY);
	
	    if (skewY) {
	      skewY = parseFloat(skewY);
	      skewX += skewY;
	      rotation += skewY;
	    }
	
	    if (rotation || skewX) {
	      rotation *= _DEG2RAD;
	      skewX *= _DEG2RAD;
	      a11 = Math.cos(rotation) * scaleX;
	      a21 = Math.sin(rotation) * scaleX;
	      a12 = Math.sin(rotation - skewX) * -scaleY;
	      a22 = Math.cos(rotation - skewX) * scaleY;
	
	      if (skewX) {
	        skewY *= _DEG2RAD;
	        temp = Math.tan(skewX - skewY);
	        temp = Math.sqrt(1 + temp * temp);
	        a12 *= temp;
	        a22 *= temp;
	
	        if (skewY) {
	          temp = Math.tan(skewY);
	          temp = Math.sqrt(1 + temp * temp);
	          a11 *= temp;
	          a21 *= temp;
	        }
	      }
	
	      a11 = _round(a11);
	      a21 = _round(a21);
	      a12 = _round(a12);
	      a22 = _round(a22);
	    } else {
	      a11 = scaleX;
	      a22 = scaleY;
	      a21 = a12 = 0;
	    }
	
	    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
	      tx = _convertToUnit(target, "x", x, "px");
	      ty = _convertToUnit(target, "y", y, "px");
	    }
	
	    if (xOrigin || yOrigin || xOffset || yOffset) {
	      tx = _round(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
	      ty = _round(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
	    }
	
	    if (xPercent || yPercent) {
	      temp = target.getBBox();
	      tx = _round(tx + xPercent / 100 * temp.width);
	      ty = _round(ty + yPercent / 100 * temp.height);
	    }
	
	    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
	    target.setAttribute("transform", temp);
	
	    if (forceCSS) {
	      target.style[_transformProp] = temp;
	    }
	  },
	      _addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue, relative) {
	    var cap = 360,
	        isString = _isString(endValue),
	        endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? _RAD2DEG : 1),
	        change = relative ? endNum * relative : endNum - startNum,
	        finalValue = startNum + change + "deg",
	        direction,
	        pt;
	
	    if (isString) {
	      direction = endValue.split("_")[1];
	
	      if (direction === "short") {
	        change %= cap;
	
	        if (change !== change % (cap / 2)) {
	          change += change < 0 ? cap : -cap;
	        }
	      }
	
	      if (direction === "cw" && change < 0) {
	        change = (change + cap * _bigNum$1) % cap - ~~(change / cap) * cap;
	      } else if (direction === "ccw" && change > 0) {
	        change = (change - cap * _bigNum$1) % cap - ~~(change / cap) * cap;
	      }
	    }
	
	    plugin._pt = pt = new PropTween(plugin._pt, target, property, startNum, change, _renderPropWithEnd);
	    pt.e = finalValue;
	    pt.u = "deg";
	
	    plugin._props.push(property);
	
	    return pt;
	  },
	      _addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
	    var style = _tempDivStyler.style,
	        startCache = target._gsap,
	        exclude = "perspective,force3D,transformOrigin,svgOrigin",
	        endCache,
	        p,
	        startValue,
	        endValue,
	        startNum,
	        endNum,
	        startUnit,
	        endUnit;
	    style.cssText = getComputedStyle(target).cssText + ";position:absolute;display:block;";
	    style[_transformProp] = transforms;
	
	    _doc$1.body.appendChild(_tempDivStyler);
	
	    endCache = _parseTransform(_tempDivStyler, 1);
	
	    for (p in _transformProps) {
	      startValue = startCache[p];
	      endValue = endCache[p];
	
	      if (startValue !== endValue && exclude.indexOf(p) < 0) {
	        startUnit = getUnit(startValue);
	        endUnit = getUnit(endValue);
	        startNum = startUnit !== endUnit ? _convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
	        endNum = parseFloat(endValue);
	        plugin._pt = new PropTween(plugin._pt, startCache, p, startNum, endNum - startNum, _renderCSSProp);
	        plugin._pt.u = endUnit || 0;
	
	        plugin._props.push(p);
	      }
	    }
	
	    _doc$1.body.removeChild(_tempDivStyler);
	  };
	
	  _forEachName("padding,margin,Width,Radius", function (name, index) {
	    var t = "Top",
	        r = "Right",
	        b = "Bottom",
	        l = "Left",
	        props = (index < 3 ? [t, r, b, l] : [t + l, t + r, b + r, b + l]).map(function (side) {
	      return index < 2 ? name + side : "border" + side + name;
	    });
	
	    _specialProps[index > 1 ? "border" + name : name] = function (plugin, target, property, endValue, tween) {
	      var a, vars;
	
	      if (arguments.length < 4) {
	        a = props.map(function (prop) {
	          return _get(plugin, prop, property);
	        });
	        vars = a.join(" ");
	        return vars.split(a[0]).length === 5 ? a[0] : vars;
	      }
	
	      a = (endValue + "").split(" ");
	      vars = {};
	      props.forEach(function (prop, i) {
	        return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
	      });
	      plugin.init(target, vars, tween);
	    };
	  });
	
	  var CSSPlugin = {
	    name: "css",
	    register: _initCore,
	    targetTest: function targetTest(target) {
	      return target.style && target.nodeType;
	    },
	    init: function init(target, vars, tween, index, targets) {
	      var props = this._props,
	          style = target.style,
	          startValue,
	          endValue,
	          endNum,
	          startNum,
	          type,
	          specialProp,
	          p,
	          startUnit,
	          endUnit,
	          relative,
	          isTransformRelated,
	          transformPropTween,
	          cache,
	          smooth,
	          hasPriority;
	
	      if (!_pluginInitted) {
	        _initCore();
	      }
	
	      for (p in vars) {
	        if (p === "autoRound") {
	          continue;
	        }
	
	        endValue = vars[p];
	
	        if (_plugins[p] && _checkPlugin(p, vars, tween, index, target, targets)) {
	          continue;
	        }
	
	        type = typeof endValue;
	        specialProp = _specialProps[p];
	
	        if (type === "function") {
	          endValue = endValue.call(tween, index, target, targets);
	          type = typeof endValue;
	        }
	
	        if (type === "string" && ~endValue.indexOf("random(")) {
	          endValue = _replaceRandom(endValue);
	        }
	
	        if (specialProp) {
	          if (specialProp(this, target, p, endValue, tween)) {
	            hasPriority = 1;
	          }
	        } else if (p.substr(0, 2) === "--") {
	          this.add(style, "setProperty", getComputedStyle(target).getPropertyValue(p) + "", endValue + "", index, targets, 0, 0, p);
	        } else {
	          startValue = _get(target, p);
	          startNum = parseFloat(startValue);
	          relative = type === "string" && endValue.charAt(1) === "=" ? +(endValue.charAt(0) + "1") : 0;
	
	          if (relative) {
	            endValue = endValue.substr(2);
	          }
	
	          endNum = parseFloat(endValue);
	
	          if (p in _propertyAliases) {
	            if (p === "autoAlpha") {
	              if (startNum === 1 && _get(target, "visibility") === "hidden" && endNum) {
	                startNum = 0;
	              }
	
	              _addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
	            }
	
	            if (p !== "scale" && p !== "transform") {
	              p = _propertyAliases[p];
	
	              if (~p.indexOf(",")) {
	                p = p.split(",")[0];
	              }
	            }
	          }
	
	          isTransformRelated = p in _transformProps;
	
	          if (isTransformRelated) {
	            if (!transformPropTween) {
	              cache = target._gsap;
	              cache.renderTransform || _parseTransform(target);
	              smooth = vars.smoothOrigin !== false && cache.smooth;
	              transformPropTween = this._pt = new PropTween(this._pt, style, _transformProp, 0, 1, cache.renderTransform, cache, 0, -1);
	              transformPropTween.dep = 1;
	            }
	
	            if (p === "scale") {
	              this._pt = new PropTween(this._pt, cache, "scaleY", cache.scaleY, relative ? relative * endNum : endNum - cache.scaleY);
	              props.push("scaleY", p);
	              p += "X";
	            } else if (p === "transformOrigin") {
	              endValue = _convertKeywordsToPercentages(endValue);
	
	              if (cache.svg) {
	                _applySVGOrigin(target, endValue, 0, smooth, 0, this);
	              } else {
	                endUnit = parseFloat(endValue.split(" ")[2]) || 0;
	
	                if (endUnit !== cache.zOrigin) {
	                  _addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
	                }
	
	                _addNonTweeningPT(this, style, p, _firstTwoOnly(startValue), _firstTwoOnly(endValue));
	              }
	
	              continue;
	            } else if (p === "svgOrigin") {
	              _applySVGOrigin(target, endValue, 1, smooth, 0, this);
	
	              continue;
	            } else if (p in _rotationalProperties) {
	              _addRotationalPropTween(this, cache, p, startNum, endValue, relative);
	
	              continue;
	            } else if (p === "smoothOrigin") {
	              _addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
	
	              continue;
	            } else if (p === "force3D") {
	              cache[p] = endValue;
	              continue;
	            } else if (p === "transform") {
	              _addRawTransformPTs(this, endValue, target);
	
	              continue;
	            }
	          } else if (!(p in style)) {
	            p = _checkPropPrefix(p) || p;
	          }
	
	          if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !_complexExp.test(endValue) && p in style) {
	            startUnit = (startValue + "").substr((startNum + "").length);
	            endNum || (endNum = 0);
	            endUnit = (endValue + "").substr((endNum + "").length) || (p in _config.units ? _config.units[p] : startUnit);
	
	            if (startUnit !== endUnit) {
	              startNum = _convertToUnit(target, p, startValue, endUnit);
	            }
	
	            this._pt = new PropTween(this._pt, isTransformRelated ? cache : style, p, startNum, relative ? relative * endNum : endNum - startNum, endUnit === "px" && vars.autoRound !== false && !isTransformRelated ? _renderRoundedCSSProp : _renderCSSProp);
	            this._pt.u = endUnit || 0;
	
	            if (startUnit !== endUnit) {
	              this._pt.b = startValue;
	              this._pt.r = _renderCSSPropWithBeginning;
	            }
	          } else if (!(p in style)) {
	            if (p in target) {
	              this.add(target, p, target[p], endValue, index, targets);
	            } else {
	              _missingPlugin(p, endValue);
	
	              continue;
	            }
	          } else {
	            _tweenComplexCSSString.call(this, target, p, startValue, endValue);
	          }
	
	          props.push(p);
	        }
	      }
	
	      if (hasPriority) {
	        _sortPropTweensByPriority(this);
	      }
	    },
	    get: _get,
	    aliases: _propertyAliases,
	    getSetter: function getSetter(target, property, plugin) {
	      var p = _propertyAliases[property];
	      p && p.indexOf(",") < 0 && (property = p);
	      return property in _transformProps && property !== _transformOriginProp && (target._gsap.x || _get(target, "x")) ? plugin && _recentSetterPlugin === plugin ? property === "scale" ? _setterScale : _setterTransform : (_recentSetterPlugin = plugin || {}) && (property === "scale" ? _setterScaleWithRender : _setterTransformWithRender) : target.style && !_isUndefined(target.style[property]) ? _setterCSSStyle : ~property.indexOf("-") ? _setterCSSProp : _getSetter(target, property);
	    },
	    core: {
	      _removeProperty: _removeProperty,
	      _getMatrix: _getMatrix
	    }
	  };
	  gsap.utils.checkPrefix = _checkPropPrefix;
	
	  (function (positionAndScale, rotation, others, aliases) {
	    var all = _forEachName(positionAndScale + "," + rotation + "," + others, function (name) {
	      _transformProps[name] = 1;
	    });
	
	    _forEachName(rotation, function (name) {
	      _config.units[name] = "deg";
	      _rotationalProperties[name] = 1;
	    });
	
	    _propertyAliases[all[13]] = positionAndScale + "," + rotation;
	
	    _forEachName(aliases, function (name) {
	      var split = name.split(":");
	      _propertyAliases[split[1]] = all[split[0]];
	    });
	  })("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
	
	  _forEachName("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function (name) {
	    _config.units[name] = "px";
	  });
	
	  gsap.registerPlugin(CSSPlugin);
	
	  var gsapWithCSS = gsap.registerPlugin(CSSPlugin) || gsap,
	      TweenMaxWithCSS = gsapWithCSS.core.Tween;
	
	  exports.Back = Back;
	  exports.Bounce = Bounce;
	  exports.CSSPlugin = CSSPlugin;
	  exports.Circ = Circ;
	  exports.Cubic = Cubic;
	  exports.Elastic = Elastic;
	  exports.Expo = Expo;
	  exports.Linear = Linear;
	  exports.Power0 = Power0;
	  exports.Power1 = Power1;
	  exports.Power2 = Power2;
	  exports.Power3 = Power3;
	  exports.Power4 = Power4;
	  exports.Quad = Quad;
	  exports.Quart = Quart;
	  exports.Quint = Quint;
	  exports.Sine = Sine;
	  exports.SteppedEase = SteppedEase;
	  exports.Strong = Strong;
	  exports.TimelineLite = Timeline;
	  exports.TimelineMax = Timeline;
	  exports.TweenLite = Tween;
	  exports.TweenMax = TweenMaxWithCSS;
	  exports.default = gsapWithCSS;
	  exports.gsap = gsapWithCSS;
	
	  if (typeof(window) === 'undefined' || window !== exports) {Object.defineProperty(exports, '__esModule', { value: true });} else {delete window.default;}
	
	})));


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	// modules
	
	
	var _delegate = __webpack_require__(7);
	
	var _delegate2 = _interopRequireDefault(_delegate);
	
	var _Cache = __webpack_require__(9);
	
	var _Cache2 = _interopRequireDefault(_Cache);
	
	var _loadPage = __webpack_require__(10);
	
	var _loadPage2 = _interopRequireDefault(_loadPage);
	
	var _renderPage = __webpack_require__(21);
	
	var _renderPage2 = _interopRequireDefault(_renderPage);
	
	var _triggerEvent = __webpack_require__(22);
	
	var _triggerEvent2 = _interopRequireDefault(_triggerEvent);
	
	var _on = __webpack_require__(23);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(24);
	
	var _off2 = _interopRequireDefault(_off);
	
	var _updateTransition = __webpack_require__(25);
	
	var _updateTransition2 = _interopRequireDefault(_updateTransition);
	
	var _getAnimationPromises = __webpack_require__(26);
	
	var _getAnimationPromises2 = _interopRequireDefault(_getAnimationPromises);
	
	var _getPageData = __webpack_require__(27);
	
	var _getPageData2 = _interopRequireDefault(_getPageData);
	
	var _plugins = __webpack_require__(28);
	
	var _utils = __webpack_require__(15);
	
	var _helpers = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Swup = function () {
		function Swup(setOptions) {
			_classCallCheck(this, Swup);
	
			// default options
			var defaults = {
				animateHistoryBrowsing: false,
				animationSelector: '[class*="transition-"]',
				linkSelector: 'a[href^="' + window.location.origin + '"]:not([data-no-swup]), a[href^="/"]:not([data-no-swup]), a[href^="#"]:not([data-no-swup])',
				cache: true,
				containers: ['#swup'],
				requestHeaders: {
					'X-Requested-With': 'swup',
					Accept: 'text/html, application/xhtml+xml'
				},
				plugins: [],
				skipPopStateHandling: function skipPopStateHandling(event) {
					return !(event.state && event.state.source === 'swup');
				}
			};
	
			// merge options
			var options = _extends({}, defaults, setOptions);
	
			// handler arrays
			this._handlers = {
				animationInDone: [],
				animationInStart: [],
				animationOutDone: [],
				animationOutStart: [],
				animationSkipped: [],
				clickLink: [],
				contentReplaced: [],
				disabled: [],
				enabled: [],
				openPageInNewTab: [],
				pageLoaded: [],
				pageRetrievedFromCache: [],
				pageView: [],
				popState: [],
				samePage: [],
				samePageWithHash: [],
				serverError: [],
				transitionStart: [],
				transitionEnd: [],
				willReplaceContent: []
			};
	
			// variable for id of element to scroll to after render
			this.scrollToElement = null;
			// variable for promise used for preload, so no new loading of the same page starts while page is loading
			this.preloadPromise = null;
			// variable for save options
			this.options = options;
			// variable for plugins array
			this.plugins = [];
			// variable for current transition object
			this.transition = {};
			// variable for keeping event listeners from "delegate"
			this.delegatedListeners = {};
			// so we are able to remove the listener
			this.boundPopStateHandler = this.popStateHandler.bind(this);
	
			// make modules accessible in instance
			this.cache = new _Cache2.default();
			this.cache.swup = this;
			this.loadPage = _loadPage2.default;
			this.renderPage = _renderPage2.default;
			this.triggerEvent = _triggerEvent2.default;
			this.on = _on2.default;
			this.off = _off2.default;
			this.updateTransition = _updateTransition2.default;
			this.getAnimationPromises = _getAnimationPromises2.default;
			this.getPageData = _getPageData2.default;
			this.log = function () {}; // here so it can be used by plugins
			this.use = _plugins.use;
			this.unuse = _plugins.unuse;
			this.findPlugin = _plugins.findPlugin;
	
			// enable swup
			this.enable();
		}
	
		_createClass(Swup, [{
			key: 'enable',
			value: function enable() {
				var _this = this;
	
				// check for Promise support
				if (typeof Promise === 'undefined') {
					console.warn('Promise is not supported');
					return;
				}
	
				// add event listeners
				this.delegatedListeners.click = (0, _delegate2.default)(document, this.options.linkSelector, 'click', this.linkClickHandler.bind(this));
				window.addEventListener('popstate', this.boundPopStateHandler);
	
				// initial save to cache
				var page = (0, _helpers.getDataFromHtml)(document.documentElement.outerHTML, this.options.containers);
				page.url = page.responseURL = (0, _helpers.getCurrentUrl)();
				if (this.options.cache) {
					this.cache.cacheUrl(page);
				}
	
				// mark swup blocks in html
				(0, _helpers.markSwupElements)(document.documentElement, this.options.containers);
	
				// mount plugins
				this.options.plugins.forEach(function (plugin) {
					_this.use(plugin);
				});
	
				// modify initial history record
				window.history.replaceState(Object.assign({}, window.history.state, {
					url: window.location.href,
					random: Math.random(),
					source: 'swup'
				}), document.title, window.location.href);
	
				// trigger enabled event
				this.triggerEvent('enabled');
	
				// add swup-enabled class to html tag
				document.documentElement.classList.add('swup-enabled');
	
				// trigger page view event
				this.triggerEvent('pageView');
			}
		}, {
			key: 'destroy',
			value: function destroy() {
				var _this2 = this;
	
				// remove delegated listeners
				this.delegatedListeners.click.destroy();
	
				// remove popstate listener
				window.removeEventListener('popstate', this.boundPopStateHandler);
	
				// empty cache
				this.cache.empty();
	
				// unmount plugins
				this.options.plugins.forEach(function (plugin) {
					_this2.unuse(plugin);
				});
	
				// remove swup data atributes from blocks
				(0, _utils.queryAll)('[data-swup]').forEach(function (element) {
					element.removeAttribute('data-swup');
				});
	
				// remove handlers
				this.off();
	
				// trigger disable event
				this.triggerEvent('disabled');
	
				// remove swup-enabled class from html tag
				document.documentElement.classList.remove('swup-enabled');
			}
		}, {
			key: 'linkClickHandler',
			value: function linkClickHandler(event) {
				// no control key pressed
				if (!event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
					// index of pressed button needs to be checked because Firefox triggers click on all mouse buttons
					if (event.button === 0) {
						this.triggerEvent('clickLink', event);
						event.preventDefault();
						var link = new _helpers.Link(event.delegateTarget);
						if (link.getAddress() == (0, _helpers.getCurrentUrl)() || link.getAddress() == '') {
							// link to the same URL
							if (link.getHash() != '') {
								// link to the same URL with hash
								this.triggerEvent('samePageWithHash', event);
								var element = document.querySelector(link.getHash());
								if (element != null) {
									history.replaceState({
										url: link.getAddress() + link.getHash(),
										random: Math.random(),
										source: 'swup'
									}, document.title, link.getAddress() + link.getHash());
								} else {
									// referenced element not found
									console.warn('Element for offset not found (' + link.getHash() + ')');
								}
							} else {
								// link to the same URL without hash
								this.triggerEvent('samePage', event);
							}
						} else {
							// link to different url
							if (link.getHash() != '') {
								this.scrollToElement = link.getHash();
							}
	
							// get custom transition from data
							var customTransition = event.delegateTarget.getAttribute('data-swup-transition');
	
							// load page
							this.loadPage({ url: link.getAddress(), customTransition: customTransition }, false);
						}
					}
				} else {
					// open in new tab (do nothing)
					this.triggerEvent('openPageInNewTab', event);
				}
			}
		}, {
			key: 'popStateHandler',
			value: function popStateHandler(event) {
				if (this.options.skipPopStateHandling(event)) return;
				var link = new _helpers.Link(event.state ? event.state.url : window.location.pathname);
				if (link.getHash() !== '') {
					this.scrollToElement = link.getHash();
				} else {
					event.preventDefault();
				}
				this.triggerEvent('popState', event);
				this.loadPage({ url: link.getAddress() }, event);
			}
		}]);
	
		return Swup;
	}();
	
	exports.default = Swup;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var closest = __webpack_require__(8);
	
	/**
	 * Delegates event to a selector.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @param {Boolean} useCapture
	 * @return {Object}
	 */
	function delegate(element, selector, type, callback, useCapture) {
	    var listenerFn = listener.apply(this, arguments);
	
	    element.addEventListener(type, listenerFn, useCapture);
	
	    return {
	        destroy: function() {
	            element.removeEventListener(type, listenerFn, useCapture);
	        }
	    }
	}
	
	/**
	 * Finds closest match and invokes callback.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Function}
	 */
	function listener(element, selector, type, callback) {
	    return function(e) {
	        e.delegateTarget = closest(e.target, selector);
	
	        if (e.delegateTarget) {
	            callback.call(element, e);
	        }
	    }
	}
	
	module.exports = delegate;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	var DOCUMENT_NODE_TYPE = 9;
	
	/**
	 * A polyfill for Element.matches()
	 */
	if (typeof Element !== 'undefined' && !Element.prototype.matches) {
	    var proto = Element.prototype;
	
	    proto.matches = proto.matchesSelector ||
	                    proto.mozMatchesSelector ||
	                    proto.msMatchesSelector ||
	                    proto.oMatchesSelector ||
	                    proto.webkitMatchesSelector;
	}
	
	/**
	 * Finds the closest parent that matches a selector.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @return {Function}
	 */
	function closest (element, selector) {
	    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
	        if (typeof element.matches === 'function' &&
	            element.matches(selector)) {
	          return element;
	        }
	        element = element.parentNode;
	    }
	}
	
	module.exports = closest;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Cache = exports.Cache = function () {
		function Cache() {
			_classCallCheck(this, Cache);
	
			this.pages = {};
			this.last = null;
		}
	
		_createClass(Cache, [{
			key: 'cacheUrl',
			value: function cacheUrl(page) {
				if (page.url in this.pages === false) {
					this.pages[page.url] = page;
				}
				this.last = this.pages[page.url];
				this.swup.log('Cache (' + Object.keys(this.pages).length + ')', this.pages);
			}
		}, {
			key: 'getPage',
			value: function getPage(url) {
				return this.pages[url];
			}
		}, {
			key: 'getCurrentPage',
			value: function getCurrentPage() {
				return this.getPage(window.location.pathname + window.location.search);
			}
		}, {
			key: 'exists',
			value: function exists(url) {
				return url in this.pages;
			}
		}, {
			key: 'empty',
			value: function empty() {
				this.pages = {};
				this.last = null;
				this.swup.log('Cache cleared');
			}
		}, {
			key: 'remove',
			value: function remove(url) {
				delete this.pages[url];
			}
		}]);
	
		return Cache;
	}();
	
	exports.default = Cache;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _helpers = __webpack_require__(11);
	
	var loadPage = function loadPage(data, popstate) {
		var _this = this;
	
		// create array for storing animation promises
		var animationPromises = [],
		    xhrPromise = void 0;
		var animateOut = function animateOut() {
			_this.triggerEvent('animationOutStart');
	
			// handle classes
			document.documentElement.classList.add('is-changing');
			document.documentElement.classList.add('is-leaving');
			document.documentElement.classList.add('is-animating');
			if (popstate) {
				document.documentElement.classList.add('is-popstate');
			}
			document.documentElement.classList.add('to-' + (0, _helpers.classify)(data.url));
	
			// animation promise stuff
			animationPromises = _this.getAnimationPromises('out');
			Promise.all(animationPromises).then(function () {
				_this.triggerEvent('animationOutDone');
			});
	
			// create history record if this is not a popstate call
			if (!popstate) {
				// create pop element with or without anchor
				var state = void 0;
				if (_this.scrollToElement != null) {
					state = data.url + _this.scrollToElement;
				} else {
					state = data.url;
				}
	
				(0, _helpers.createHistoryRecord)(state);
			}
		};
	
		this.triggerEvent('transitionStart', popstate);
	
		// set transition object
		if (data.customTransition != null) {
			this.updateTransition(window.location.pathname, data.url, data.customTransition);
			document.documentElement.classList.add('to-' + (0, _helpers.classify)(data.customTransition));
		} else {
			this.updateTransition(window.location.pathname, data.url);
		}
	
		// start/skip animation
		if (!popstate || this.options.animateHistoryBrowsing) {
			animateOut();
		} else {
			this.triggerEvent('animationSkipped');
		}
	
		// start/skip loading of page
		if (this.cache.exists(data.url)) {
			xhrPromise = new Promise(function (resolve) {
				resolve();
			});
			this.triggerEvent('pageRetrievedFromCache');
		} else {
			if (!this.preloadPromise || this.preloadPromise.route != data.url) {
				xhrPromise = new Promise(function (resolve, reject) {
					(0, _helpers.fetch)(_extends({}, data, { headers: _this.options.requestHeaders }), function (response) {
						if (response.status === 500) {
							_this.triggerEvent('serverError');
							reject(data.url);
							return;
						} else {
							// get json data
							var page = _this.getPageData(response);
							if (page != null) {
								page.url = data.url;
							} else {
								reject(data.url);
								return;
							}
							// render page
							_this.cache.cacheUrl(page);
							_this.triggerEvent('pageLoaded');
						}
						resolve();
					});
				});
			} else {
				xhrPromise = this.preloadPromise;
			}
		}
	
		// when everything is ready, handle the outcome
		Promise.all(animationPromises.concat([xhrPromise])).then(function () {
			// render page
			_this.renderPage(_this.cache.getPage(data.url), popstate);
			_this.preloadPromise = null;
		}).catch(function (errorUrl) {
			// rewrite the skipPopStateHandling function to redirect manually when the history.go is processed
			_this.options.skipPopStateHandling = function () {
				window.location = errorUrl;
				return true;
			};
	
			// go back to the actual page were still at
			window.history.go(-1);
		});
	};
	
	exports.default = loadPage;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Link = exports.markSwupElements = exports.getCurrentUrl = exports.transitionEnd = exports.fetch = exports.getDataFromHtml = exports.createHistoryRecord = exports.classify = undefined;
	
	var _classify = __webpack_require__(12);
	
	var _classify2 = _interopRequireDefault(_classify);
	
	var _createHistoryRecord = __webpack_require__(13);
	
	var _createHistoryRecord2 = _interopRequireDefault(_createHistoryRecord);
	
	var _getDataFromHtml = __webpack_require__(14);
	
	var _getDataFromHtml2 = _interopRequireDefault(_getDataFromHtml);
	
	var _fetch = __webpack_require__(16);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	var _transitionEnd = __webpack_require__(17);
	
	var _transitionEnd2 = _interopRequireDefault(_transitionEnd);
	
	var _getCurrentUrl = __webpack_require__(18);
	
	var _getCurrentUrl2 = _interopRequireDefault(_getCurrentUrl);
	
	var _markSwupElements = __webpack_require__(19);
	
	var _markSwupElements2 = _interopRequireDefault(_markSwupElements);
	
	var _Link = __webpack_require__(20);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var classify = exports.classify = _classify2.default;
	var createHistoryRecord = exports.createHistoryRecord = _createHistoryRecord2.default;
	var getDataFromHtml = exports.getDataFromHtml = _getDataFromHtml2.default;
	var fetch = exports.fetch = _fetch2.default;
	var transitionEnd = exports.transitionEnd = _transitionEnd2.default;
	var getCurrentUrl = exports.getCurrentUrl = _getCurrentUrl2.default;
	var markSwupElements = exports.markSwupElements = _markSwupElements2.default;
	var Link = exports.Link = _Link2.default;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var classify = function classify(text) {
		var output = text.toString().toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
		.replace(/\//g, '-') // Replace / with -
		.replace(/[^\w\-]+/g, '') // Remove all non-word chars
		.replace(/\-\-+/g, '-') // Replace multiple - with single -
		.replace(/^-+/, '') // Trim - from start of text
		.replace(/-+$/, ''); // Trim - from end of text
		if (output[0] === '/') output = output.splice(1);
		if (output === '') output = 'homepage';
		return output;
	};
	
	exports.default = classify;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var createHistoryRecord = function createHistoryRecord(url) {
		window.history.pushState({
			url: url || window.location.href.split(window.location.hostname)[1],
			random: Math.random(),
			source: 'swup'
		}, document.getElementsByTagName('title')[0].innerText, url || window.location.href.split(window.location.hostname)[1]);
	};
	
	exports.default = createHistoryRecord;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _utils = __webpack_require__(15);
	
	var getDataFromHtml = function getDataFromHtml(html, containers) {
		var fakeDom = document.createElement('html');
		fakeDom.innerHTML = html;
		var blocks = [];
	
		var _loop = function _loop(i) {
			if (fakeDom.querySelector(containers[i]) == null) {
				// page in invalid
				return {
					v: null
				};
			} else {
				(0, _utils.queryAll)(containers[i]).forEach(function (item, index) {
					(0, _utils.queryAll)(containers[i], fakeDom)[index].setAttribute('data-swup', blocks.length); // marks element with data-swup
					blocks.push((0, _utils.queryAll)(containers[i], fakeDom)[index].outerHTML);
				});
			}
		};
	
		for (var i = 0; i < containers.length; i++) {
			var _ret = _loop(i);
	
			if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
		}
	
		var json = {
			title: fakeDom.querySelector('title').innerText,
			pageClass: fakeDom.querySelector('body').className,
			originalContent: html,
			blocks: blocks
		};
	
		// to prevent memory leaks
		fakeDom.innerHTML = '';
		fakeDom = null;
	
		return json;
	};
	
	exports.default = getDataFromHtml;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var query = exports.query = function query(selector) {
		var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
	
		if (typeof selector !== 'string') {
			return selector;
		}
	
		return context.querySelector(selector);
	};
	
	var queryAll = exports.queryAll = function queryAll(selector) {
		var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
	
		if (typeof selector !== 'string') {
			return selector;
		}
	
		return Array.prototype.slice.call(context.querySelectorAll(selector));
	};

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var fetch = function fetch(setOptions) {
		var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
		var defaults = {
			url: window.location.pathname + window.location.search,
			method: 'GET',
			data: null,
			headers: {}
		};
	
		var options = _extends({}, defaults, setOptions);
	
		var request = new XMLHttpRequest();
	
		request.onreadystatechange = function () {
			if (request.readyState === 4) {
				if (request.status !== 500) {
					callback(request);
				} else {
					callback(request);
				}
			}
		};
	
		request.open(options.method, options.url, true);
		Object.keys(options.headers).forEach(function (key) {
			request.setRequestHeader(key, options.headers[key]);
		});
		request.send(options.data);
		return request;
	};
	
	exports.default = fetch;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var transitionEnd = function transitionEnd() {
		var el = document.createElement('div');
	
		var transEndEventNames = {
			WebkitTransition: 'webkitTransitionEnd',
			MozTransition: 'transitionend',
			OTransition: 'oTransitionEnd otransitionend',
			transition: 'transitionend'
		};
	
		for (var name in transEndEventNames) {
			if (el.style[name] !== undefined) {
				return transEndEventNames[name];
			}
		}
	
		return false;
	};
	
	exports.default = transitionEnd;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var getCurrentUrl = function getCurrentUrl() {
		return window.location.pathname + window.location.search;
	};
	
	exports.default = getCurrentUrl;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _utils = __webpack_require__(15);
	
	var markSwupElements = function markSwupElements(element, containers) {
		var blocks = 0;
	
		var _loop = function _loop(i) {
			if (element.querySelector(containers[i]) == null) {
				console.warn('Element ' + containers[i] + ' is not in current page.');
			} else {
				(0, _utils.queryAll)(containers[i]).forEach(function (item, index) {
					(0, _utils.queryAll)(containers[i], element)[index].setAttribute('data-swup', blocks);
					blocks++;
				});
			}
		};
	
		for (var i = 0; i < containers.length; i++) {
			_loop(i);
		}
	};
	
	exports.default = markSwupElements;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Link = function () {
		function Link(elementOrUrl) {
			_classCallCheck(this, Link);
	
			if (elementOrUrl instanceof Element || elementOrUrl instanceof SVGElement) {
				this.link = elementOrUrl;
			} else {
				this.link = document.createElement('a');
				this.link.href = elementOrUrl;
			}
		}
	
		_createClass(Link, [{
			key: 'getPath',
			value: function getPath() {
				var path = this.link.pathname;
				if (path[0] !== '/') {
					path = '/' + path;
				}
				return path;
			}
		}, {
			key: 'getAddress',
			value: function getAddress() {
				var path = this.link.pathname + this.link.search;
	
				if (this.link.getAttribute('xlink:href')) {
					path = this.link.getAttribute('xlink:href');
				}
	
				if (path[0] !== '/') {
					path = '/' + path;
				}
				return path;
			}
		}, {
			key: 'getHash',
			value: function getHash() {
				return this.link.hash;
			}
		}]);
	
		return Link;
	}();
	
	exports.default = Link;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _utils = __webpack_require__(15);
	
	var _helpers = __webpack_require__(11);
	
	var renderPage = function renderPage(page, popstate) {
		var _this = this;
	
		document.documentElement.classList.remove('is-leaving');
	
		// replace state in case the url was redirected
		var link = new _helpers.Link(page.responseURL);
		if (window.location.pathname !== link.getPath()) {
			window.history.replaceState({
				url: link.getPath(),
				random: Math.random(),
				source: 'swup'
			}, document.title, link.getPath());
	
			// save new record for redirected url
			this.cache.cacheUrl(_extends({}, page, { url: link.getPath() }));
		}
	
		// only add for non-popstate transitions
		if (!popstate || this.options.animateHistoryBrowsing) {
			document.documentElement.classList.add('is-rendering');
		}
	
		this.triggerEvent('willReplaceContent', popstate);
	
		// replace blocks
		for (var i = 0; i < page.blocks.length; i++) {
			document.body.querySelector('[data-swup="' + i + '"]').outerHTML = page.blocks[i];
		}
	
		// set title
		document.title = page.title;
	
		this.triggerEvent('contentReplaced', popstate);
		this.triggerEvent('pageView', popstate);
	
		// empty cache if it's disabled (because pages could be preloaded and stuff)
		if (!this.options.cache) {
			this.cache.empty();
		}
	
		// start animation IN
		setTimeout(function () {
			if (!popstate || _this.options.animateHistoryBrowsing) {
				_this.triggerEvent('animationInStart');
				document.documentElement.classList.remove('is-animating');
			}
		}, 10);
	
		// handle end of animation
		var animationPromises = this.getAnimationPromises('in');
		if (!popstate || this.options.animateHistoryBrowsing) {
			Promise.all(animationPromises).then(function () {
				_this.triggerEvent('animationInDone');
				_this.triggerEvent('transitionEnd', popstate);
				// remove "to-{page}" classes
				document.documentElement.className.split(' ').forEach(function (classItem) {
					if (new RegExp('^to-').test(classItem) || classItem === 'is-changing' || classItem === 'is-rendering' || classItem === 'is-popstate') {
						document.documentElement.classList.remove(classItem);
					}
				});
			});
		} else {
			this.triggerEvent('transitionEnd', popstate);
		}
	
		// reset scroll-to element
		this.scrollToElement = null;
	};
	
	exports.default = renderPage;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var triggerEvent = function triggerEvent(eventName, originalEvent) {
		// call saved handlers with "on" method and pass originalEvent object if available
		this._handlers[eventName].forEach(function (handler) {
			try {
				handler(originalEvent);
			} catch (error) {
				console.error(error);
			}
		});
	
		// trigger event on document with prefix "swup:"
		var event = new CustomEvent('swup:' + eventName, { detail: eventName });
		document.dispatchEvent(event);
	};
	
	exports.default = triggerEvent;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var on = function on(event, handler) {
		if (this._handlers[event]) {
			this._handlers[event].push(handler);
		} else {
			console.warn("Unsupported event " + event + ".");
		}
	};
	
	exports.default = on;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var off = function off(event, handler) {
		var _this = this;
	
		if (event != null) {
			if (handler != null) {
				if (this._handlers[event] && this._handlers[event].filter(function (savedHandler) {
					return savedHandler === handler;
				}).length) {
					var toRemove = this._handlers[event].filter(function (savedHandler) {
						return savedHandler === handler;
					})[0];
					var index = this._handlers[event].indexOf(toRemove);
					if (index > -1) {
						this._handlers[event].splice(index, 1);
					}
				} else {
					console.warn("Handler for event '" + event + "' no found.");
				}
			} else {
				this._handlers[event] = [];
			}
		} else {
			Object.keys(this._handlers).forEach(function (keys) {
				_this._handlers[keys] = [];
			});
		}
	};
	
	exports.default = off;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var updateTransition = function updateTransition(from, to, custom) {
		// transition routes
		this.transition = {
			from: from,
			to: to,
			custom: custom
		};
	};
	
	exports.default = updateTransition;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _utils = __webpack_require__(15);
	
	var _helpers = __webpack_require__(11);
	
	var getAnimationPromises = function getAnimationPromises() {
		var promises = [];
		var animatedElements = (0, _utils.queryAll)(this.options.animationSelector);
		animatedElements.forEach(function (element) {
			var promise = new Promise(function (resolve) {
				element.addEventListener((0, _helpers.transitionEnd)(), function (event) {
					if (element == event.target) {
						resolve();
					}
				});
			});
			promises.push(promise);
		});
		return promises;
	};
	
	exports.default = getAnimationPromises;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _helpers = __webpack_require__(11);
	
	var getPageData = function getPageData(request) {
		// this method can be replaced in case other content than html is expected to be received from server
		// this function should always return {title, pageClass, originalContent, blocks, responseURL}
		// in case page has invalid structure - return null
		var html = request.responseText;
		var pageObject = (0, _helpers.getDataFromHtml)(html, this.options.containers);
	
		if (pageObject) {
			pageObject.responseURL = request.responseURL ? request.responseURL : window.location.href;
		} else {
			console.warn('Received page is invalid.');
			return null;
		}
	
		return pageObject;
	};
	
	exports.default = getPageData;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var use = exports.use = function use(plugin) {
		if (!plugin.isSwupPlugin) {
			console.warn('Not swup plugin instance ' + plugin + '.');
			return;
		}
	
		this.plugins.push(plugin);
		plugin.swup = this;
		if (typeof plugin._beforeMount === 'function') {
			plugin._beforeMount();
		}
		plugin.mount();
	
		return this.plugins;
	};
	
	var unuse = exports.unuse = function unuse(plugin) {
		var pluginReference = void 0;
	
		if (typeof plugin === 'string') {
			pluginReference = this.plugins.find(function (p) {
				return plugin === p.name;
			});
		} else {
			pluginReference = plugin;
		}
	
		if (!pluginReference) {
			console.warn('No such plugin.');
			return;
		}
	
		pluginReference.unmount();
	
		if (typeof pluginReference._afterUnmount === 'function') {
			pluginReference._afterUnmount();
		}
	
		var index = this.plugins.indexOf(pluginReference);
		this.plugins.splice(index, 1);
	
		return this.plugins;
	};
	
	var findPlugin = exports.findPlugin = function findPlugin(pluginName) {
		return this.plugins.find(function (p) {
			return pluginName === p.name;
		});
	};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _plugin = __webpack_require__(30);
	
	var _plugin2 = _interopRequireDefault(_plugin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BodyClassPlugin = function (_Plugin) {
		_inherits(BodyClassPlugin, _Plugin);
	
		function BodyClassPlugin(options) {
			_classCallCheck(this, BodyClassPlugin);
	
			var _this = _possibleConstructorReturn(this, (BodyClassPlugin.__proto__ || Object.getPrototypeOf(BodyClassPlugin)).call(this));
	
			_this.name = 'BodyClassPlugin';
	
	
			var defaultOptions = {
				prefix: ''
			};
	
			_this.options = _extends({}, defaultOptions, options);
			return _this;
		}
	
		_createClass(BodyClassPlugin, [{
			key: 'mount',
			value: function mount() {
				var _this2 = this;
	
				this.swup.on('contentReplaced', function () {
					var page = _this2.swup.cache.getCurrentPage();
	
					// remove old classes
					document.body.className.split(' ').forEach(function (className) {
						if (_this2.isValidClassName(className)) {
							document.body.classList.remove(className);
						}
					});
	
					// add new classes
					if (page.pageClass !== '') {
						page.pageClass.split(' ').forEach(function (className) {
							if (_this2.isValidClassName(className)) {
								document.body.classList.add(className);
							}
						});
					}
				});
			}
		}, {
			key: 'isValidClassName',
			value: function isValidClassName(className) {
				return className !== '' && className.indexOf(this.options.prefix) !== -1;
			}
		}]);
	
		return BodyClassPlugin;
	}(_plugin2.default);
	
	exports.default = BodyClassPlugin;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Plugin = function () {
	    function Plugin() {
	        _classCallCheck(this, Plugin);
	
	        this.isSwupPlugin = true;
	    }
	
	    _createClass(Plugin, [{
	        key: "mount",
	        value: function mount() {
	            // this is mount method rewritten by class extending
	            // and is executed when swup is enabled with plugin
	        }
	    }, {
	        key: "unmount",
	        value: function unmount() {
	            // this is unmount method rewritten by class extending
	            // and is executed when swup with plugin is disabled
	        }
	    }, {
	        key: "_beforeMount",
	        value: function _beforeMount() {
	            // here for any future hidden auto init
	        }
	    }, {
	        key: "_afterUnmount",
	        value: function _afterUnmount() {}
	        // here for any future hidden auto-cleanup
	
	
	        // this is here so we can tell if plugin was created by extending this class
	
	    }]);
	
	    return Plugin;
	}();
	
	exports.default = Plugin;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _plugin = __webpack_require__(30);
	
	var _plugin2 = _interopRequireDefault(_plugin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GaPlugin = function (_Plugin) {
	    _inherits(GaPlugin, _Plugin);
	
	    function GaPlugin() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, GaPlugin);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GaPlugin.__proto__ || Object.getPrototypeOf(GaPlugin)).call.apply(_ref, [this].concat(args))), _this), _this.name = "GaPlugin", _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(GaPlugin, [{
	        key: 'mount',
	        value: function mount() {
	            var _this2 = this;
	
	            this.swup.on('contentReplaced', function (event) {
	                if (typeof window.ga === 'function') {
	                    var title = document.title;
	                    var url = window.location.pathname + window.location.search;
	
	                    window.ga('set', 'title', title);
	                    window.ga('set', 'page', url);
	                    window.ga('send', 'pageview');
	
	                    _this2.swup.log('GA pageview (url \'' + url + '\').');
	                } else {
	                    console.warn('GA is not loaded.');
	                }
	            });
	        }
	    }]);
	
	    return GaPlugin;
	}(_plugin2.default);
	
	exports.default = GaPlugin;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _plugin = __webpack_require__(30);
	
	var _plugin2 = _interopRequireDefault(_plugin);
	
	var _pathToRegexp = __webpack_require__(33);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JsPlugin = function (_Plugin) {
		_inherits(JsPlugin, _Plugin);
	
		function JsPlugin() {
			var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
			_classCallCheck(this, JsPlugin);
	
			var _this = _possibleConstructorReturn(this, (JsPlugin.__proto__ || Object.getPrototypeOf(JsPlugin)).call(this));
	
			_this.name = 'JsPlugin';
			_this.currentAnimation = null;
	
			_this.getAnimationPromises = function (type) {
				var animationIndex = _this.getAnimationIndex(type);
				return [_this.createAnimationPromise(animationIndex, type)];
			};
	
			_this.createAnimationPromise = function (index, type) {
				var currentTransitionRoutes = _this.swup.transition;
				var animation = _this.options[index];
	
				return new Promise(function (resolve) {
					animation[type](resolve, {
						paramsFrom: animation.regFrom.exec(currentTransitionRoutes.from),
						paramsTo: animation.regTo.exec(currentTransitionRoutes.to),
						transition: currentTransitionRoutes,
						from: animation.from,
						to: animation.to
					});
				});
			};
	
			_this.getAnimationIndex = function (type) {
				// already saved from out animation
				if (type === 'in') {
					return _this.currentAnimation;
				}
	
				var animations = _this.options;
				var animationIndex = 0;
				var topRating = 0;
	
				Object.keys(animations).forEach(function (key, index) {
					var animation = animations[key];
					var rating = _this.rateAnimation(animation);
	
					if (rating >= topRating) {
						animationIndex = index;
						topRating = rating;
					}
				});
	
				_this.currentAnimation = animationIndex;
				return _this.currentAnimation;
			};
	
			_this.rateAnimation = function (animation) {
				var currentTransitionRoutes = _this.swup.transition;
				var rating = 0;
	
				// run regex
				var fromMatched = animation.regFrom.test(currentTransitionRoutes.from);
				var toMatched = animation.regTo.test(currentTransitionRoutes.to);
	
				// check if regex passes
				rating += fromMatched ? 1 : 0;
				rating += toMatched ? 1 : 0;
	
				// beat all other if custom parameter fits
				rating += fromMatched && animation.to === currentTransitionRoutes.custom ? 2 : 0;
	
				return rating;
			};
	
			var defaultOptions = [{
				from: '(.*)',
				to: '(.*)',
				out: function out(next) {
					return next();
				},
				in: function _in(next) {
					return next();
				}
			}];
	
			_this.options = _extends({}, defaultOptions, options);
	
			_this.generateRegex();
			return _this;
		}
	
		_createClass(JsPlugin, [{
			key: 'mount',
			value: function mount() {
				var swup = this.swup;
	
				swup._getAnimationPromises = swup.getAnimationPromises;
				swup.getAnimationPromises = this.getAnimationPromises;
			}
		}, {
			key: 'unmount',
			value: function unmount() {
				swup.getAnimationPromises = swup._getAnimationPromises;
				swup._getAnimationPromises = null;
			}
		}, {
			key: 'generateRegex',
			value: function generateRegex() {
				var _this2 = this;
	
				var isRegex = function isRegex(str) {
					return str instanceof RegExp;
				};
	
				this.options = Object.keys(this.options).map(function (key) {
					return _extends({}, _this2.options[key], {
						regFrom: isRegex(_this2.options[key].from) ? _this2.options[key].from : (0, _pathToRegexp2.default)(_this2.options[key].from),
						regTo: isRegex(_this2.options[key].to) ? _this2.options[key].to : (0, _pathToRegexp2.default)(_this2.options[key].to)
					});
				});
			}
		}]);
	
		return JsPlugin;
	}(_plugin2.default);
	
	exports.default = JsPlugin;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.match = match
	module.exports.regexpToFunction = regexpToFunction
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * Default configs.
	 */
	var DEFAULT_DELIMITER = '/'
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // ":test(\\d+)?" => ["test", "\d+", undefined, "?"]
	  // "(\\d+)"  => [undefined, undefined, "\d+", undefined]
	  '(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = (options && options.delimiter) || DEFAULT_DELIMITER
	  var whitelist = (options && options.whitelist) || undefined
	  var pathEscaped = false
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) !== null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      pathEscaped = true
	      continue
	    }
	
	    var prev = ''
	    var name = res[2]
	    var capture = res[3]
	    var group = res[4]
	    var modifier = res[5]
	
	    if (!pathEscaped && path.length) {
	      var k = path.length - 1
	      var c = path[k]
	      var matches = whitelist ? whitelist.indexOf(c) > -1 : true
	
	      if (matches) {
	        prev = c
	        path = path.slice(0, k)
	      }
	    }
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	      pathEscaped = false
	    }
	
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var pattern = capture || group
	    var delimiter = prev || defaultDelimiter
	
	    tokens.push({
	      name: name || key++,
	      prefix: prev,
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      pattern: pattern
	        ? escapeGroup(pattern)
	        : '[^' + escapeString(delimiter === defaultDelimiter ? delimiter : (delimiter + defaultDelimiter)) + ']+?'
	    })
	  }
	
	  // Push any remaining characters.
	  if (path || index < str.length) {
	    tokens.push(path + str.substr(index))
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options), options)
	}
	
	/**
	 * Create path match function from `path-to-regexp` spec.
	 */
	function match (str, options) {
	  var keys = []
	  var re = pathToRegexp(str, keys, options)
	  return regexpToFunction(re, keys)
	}
	
	/**
	 * Create a path match function from `path-to-regexp` output.
	 */
	function regexpToFunction (re, keys) {
	  return function (pathname, options) {
	    var m = re.exec(pathname)
	    if (!m) return false
	
	    var path = m[0]
	    var index = m.index
	    var params = {}
	    var decode = (options && options.decode) || decodeURIComponent
	
	    for (var i = 1; i < m.length; i++) {
	      if (m[i] === undefined) continue
	
	      var key = keys[i - 1]
	
	      if (key.repeat) {
	        params[key.name] = m[i].split(key.delimiter).map(function (value) {
	          return decode(value, key)
	        })
	      } else {
	        params[key.name] = decode(m[i], key)
	      }
	    }
	
	    return { path: path, index: index, params: params }
	  }
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens, options) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
	    }
	  }
	
	  return function (data, options) {
	    var path = ''
	    var encode = (options && options.encode) || encodeURIComponent
	    var validate = options ? options.validate !== false : true
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	        continue
	      }
	
	      var value = data ? data[token.name] : undefined
	      var segment
	
	      if (Array.isArray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but got array')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) continue
	
	          throw new TypeError('Expected "' + token.name + '" to not be empty')
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j], token)
	
	          if (validate && !matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '"')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
	        segment = encode(String(value), token)
	
	        if (validate && !matches[i].test(segment)) {
	          throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but got "' + segment + '"')
	        }
	
	        path += token.prefix + segment
	        continue
	      }
	
	      if (token.optional) continue
	
	      throw new TypeError('Expected "' + token.name + '" to be ' + (token.repeat ? 'an array' : 'a string'))
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$/()])/g, '\\$1')
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options && options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {Array=}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  if (!keys) return path
	
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        pattern: null
	      })
	    }
	  }
	
	  return path
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array=}  keys
	 * @param  {Object=} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  return new RegExp('(?:' + parts.join('|') + ')', flags(options))
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {Array=}  keys
	 * @param  {Object=} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}  tokens
	 * @param  {Array=}  keys
	 * @param  {Object=} options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  options = options || {}
	
	  var strict = options.strict
	  var start = options.start !== false
	  var end = options.end !== false
	  var delimiter = options.delimiter || DEFAULT_DELIMITER
	  var endsWith = [].concat(options.endsWith || []).map(escapeString).concat('$').join('|')
	  var route = start ? '^' : ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var capture = token.repeat
	        ? '(?:' + token.pattern + ')(?:' + escapeString(token.delimiter) + '(?:' + token.pattern + '))*'
	        : token.pattern
	
	      if (keys) keys.push(token)
	
	      if (token.optional) {
	        if (!token.prefix) {
	          route += '(' + capture + ')?'
	        } else {
	          route += '(?:' + escapeString(token.prefix) + '(' + capture + '))?'
	        }
	      } else {
	        route += escapeString(token.prefix) + '(' + capture + ')'
	      }
	    }
	  }
	
	  if (end) {
	    if (!strict) route += '(?:' + escapeString(delimiter) + ')?'
	
	    route += endsWith === '$' ? '$' : '(?=' + endsWith + ')'
	  } else {
	    var endToken = tokens[tokens.length - 1]
	    var isEndDelimited = typeof endToken === 'string'
	      ? endToken[endToken.length - 1] === delimiter
	      : endToken === undefined
	
	    if (!strict) route += '(?:' + escapeString(delimiter) + '(?=' + endsWith + '))?'
	    if (!isEndDelimited) route += '(?=' + escapeString(delimiter) + '|' + endsWith + ')'
	  }
	
	  return new RegExp(route, flags(options))
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {Array=}                keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, keys)
	  }
	
	  if (Array.isArray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), keys, options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), keys, options)
	}


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _plugin = __webpack_require__(30);
	
	var _plugin2 = _interopRequireDefault(_plugin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DebugPlugin = function (_Plugin) {
	    _inherits(DebugPlugin, _Plugin);
	
	    function DebugPlugin() {
	        _classCallCheck(this, DebugPlugin);
	
	        var _this = _possibleConstructorReturn(this, (DebugPlugin.__proto__ || Object.getPrototypeOf(DebugPlugin)).call(this));
	
	        _this.name = "DebugPlugin";
	
	        _this.triggerEvent = function (eventName, originalEvent) {
	            if (originalEvent) {
	                console.groupCollapsed('%cswup:' + '%c' + eventName, 'color: #343434', 'color: #009ACD');
	                console.log(originalEvent);
	                console.groupEnd();
	            } else {
	                console.log('%cswup:' + '%c' + eventName, 'color: #343434', 'color: #009ACD');
	            }
	
	            _this.swup._triggerEvent(eventName, originalEvent);
	        };
	
	        _this.log = function (str, object) {
	            if (object) {
	                console.groupCollapsed(str);
	                for (var key in object) {
	                    console.log(object[key]);
	                }
	                console.groupEnd();
	            } else {
	                console.log(str + '%c', 'color: #009ACD');
	            }
	        };
	
	        _this.debugLog = function (log, type) {
	            if (type === 'error') {
	                console.error('DEBUG PLUGIN: ' + log);
	            } else {
	                console.warn('DEBUG PLUGIN: ' + log);
	            }
	        };
	
	        if (!document.getElementsByTagName('title').length) {
	            var error = "This page doesn't have title tag. Title tag is required in every page.";
	            console.warn('DEBUG PLUGIN: ' + error);
	        }
	        return _this;
	    }
	
	    _createClass(DebugPlugin, [{
	        key: 'mount',
	        value: function mount() {
	            var swup = this.swup;
	
	            // set non-empty log method of swup
	            swup.log = this.log;
	
	            // set swup instance as a global variable swup
	            window.swup = swup;
	
	            // make events appear in console
	            swup._triggerEvent = swup.triggerEvent;
	            swup.triggerEvent = this.triggerEvent;
	
	            // detect relative links not starting with / or #
	            var potentiallyWrongLinksSelector = 'a[href]:not([href^="' + window.location.origin + '"]):not([href^="/"]):not([href^="http"]):not([href^="/"]):not([href^="?"]):not([href^="#"])';
	
	            swup.on('pageView', function () {
	                if (document.querySelectorAll(potentiallyWrongLinksSelector).length) {
	                    var error = 'It seems there are some links with a href attribute not starting with "#", "/" or current domain, which is potentially a problem.';
	                    console.warn('DEBUG PLUGIN: ' + error, document.querySelectorAll(potentiallyWrongLinksSelector));
	                }
	                if (document.querySelectorAll(potentiallyWrongLinksSelector).length) {
	                    var _error = 'It seems there are some links with a href attribute not starting with "#", "/" or current domain, which is potentially a problem.';
	                    console.warn('DEBUG PLUGIN: ' + _error, document.querySelectorAll(potentiallyWrongLinksSelector));
	                }
	            });
	        }
	    }, {
	        key: 'unmount',
	        value: function unmount() {
	            this.swup.log = function () {};
	            this.swup.triggerEvent = this.swup._triggerEvent;
	        }
	    }]);
	
	    return DebugPlugin;
	}(_plugin2.default);
	
	exports.default = DebugPlugin;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(36);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _smoothScroll = __webpack_require__(37);
	
	var _smoothScroll2 = _interopRequireDefault(_smoothScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * GlobalHeader functionality.
	 * @author Dayne Coulson-Hoffacker
	 */
	var GlobalHeader =
	/**
	 * Constructs a new GlobalHeader instance.
	 * @param {Object} options - Options.
	 * @param {HTMLElement} options.element - Container.
	 */
	function GlobalHeader(options) {
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, GlobalHeader);
	
	  this.element = options.element;
	  this.globalFooter = document.querySelector('[data-component="global-footer"]');
	  this.navToggle = this.element.querySelector('[data-component="nav-toggle"]');
	  this.mainNav = this.element.querySelector('[data-component="main-nav"]');
	  this.contactNavItem = this.element.querySelector('[data-component="main-nav"] li.contact');
	  this.scroll = new _smoothScroll2.default();
	  this.scrollOptions = {
	    speed: 500,
	    speedAsDuration: true,
	    updateURL: false
	  };
	
	  this.navToggle.addEventListener('click', function () {
	    _this.element.classList.toggle('nav-open');
	    _this.navToggle.classList.toggle('is-active');
	    document.body.classList.toggle('nav-open');
	  });
	
	  this.contactNavItem.addEventListener('click', function (e) {
	    e.preventDefault();
	    if (_this.element.classList.contains('nav-open')) {
	      _this.element.classList.remove('nav-open');
	      _this.navToggle.classList.remove('is-active');
	      document.body.classList.remove('nav-open');
	    }
	    _this.scroll.animateScroll(_this.globalFooter);
	  });
	};
	
	exports.default = GlobalHeader;

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! smooth-scroll v16.1.1 | (c) 2019 Chris Ferdinandi | MIT License | http://github.com/cferdinandi/smooth-scroll */
	window.Element&&!Element.prototype.closest&&(Element.prototype.closest=function(e){var t,n=(this.document||this.ownerDocument).querySelectorAll(e),o=this;do{for(t=n.length;0<=--t&&n.item(t)!==o;);}while(t<0&&(o=o.parentElement));return o}),(function(){if("function"==typeof window.CustomEvent)return;function e(e,t){t=t||{bubbles:!1,cancelable:!1,detail:void 0};var n=document.createEvent("CustomEvent");return n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),n}e.prototype=window.Event.prototype,window.CustomEvent=e})(),(function(){for(var r=0,e=["ms","moz","webkit","o"],t=0;t<e.length&&!window.requestAnimationFrame;++t)window.requestAnimationFrame=window[e[t]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[e[t]+"CancelAnimationFrame"]||window[e[t]+"CancelRequestAnimationFrame"];window.requestAnimationFrame||(window.requestAnimationFrame=function(e,t){var n=(new Date).getTime(),o=Math.max(0,16-(n-r)),a=window.setTimeout((function(){e(n+o)}),o);return r=n+o,a}),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(e){clearTimeout(e)})})(),(function(e,t){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return t(e)}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=t(e):e.SmoothScroll=t(e)})("undefined"!=typeof global?global:"undefined"!=typeof window?window:this,(function(q){"use strict";var I={ignore:"[data-scroll-ignore]",header:null,topOnEmptyHash:!0,speed:500,speedAsDuration:!1,durationMax:null,durationMin:null,clip:!0,offset:0,easing:"easeInOutCubic",customEasing:null,updateURL:!0,popstate:!0,emitEvents:!0},F=function(){var n={};return Array.prototype.forEach.call(arguments,(function(e){for(var t in e){if(!e.hasOwnProperty(t))return;n[t]=e[t]}})),n},r=function(e){"#"===e.charAt(0)&&(e=e.substr(1));for(var t,n=String(e),o=n.length,a=-1,r="",i=n.charCodeAt(0);++a<o;){if(0===(t=n.charCodeAt(a)))throw new InvalidCharacterError("Invalid character: the input contains U+0000.");1<=t&&t<=31||127==t||0===a&&48<=t&&t<=57||1===a&&48<=t&&t<=57&&45===i?r+="\\"+t.toString(16)+" ":r+=128<=t||45===t||95===t||48<=t&&t<=57||65<=t&&t<=90||97<=t&&t<=122?n.charAt(a):"\\"+n.charAt(a)}return"#"+r},L=function(){return Math.max(document.body.scrollHeight,document.documentElement.scrollHeight,document.body.offsetHeight,document.documentElement.offsetHeight,document.body.clientHeight,document.documentElement.clientHeight)},x=function(e){return e?(t=e,parseInt(q.getComputedStyle(t).height,10)+e.offsetTop):0;var t},H=function(e,t,n,o){if(t.emitEvents&&"function"==typeof q.CustomEvent){var a=new CustomEvent(e,{bubbles:!0,detail:{anchor:n,toggle:o}});document.dispatchEvent(a)}};return function(o,e){var A,a,O,C,M={};M.cancelScroll=function(e){cancelAnimationFrame(C),C=null,e||H("scrollCancel",A)},M.animateScroll=function(i,c,e){M.cancelScroll();var s=F(A||I,e||{}),u="[object Number]"===Object.prototype.toString.call(i),t=u||!i.tagName?null:i;if(u||t){var l=q.pageYOffset;s.header&&!O&&(O=document.querySelector(s.header));var n,o,a,m,r,d,f,h,p=x(O),g=u?i:(function(e,t,n,o){var a=0;if(e.offsetParent)for(;a+=e.offsetTop,e=e.offsetParent;);return a=Math.max(a-t-n,0),o&&(a=Math.min(a,L()-q.innerHeight)),a})(t,p,parseInt("function"==typeof s.offset?s.offset(i,c):s.offset,10),s.clip),y=g-l,v=L(),w=0,S=(n=y,a=(o=s).speedAsDuration?o.speed:Math.abs(n/1e3*o.speed),o.durationMax&&a>o.durationMax?o.durationMax:o.durationMin&&a<o.durationMin?o.durationMin:parseInt(a,10)),E=function(e,t){var n,o,a,r=q.pageYOffset;if(e==t||r==t||(l<t&&q.innerHeight+r)>=v)return M.cancelScroll(!0),o=t,a=u,0===(n=i)&&document.body.focus(),a||(n.focus(),document.activeElement!==n&&(n.setAttribute("tabindex","-1"),n.focus(),n.style.outline="none"),q.scrollTo(0,o)),H("scrollStop",s,i,c),!(C=m=null)},b=function(e){var t,n,o;m||(m=e),w+=e-m,d=l+y*(n=r=1<(r=0===S?0:w/S)?1:r,"easeInQuad"===(t=s).easing&&(o=n*n),"easeOutQuad"===t.easing&&(o=n*(2-n)),"easeInOutQuad"===t.easing&&(o=n<.5?2*n*n:(4-2*n)*n-1),"easeInCubic"===t.easing&&(o=n*n*n),"easeOutCubic"===t.easing&&(o=--n*n*n+1),"easeInOutCubic"===t.easing&&(o=n<.5?4*n*n*n:(n-1)*(2*n-2)*(2*n-2)+1),"easeInQuart"===t.easing&&(o=n*n*n*n),"easeOutQuart"===t.easing&&(o=1- --n*n*n*n),"easeInOutQuart"===t.easing&&(o=n<.5?8*n*n*n*n:1-8*--n*n*n*n),"easeInQuint"===t.easing&&(o=n*n*n*n*n),"easeOutQuint"===t.easing&&(o=1+--n*n*n*n*n),"easeInOutQuint"===t.easing&&(o=n<.5?16*n*n*n*n*n:1+16*--n*n*n*n*n),t.customEasing&&(o=t.customEasing(n)),o||n),q.scrollTo(0,Math.floor(d)),E(d,g)||(C=q.requestAnimationFrame(b),m=e)};0===q.pageYOffset&&q.scrollTo(0,0),f=i,h=s,u||history.pushState&&h.updateURL&&history.pushState({smoothScroll:JSON.stringify(h),anchor:f.id},document.title,f===document.documentElement?"#top":"#"+f.id),"matchMedia"in q&&q.matchMedia("(prefers-reduced-motion)").matches?q.scrollTo(0,Math.floor(g)):(H("scrollStart",s,i,c),M.cancelScroll(!0),q.requestAnimationFrame(b))}};var t=function(e){if(!e.defaultPrevented&&!(0!==e.button||e.metaKey||e.ctrlKey||e.shiftKey)&&"closest"in e.target&&(a=e.target.closest(o))&&"a"===a.tagName.toLowerCase()&&!e.target.closest(A.ignore)&&a.hostname===q.location.hostname&&a.pathname===q.location.pathname&&/#/.test(a.href)){var t,n;try{t=r(decodeURIComponent(a.hash))}catch(e){t=r(a.hash)}if(console.log(t),"#"===t){if(!A.topOnEmptyHash)return;n=document.documentElement}else n=document.querySelector(t);(n=n||"#top"!==t?n:document.documentElement)&&(e.preventDefault(),(function(e){if(history.replaceState&&e.updateURL&&!history.state){var t=q.location.hash;t=t||"",history.replaceState({smoothScroll:JSON.stringify(e),anchor:t||q.pageYOffset},document.title,t||q.location.href)}})(A),M.animateScroll(n,a))}},n=function(e){if(null!==history.state&&history.state.smoothScroll&&history.state.smoothScroll===JSON.stringify(A)){var t=history.state.anchor;"string"==typeof t&&t&&!(t=document.querySelector(r(history.state.anchor)))||M.animateScroll(t,null,{updateURL:!1})}};M.destroy=function(){A&&(document.removeEventListener("click",t,!1),q.removeEventListener("popstate",n,!1),M.cancelScroll(),C=O=a=A=null)};return (function(){if(!("querySelector"in document&&"addEventListener"in q&&"requestAnimationFrame"in q&&"closest"in q.Element.prototype))throw"Smooth Scroll: This browser does not support the required JavaScript methods and browser APIs.";M.destroy(),A=F(I,e||{}),O=A.header?document.querySelector(A.header):null,document.addEventListener("click",t,!1),A.updateURL&&A.popstate&&q.addEventListener("popstate",n,!1)})(),M}}));
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(36);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * PageIntroduction functionality.
	 * @author Dayne Coulson-Hoffacker
	 */
	var PageIntroduction =
	/**
	 * Constructs a new PageIntroduction instance.
	 * @param {Object} options - Options.
	 * @param {HTMLElement} options.element - Container.
	 */
	function PageIntroduction(options) {
	  (0, _classCallCheck3.default)(this, PageIntroduction);
	
	  this.element = options.element;
	  this.header = this.element.querySelector('header');
	  this.mainNav = document.querySelector('[data-component="main-nav"]');
	  this.mediaQuery = window.matchMedia("(min-width: 48em)");
	
	  // // Set initial width of header element on page load
	
	  // if (this.mediaQuery.matches) {
	  //   var mainNavWidth = this.mainNav.offsetWidth
	  //   this.header.style.width = mainNavWidth + 'px'
	  // }
	
	  // window.addEventListener('resize', () => {
	  //   if (this.mediaQuery.matches) {
	  //     var mainNavWidth = this.mainNav.offsetWidth
	  //     this.header.style.width = mainNavWidth + 'px'
	  //   } else {
	  //     this.header.style.width = 'auto'
	  //   }
	  // })
	};
	
	exports.default = PageIntroduction;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(36);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Popup component
	 * @author Dayne Coulson-Hoffacker
	 */
	var Popup =
	/**
	 * Constructs a new Popup Feed instance
	 * @param {Object} options - Options object.
	 * @param {HMTLElement} options.element - Container element.
	 */
	function Popup(options) {
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, Popup);
	
	  this.element = options.element;
	  this.closeBtn = this.element.querySelector('[data-component="close"]');
	
	  setTimeout(function () {
	    _this.element.classList.add('visible');
	  }, 1000);
	
	  this.closeBtn.addEventListener('click', function () {
	    _this.element.classList.remove('visible');
	  });
	};
	
	exports.default = Popup;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(36);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _smoothScroll = __webpack_require__(37);
	
	var _smoothScroll2 = _interopRequireDefault(_smoothScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Accordions functionality.
	 * @author Dayne Coulson-Hoffacker
	 */
	var Accordions = function () {
	  /**
	   * Constructs a new Accordions instance.
	   * @param {Object} options - Options.
	   * @param {HTMLElement} options.element - Container.
	   */
	  function Accordions(options) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, Accordions);
	
	    this.element = options.element;
	    this.accordion = this.element.queryAll('[data-component="accordion"]');
	    this.touchDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
	    this.scroll = new _smoothScroll2.default();
	    this.scrollOptions = {
	      speed: 1000,
	      speedAsDuration: true,
	      updateURL: false,
	      header: '[data-component="global-header"]'
	    };
	
	    this.accordion.forEach(function (element) {
	      var toggle = element.querySelector('header');
	      var accordionDetails = element.querySelector('.accordion-details');
	      var closeBtn = element.querySelector('.close-btn button');
	
	      if (closeBtn) {
	        closeBtn.addEventListener('click', function (e) {
	          _this.close(_this.accordion);
	          setTimeout(function () {
	            _this.scroll.animateScroll(element, element, _this.scrollOptions);
	          });
	        });
	      }
	
	      toggle.addEventListener('click', function (e) {
	        var index = _this.accordion.indexOf(element);
	        if (element.classList.contains('open')) {
	          _this.close(_this.accordion);
	          e.preventDefault();
	        } else {
	          e.preventDefault();
	          _this.close(_this.accordion);
	          _this.open(element, index, accordionDetails);
	          if (document.body.classList.contains('home') || document.body.classList.contains('page-template-page-faqs-and-resources')) {
	            setTimeout(function () {
	              _this.scroll.animateScroll(element, element, _this.scrollOptions);
	            }, 1000);
	          }
	        }
	      });
	    });
	  }
	
	  /**
	  * Closes expanded state.
	  */
	
	
	  (0, _createClass3.default)(Accordions, [{
	    key: 'close',
	    value: function close(question) {
	      this.accordion.forEach(function (element) {
	        element.classList.remove('open');
	      });
	      document.body.classList.remove('accordion-open');
	    }
	
	    /**
	    * Opens expanded state.
	    */
	
	  }, {
	    key: 'open',
	    value: function open(element, index, accordionDetails) {
	      element.classList.add('open');
	      if (!document.body.classList.contains('page-template-page-what-we-do-php')) {
	        document.body.classList.add('accordion-open');
	      }
	      // document.body.classList.add('scrolling')
	    }
	  }]);
	  return Accordions;
	}();
	
	exports.default = Accordions;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(42);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(44);
	var $Object = __webpack_require__(47).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(45);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(55), 'Object', { defineProperty: __webpack_require__(51).f });


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(46);
	var core = __webpack_require__(47);
	var ctx = __webpack_require__(48);
	var hide = __webpack_require__(50);
	var has = __webpack_require__(60);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 46 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.5' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(49);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(51);
	var createDesc = __webpack_require__(59);
	module.exports = __webpack_require__(55) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(52);
	var IE8_DOM_DEFINE = __webpack_require__(54);
	var toPrimitive = __webpack_require__(58);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(55) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(53);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(55) && !__webpack_require__(56)(function () {
	  return Object.defineProperty(__webpack_require__(57)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(56)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(53);
	var document = __webpack_require__(46).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(53);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(36);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(41);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _smoothScroll = __webpack_require__(37);
	
	var _smoothScroll2 = _interopRequireDefault(_smoothScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Accordions functionality.
	 * @author Dayne Coulson-Hoffacker
	 */
	var WhatWeDoFAQs = function () {
	  /**
	   * Constructs a new WhatWeDoFAQs instance.
	   * @param {Object} options - Options.
	   * @param {HTMLElement} options.element - Container.
	   */
	  function WhatWeDoFAQs(options) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, WhatWeDoFAQs);
	
	    this.element = options.element;
	    this.accordion = this.element.queryAll('[data-component="what-we-do-sections-faqs-accordion"]');
	    this.scroll = new _smoothScroll2.default();
	    this.scrollOptions = {
	      speed: 1000,
	      speedAsDuration: true,
	      updateURL: false,
	      header: '[data-component="global-header"]'
	    };
	
	    this.accordion.forEach(function (element) {
	      var toggle = element.querySelector('header');
	      var accordionDetails = element.querySelector('.accordion-details');
	
	      toggle.addEventListener('click', function (e) {
	        var index = _this.accordion.indexOf(element);
	        if (element.classList.contains('open')) {
	          _this.close(_this.accordion);
	          e.preventDefault();
	        } else {
	          e.preventDefault();
	          _this.close(_this.accordion);
	          _this.open(element, index, accordionDetails);
	          setTimeout(function () {
	            _this.scroll.animateScroll(element, element, _this.scrollOptions);
	          });
	        }
	      });
	    });
	  }
	
	  /**
	  * Closes expanded state.
	  */
	
	
	  (0, _createClass3.default)(WhatWeDoFAQs, [{
	    key: 'close',
	    value: function close(question) {
	      this.accordion.forEach(function (element) {
	        element.classList.remove('open');
	      });
	    }
	
	    /**
	    * Opens expanded state.
	    */
	
	  }, {
	    key: 'open',
	    value: function open(element, index, accordionDetails) {
	      element.classList.add('open');
	    }
	  }]);
	  return WhatWeDoFAQs;
	}();
	
	exports.default = WhatWeDoFAQs;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(36);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Archive functionality.
	 * @author Dayne Coulson-Hoffacker
	 */
	var GlobalHeader =
	/**
	 * Constructs a new Archive instance.
	 * @param {Object} options - Options.
	 * @param {HTMLElement} options.element - Container.
	 */
	function GlobalHeader(options) {
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, GlobalHeader);
	
	  this.element = options.element;
	  this.archiveToggle = this.element.querySelector('[data-component="archive-toggle"]');
	
	  this.archiveToggle.addEventListener('click', function () {
	    _this.element.classList.toggle('open');
	    document.body.classList.toggle('archive-open');
	  });
	};
	
	exports.default = GlobalHeader;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(36);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Instafeed = __webpack_require__(65);
	
	/**
	* Instagram Feed component
	* @author Dayne Coulson-Hoffacker
	*/
	
	var InstagramFeed =
	/**
	* Constructs a new Instagram Feed instance
	* @param {Object} options - Options object.
	* @param {HMTLElement} options.element - Container element.
	*/
	function InstagramFeed(options) {
	  (0, _classCallCheck3.default)(this, InstagramFeed);
	
	  this.element = options.element;
	
	  if (this.element.classList.contains('make-models')) {
	    fetch('https://ig.instant-tokens.com/users/b5bde12f-9607-4f3d-939a-f9f12758fb34/instagram/17841401854255884/token?userSecret=sxsdm0w92imqkrb3dxl96g').then(function (resp) {
	      return resp.json();
	    }).then(function (data) {
	      var feed = new Instafeed({
	        accessToken: data.Token,
	        limit: 4,
	        template: '<a href="{{link}}" target="_blank"><figure><img src="{{image}}" /></figure></a>'
	      });
	
	      feed.run();
	    }).catch(function (error) {
	      console.log(error);
	    });
	  } else {
	    fetch('https://ig.instant-tokens.com/users/b5bde12f-9607-4f3d-939a-f9f12758fb34/instagram/17841404369675456/token?userSecret=jqqjilqd21q3q96unu6uny').then(function (resp) {
	      return resp.json();
	    }).then(function (data) {
	      var feed = new Instafeed({
	        accessToken: data.Token,
	        limit: 4,
	        template: '<a href="{{link}}" target="_blank"><figure><img src="{{image}}" /></figure></a>'
	      });
	
	      feed.run();
	    }).catch(function (error) {
	      console.log(error);
	    });
	  }
	};
	
	exports.default = InstagramFeed;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64)))

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status === undefined ? 200 : options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);
	
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = global.fetch;
	}.call(global));
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function exportInstafeed(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
	    module.exports = factory();
	  } else {
	    root.Instafeed = factory();
	  }
	}(this, function defineInstafeed() {
	  function assert(val, msg) {
	    if (!val) {
	      throw new Error(msg);
	    }
	  }
	
	  function Instafeed(options) {
	    assert(!options || typeof options === 'object', 'options must be an object, got ' + options + ' ('+ typeof options +')');
	
	    // default options
	    var opts = {
	      accessToken: null,
	      accessTokenTimeout: 10000,
	      after: null,
	      apiTimeout: 10000,
	      before: null,
	      debug: false,
	      error: null,
	      filter: null,
	      limit: null,
	      mock: false,
	      render: null,
	      sort: null,
	      success: null,
	      target: 'instafeed',
	      template: '<a href="{{link}}"><img title="{{caption}}" src="{{image}}" /></a>',
	      templateBoundaries: ['{{','}}'],
	      transform: null
	    };
	
	    // state holder
	    var state = {
	      running: false
	    };
	
	    // copy options over defaults
	    if (options) {
	      for (var optKey in opts) {
	        if (typeof options[optKey] !== 'undefined') {
	          opts[optKey] = options[optKey];
	        }
	      }
	    }
	
	    // validate options
	    assert(typeof opts.target === 'string' || typeof opts.target === 'object', 'target must be a string or DOM node, got ' + opts.target + ' ('+ typeof opts.target +')');
	    assert(typeof opts.accessToken === 'string' || typeof opts.accessToken === 'function', 'accessToken must be a string or function, got ' + opts.accessToken + ' ('+ typeof opts.accessToken +')');
	    assert(typeof opts.accessTokenTimeout === 'number', 'accessTokenTimeout must be a number, got '+ opts.accessTokenTimeout + ' ('+ typeof opts.accessTokenTimeout +')');
	    assert(typeof opts.apiTimeout === 'number', 'apiTimeout must be a number, got '+ opts.apiTimeout + ' ('+ typeof opts.apiTimeout +')');
	    assert(typeof opts.debug === 'boolean', 'debug must be true or false, got ' + opts.debug + ' ('+ typeof opts.debug +')');
	    assert(typeof opts.mock === 'boolean', 'mock must be true or false, got ' + opts.mock + ' ('+ typeof opts.mock +')');
	    assert(typeof opts.templateBoundaries === 'object' && opts.templateBoundaries.length === 2 && typeof opts.templateBoundaries[0] === 'string' && typeof opts.templateBoundaries[1] === 'string', 'templateBoundaries must be an array of 2 strings, got ' + opts.templateBoundaries + ' ('+ typeof opts.templateBoundaries +')');
	    assert(!opts.template || typeof opts.template === 'string', 'template must null or string, got ' + opts.template + ' ('+ typeof opts.template +')');
	    assert(!opts.error || typeof opts.error === 'function', 'error must be null or function, got ' + opts.error + ' ('+ typeof opts.error +')');
	    assert(!opts.before || typeof opts.before === 'function', 'before must be null or function, got ' + opts.before + ' ('+ typeof opts.before +')');
	    assert(!opts.after || typeof opts.after === 'function', 'after must be null or function, got ' + opts.after + ' ('+ typeof opts.after +')');
	    assert(!opts.success || typeof opts.success === 'function', 'success must be null or function, got ' + opts.success + ' ('+ typeof opts.success +')');
	    assert(!opts.filter || typeof opts.filter === 'function', 'filter must be null or function, got ' + opts.filter + ' ('+ typeof opts.filter +')');
	    assert(!opts.transform || typeof opts.transform === 'function', 'transform must be null or function, got ' + opts.transform + ' ('+ typeof opts.transform +')');
	    assert(!opts.sort || typeof opts.sort === 'function', 'sort must be null or function, got ' + opts.sort + ' ('+ typeof opts.sort +')');
	    assert(!opts.render || typeof opts.render === 'function', 'render must be null or function, got ' + opts.render + ' ('+ typeof opts.render +')');
	    assert(!opts.limit || typeof opts.limit === 'number', 'limit must be null or number, got ' + opts.limit + ' ('+ typeof opts.limit +')');
	
	    // set instance info
	    this._state = state;
	    this._options = opts;
	  }
	
	  Instafeed.prototype.run = function run() {
	    var scope = this;
	    var node = null;
	    var url = null;
	    var items = null;
	    var html = null;
	
	    this._debug('run', 'options', this._options);
	    this._debug('run', 'state', this._state);
	
	    // prevent re-entry
	    if (this._state.running) {
	      this._debug('run', 'already running, skipping');
	      return false;
	    }
	
	    // set as running
	    this._start();
	
	    // get dom node
	    this._debug('run', 'getting dom node');
	    if (typeof this._options.target === 'string') {
	      node = document.getElementById(this._options.target);
	    } else {
	      node = this._options.target;
	    }
	    if (!node) {
	      this._fail(new Error('no element found with ID ' + this._options.target));
	      return false;
	    }
	    this._debug('run', 'got dom node', node);
	
	    // get access token
	    this._debug('run', 'getting access token');
	    this._getAccessToken(function onTokenReceived(err, token) {
	      if (err) {
	        scope._debug('onTokenReceived', 'error', err);
	        scope._fail(new Error('error getting access token: ' + err.message));
	        return;
	      }
	
	      url = 'https://graph.instagram.com/me/media?fields=caption,id,media_type,media_url,permalink,thumbnail_url,timestamp,username&access_token='+ token;
	      scope._debug('onTokenReceived', 'request url', url);
	
	      // make network request
	      scope._makeApiRequest(url, function onResponseReceived(err, data) {
	        if (err) {
	          scope._debug('onResponseReceived', 'error', err);
	          scope._fail(new Error('api request error: ' + err.message));
	          return;
	        }
	        scope._debug('onResponseReceived', 'data', data);
	        scope._success(data);
	
	        try {
	          items = scope._processData(data);
	          scope._debug('onResponseReceived', 'processed data', items);
	        } catch (processErr) {
	          scope._fail(processErr);
	          return;
	        }
	
	        if (scope._options.mock) {
	          scope._debug('onResponseReceived', 'mock enabled, skipping render');
	        } else {
	          try {
	            html = scope._renderData(items);
	            scope._debug('onResponseReceived', 'html content', html);
	          } catch (renderErr) {
	            scope._fail(renderErr);
	            return;
	          }
	          node.innerHTML = html;
	        }
	
	        scope._finish();
	      });
	    });
	
	    return true;
	  };
	
	  Instafeed.prototype._processData = function processData(data) {
	    var hasTransform = (typeof this._options.transform === 'function');
	    var hasFilter = (typeof this._options.filter === 'function');
	    var hasSort = (typeof this._options.sort === 'function');
	    var hasLimit = (typeof this._options.limit === 'number');
	    var transformedFiltered = [];
	    var limitDelta = null;
	    var dataItem = null;
	    var transformedItem = null;
	    var filterResult = null;
	
	    this._debug('processData', 'hasFilter', hasFilter, 'hasTransform', hasTransform, 'hasSort', hasSort, 'hasLimit', hasLimit);
	
	    if (typeof data !== 'object' || typeof data.data !== 'object' || data.data.length <= 0) {
	      return null;
	    }
	
	    for (var i = 0; i < data.data.length; i++) {
	      dataItem = this._getItemData(data.data[i]);
	
	      // transform
	      if (hasTransform) {
	        try {
	          transformedItem = this._options.transform(dataItem);
	          this._debug('processData', 'transformed item', dataItem, transformedItem);
	        } catch (err) {
	          this._debug('processData', 'error calling transform', err);
	          throw new Error('error in transform: ' + err.message);
	        }
	      } else {
	        transformedItem = dataItem;
	      }
	
	      // filter
	      if (hasFilter) {
	        try {
	          filterResult = this._options.filter(transformedItem);
	          this._debug('processData', 'filter item result', transformedItem, filterResult);
	        } catch (err) {
	          this._debug('processData', 'error calling filter', err);
	          throw new Error('error in filter: ' + err.message);
	        }
	        if (filterResult) {
	          transformedFiltered.push(transformedItem);
	        }
	      } else {
	        transformedFiltered.push(transformedItem);
	      }
	    }
	
	    // sort
	    if (hasSort) {
	      try {
	        transformedFiltered.sort(this._options.sort);
	      } catch (err) {
	        this._debug('processData', 'error calling sort', err);
	        throw new Error('error in sort: ' + err.message);
	      }
	    }
	
	    // limit
	    if (hasLimit) {
	      limitDelta = transformedFiltered.length - this._options.limit;
	      this._debug('processData', 'checking limit', transformedFiltered.length, this._options.limit, limitDelta);
	      if (limitDelta > 0) {
	        transformedFiltered.splice(transformedFiltered.length - limitDelta, limitDelta);
	      }
	    }
	
	    return transformedFiltered;
	  };
	
	  Instafeed.prototype._extractTags = function extractTags(str) {
	    var exp = /#([^\s]+)/gi;
	    var badChars = /[~`!@#$%^&*\(\)\-\+={}\[\]:;"'<>\?,\./|\\\s]+/i; // non-allowed characters
	    var tags = [];
	
	    if (typeof str === 'string') {
	      while ((match = exp.exec(str)) !== null) {
	        if (badChars.test(match[1]) === false) {
	          tags.push(match[1]);
	        }
	      }
	    }
	
	    return tags;
	  };
	
	  Instafeed.prototype._getItemData = function getItemData(data) {
	    var type = null;
	    var image = null;
	
	    switch (data.media_type) {
	      case 'IMAGE':
	        type = 'image';
	        image = data.media_url;
	        break;
	      case 'VIDEO':
	        type = 'video';
	        image = data.thumbnail_url;
	        break;
	      case 'CAROUSEL_ALBUM':
	        type = 'album';
	        image = data.media_url;
	        break;
	    }
	
	    return {
	      caption: data.caption,
	      tags: this._extractTags(data.caption),
	      id: data.id,
	      image: image,
	      link: data.permalink,
	      model: data,
	      timestamp: data.timestamp,
	      type: type,
	      username: data.username
	    };
	  };
	
	  Instafeed.prototype._renderData = function renderData(items) {
	    var hasTemplate = (typeof this._options.template === 'string');
	    var hasRender = (typeof this._options.render === 'function');
	    var item = null;
	    var itemHtml = null;
	    var html = '';
	
	    this._debug('renderData', 'hasTemplate', hasTemplate, 'hasRender', hasRender);
	
	    if (typeof items !== 'object' || items.length <= 0) {
	      return null;
	    }
	
	    for (var i = 0; i < items.length; i++) {
	      item = items[i];
	
	      if (hasRender) {
	        try {
	          itemHtml = this._options.render(item, this._options);
	          this._debug('renderData', 'custom render result', item, itemHtml);
	        } catch (err) {
	          this._debug('renderData', 'error calling render', err);
	          throw new Error('error in render: ' + err.message);
	        }
	      } else if (hasTemplate) {
	        itemHtml = this._basicRender(item);
	      }
	
	      if (itemHtml) {
	        html = html + itemHtml;
	      } else {
	        this._debug('renderData', 'render item did not return any content', item);
	      }
	    }
	
	    return html;
	  };
	
	  Instafeed.prototype._basicRender = function basicRender(data) {
	    var exp = new RegExp(this._options.templateBoundaries[0] + '([\\s\\w.]+)' + this._options.templateBoundaries[1], 'gm');
	    var template = this._options.template;
	    var match = null;
	    var output = '';
	    var substr = null;
	    var lastIndex = 0;
	    var keyPath = null;
	    var keyPathValue = null;
	
	    while((match = exp.exec(template)) !== null) {
	      keyPath = match[1];
	      substr = template.slice(lastIndex, match.index);
	      output = output + substr;
	      keyPathValue = this._valueForKeyPath(keyPath, data);
	      if (keyPathValue) {
	        output = output + keyPathValue.toString();
	      }
	      lastIndex = exp.lastIndex;
	    }
	
	    if (lastIndex < template.length) {
	      substr = template.slice(lastIndex, template.length);
	      output = output + substr;
	    }
	
	    return output;
	  };
	
	  Instafeed.prototype._valueForKeyPath = function valueForKeyPath(keyPath, data) {
	    var exp = /([\w]+)/gm;
	    var match = null;
	    var key = null;
	    var lastValue = data;
	
	    while((match = exp.exec(keyPath)) !== null) {
	      if (typeof lastValue !== 'object') {
	        return null;
	      }
	      key = match[1];
	      lastValue = lastValue[key];
	    }
	
	    return lastValue;
	  };
	
	  Instafeed.prototype._fail = function fail(err) {
	    var didHook = this._runHook('error', err);
	    if (!didHook && console && typeof console.error === 'function') {
	      console.error(err);
	    }
	    this._state.running = false;
	  };
	
	  Instafeed.prototype._start = function start() {
	    this._state.running = true;
	    this._runHook('before');
	  };
	
	  Instafeed.prototype._finish = function finish() {
	    this._runHook('after');
	    this._state.running = false;
	  };
	
	  Instafeed.prototype._success = function success(data) {
	    this._runHook('success', data);
	    this._state.running = false;
	  };
	
	  Instafeed.prototype._makeApiRequest = function makeApiRequest(url, callback) {
	    var called = false;
	    var scope = this;
	    var apiRequest = null;
	    var callbackOnce = function callbackOnce(err, value) {
	      if (!called) {
	        called = true;
	        callback(err, value);
	      }
	    };
	
	    apiRequest = new XMLHttpRequest();
	
	    apiRequest.ontimeout = function apiRequestTimedOut(event) {
	      callbackOnce(new Error('api request timed out'));
	    };
	
	    apiRequest.onerror = function apiRequestOnError(event) {
	      callbackOnce(new Error('api connection error'));
	    };
	
	    apiRequest.onload = function apiRequestOnLoad(event) {
	      var contentType = apiRequest.getResponseHeader('Content-Type');
	      var responseJson = null;
	
	      scope._debug('apiRequestOnLoad', 'loaded', event);
	      scope._debug('apiRequestOnLoad', 'response status', apiRequest.status);
	      scope._debug('apiRequestOnLoad', 'response content type', contentType);
	
	      if (contentType.indexOf('application/json') >= 0) {
	        try {
	          responseJson = JSON.parse(apiRequest.responseText);
	        } catch (err) {
	          scope._debug('apiRequestOnLoad', 'json parsing error', err, apiRequest.responseText);
	          callbackOnce(new Error('error parsing response json'));
	          return;
	        }
	      }
	
	      if (apiRequest.status !== 200) {
	        if (responseJson && responseJson.error) {
	          callbackOnce(new Error(responseJson.error.code + ' ' + responseJson.error.message));
	        } else {
	          callbackOnce(new Error('status code ' + apiRequest.status));
	        }
	        return;
	      }
	
	      callbackOnce(null, responseJson);
	    };
	
	    apiRequest.open('GET', url, true);
	    apiRequest.timeout = this._options.apiTimeout;
	    apiRequest.send();
	  };
	
	  Instafeed.prototype._getAccessToken = function getAccessToken(callback) {
	    var called = false;
	    var scope = this;
	    var timeoutCheck = null;
	
	    var callbackOnce = function callbackOnce(err, value) {
	      if (!called) {
	        called = true;
	        clearTimeout(timeoutCheck);
	        callback(err, value);
	      }
	    };
	
	    if (typeof this._options.accessToken === 'function') {
	      this._debug('getAccessToken', 'calling accessToken as function');
	
	      timeoutCheck = setTimeout(function accessTokenTimeoutCheck() {
	        scope._debug('getAccessToken', 'timeout check', called);
	        callbackOnce(new Error('accessToken timed out'), null);
	      }, this._options.accessTokenTimeout);
	
	      try {
	        this._options.accessToken(function accessTokenReceiver(err, value) {
	          scope._debug('getAccessToken', 'received accessToken callback', called, err, value);
	          callbackOnce(err, value);
	        });
	      } catch (err) {
	        this._debug('getAccessToken', 'error invoking the accessToken as function', err);
	        callbackOnce(err, null);
	      }
	    } else {
	      this._debug('getAccessToken', 'treating accessToken as static', typeof this._options.accessToken);
	      callbackOnce(null, this._options.accessToken);
	    }
	  };
	
	  Instafeed.prototype._debug = function debug() {
	    var args = null;
	
	    if (this._options.debug && console && typeof console.log === 'function') {
	      args = [].slice.call(arguments);
	      args[0] = '[Instafeed] ['+args[0]+']'; // first argument should be the callers name
	      console.log.apply(null, args);
	    }
	  };
	
	  Instafeed.prototype._runHook = function runHook(hookName, data) {
	    var success = false;
	    if (typeof this._options[hookName] === 'function') {
	      try {
	        this._options[hookName](data);
	        success = true;
	      } catch (err) {
	        this._debug('runHook', 'error calling hook', hookName, err);
	      }
	    }
	    return success;
	  };
	
	  return Instafeed;
	}));


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(36);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _gsap = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * SiteSwitcher functionality.
	 * @author Dayne Coulson-Hoffacker
	 */
	var SiteSwitcher =
	/**
	 * Constructs a new PageIntroduction instance.
	 * @param {Object} options - Options.
	 * @param {HTMLElement} options.element - Container.
	 */
	function SiteSwitcher(options) {
	  (0, _classCallCheck3.default)(this, SiteSwitcher);
	
	  this.element = options.element;
	  this.link = this.element.querySelector('a');
	
	  // // MakeWorkshop Timeline
	  var mwTimeline = _gsap.gsap.timeline({ repeat: 0, repeatDelay: 0, paused: true });
	  mwTimeline.to("[data-component='mw-transition']", { duration: 1, x: 0, y: 0, ease: "expo.out" });
	  mwTimeline.to("[data-component='mw-transition'] svg", { duration: 0.8, opacity: 1 }, "+=0.5");
	  mwTimeline.to("[data-component='mw-transition'] #rotate", { rotation: 180, transformOrigin: '50% 31px', ease: "expo.out", duration: 1.5 }, "+=0.5");
	
	  this.link.addEventListener('click', function (event) {
	    event.preventDefault();
	    if (document.body.classList.contains('make-workshop')) {
	      mmTimeline.play();
	    } else {
	      mwTimeline.play();
	    }
	  });
	};
	
	exports.default = SiteSwitcher;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(36);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _smoothScroll = __webpack_require__(37);
	
	var _smoothScroll2 = _interopRequireDefault(_smoothScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A section that can be scrolled to via URL hash.
	 * @author Dayne Coulson-Hoffacker
	 */
	var GlobalFooter =
	/**
	 * Constructs a new GlobalFooter section instance.
	 * @param {Object} options - Options.
	 * @param {HTMLElement} options.element - Container.
	 * @param {Hurdler} options.hurdler - Hurdler instance.
	 */
	function GlobalFooter(options) {
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, GlobalFooter);
	
	  this.element = options.element;
	  this.footerLogo = this.element.querySelector('.mm-logo');
	  this.scroll = new _smoothScroll2.default();
	  this.scrollOptions = {
	    speed: 500,
	    speedAsDuration: true,
	    updateURL: false
	  };
	
	  this.footerLogo.addEventListener('click', function () {
	    _this.scroll.animateScroll(0);
	  });
	};
	
	exports.default = GlobalFooter;

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js